{
  "acts": {
    "engine-v10-010eaa2e62ff4030": {
      "instrument_id": "lk-act-2025-26",
      "sha256": "010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 26 OF 2025"
    },
    "engine-v10-038fce99adb29b52": {
      "instrument_id": "lk-act-2018-35",
      "sha256": "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7",
      "title": "FINANCE ACT, No. 35 OF 2018"
    },
    "engine-v10-08303ae9f5fa3082": {
      "instrument_id": "lk-act-2018-12",
      "sha256": "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 12 OF 2018"
    },
    "engine-v10-0a2e020ab1a01498": {
      "instrument_id": "lk-act-2017-14",
      "sha256": "0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY (AMENDMENT) ACT, No. 14 OF 2017"
    },
    "engine-v10-0d908137412311ad": {
      "instrument_id": "lk-act-2019-20",
      "sha256": "9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2019"
    },
    "engine-v10-10df115f0c104eef": {
      "instrument_id": "lk-act-2016-4",
      "sha256": "10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 4 OF 2016"
    },
    "engine-v10-11defaa0f2254736": {
      "instrument_id": "lk-act-2006-12",
      "sha256": "11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) ACT, No. 12 OF 2006"
    },
    "engine-v10-15a38c5892d864b3": {
      "instrument_id": "lk-act-2013-8",
      "sha256": "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 8 OF 2013"
    },
    "engine-v10-177df77d8625abca": {
      "instrument_id": "lk-act-2024-15",
      "sha256": "64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2024"
    },
    "engine-v10-1bbd3c02b957c261": {
      "instrument_id": "lk-act-2025-24",
      "sha256": "5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 24 OF 2025"
    },
    "engine-v10-1c611f654f4d2029": {
      "instrument_id": "lk-act-2013-3",
      "sha256": "1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 3 OF 2013"
    },
    "engine-v10-24045391b4ecbcd3": {
      "instrument_id": "lk-act-2008-14",
      "sha256": "24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470",
      "title": "STRATEGIC DEVELOPMENT PROJECTS ACT, No. 14 OF 2008"
    },
    "engine-v10-24e8fa6345a290f4": {
      "instrument_id": "lk-act-2011-12",
      "sha256": "24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 12 OF 2011"
    },
    "engine-v10-283e1252ff238d03": {
      "instrument_id": "lk-act-2008-10",
      "sha256": "283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 10 OF 2008"
    },
    "engine-v10-2c83dc5b0edbf1e8": {
      "instrument_id": "lk-act-2022-6",
      "sha256": "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) (AMENDMENT) ACT, No. 6 OF 2022"
    },
    "engine-v10-2cec4c3f6fea90c0": {
      "instrument_id": "lk-act-2017-3",
      "sha256": "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 3 OF 2017"
    },
    "engine-v10-340852bc820f0054": {
      "instrument_id": "lk-act-2013-16",
      "sha256": "340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 16 OF 2013"
    },
    "engine-v10-3706ee7993257c74": {
      "instrument_id": "lk-act-2007-55",
      "sha256": "3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) ACT, No. 55 OF 2007"
    },
    "engine-v10-3ad87b14401803d4": {
      "instrument_id": "lk-act-2021-16",
      "sha256": "9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 16 OF 2021"
    },
    "engine-v10-3c899d6dad3585c8": {
      "instrument_id": "lk-act-2010-14",
      "sha256": "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558",
      "title": "CIVIL AVIATION ACT, No. 14 OF 2010"
    },
    "engine-v10-3d8d0dc5d494c5ed": {
      "instrument_id": "lk-act-2016-21",
      "sha256": "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 21 OF 2016"
    },
    "engine-v10-3e6289785b5d2ace": {
      "instrument_id": "lk-act-2025-11",
      "sha256": "f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 11 OF 2025"
    },
    "engine-v10-4041a8ef167eb084": {
      "instrument_id": "lk-act-2011-13",
      "sha256": "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) ACT, No. 13 OF 2011"
    },
    "engine-v10-418781f54cdfd082": {
      "instrument_id": "lk-act-2013-5",
      "sha256": "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2013"
    },
    "engine-v10-43e8c4dc7e4ca1a3": {
      "instrument_id": "lk-act-2014-10",
      "sha256": "fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2014"
    },
    "engine-v10-48e79ad5c5ebdff5": {
      "instrument_id": "lk-act-1999-54",
      "sha256": "48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7",
      "title": "RANA VIRU SEVA AUTHORITY ACT, No. 54 OF 1999"
    },
    "engine-v10-4ff365ba7583281e": {
      "instrument_id": "lk-act-2016-3",
      "sha256": "357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS ACT, No. 3 OF 2016"
    },
    "engine-v10-52d986f40394d4c4": {
      "instrument_id": "lk-act-2017-9",
      "sha256": "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) (AMENDMENT) ACT, No. 9 OF 2017"
    },
    "engine-v10-540977e80ed06d0c": {
      "instrument_id": "lk-act-2011-10",
      "sha256": "902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2011"
    },
    "engine-v10-55de35382c0b1fd0": {
      "instrument_id": "lk-act-2012-20",
      "sha256": "55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 20 OF 2012"
    },
    "engine-v10-5604933fce046827": {
      "instrument_id": "lk-act-2017-13",
      "sha256": "03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 13 OF 2017"
    },
    "engine-v10-565a4f3edcbaec3d": {
      "instrument_id": "lk-act-2003-27",
      "sha256": "565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY ACT, No. 27 OF 2003"
    },
    "engine-v10-581d20f6abcc200b": {
      "instrument_id": "lk-act-1999-17",
      "sha256": "581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY ACT, No. 17 OF 1999"
    },
    "engine-v10-616ac68a0a7889f1": {
      "instrument_id": "lk-act-2020-5",
      "sha256": "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2020"
    },
    "engine-v10-627abbb7b65581a2": {
      "instrument_id": "lk-act-2013-10",
      "sha256": "627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd",
      "title": "RESETTLEMENT AUTHORITY (AMENDMENT) ACT, No. 10 OF 2013"
    },
    "engine-v10-6617b32ac9f373cc": {
      "instrument_id": "lk-act-2011-21",
      "sha256": "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117",
      "title": "TELECOMMUNICATION LEVY ACT, No. 21 OF 2011"
    },
    "engine-v10-67a43366df903e38": {
      "instrument_id": "lk-act-2012-13",
      "sha256": "67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 13 OF 2012"
    },
    "engine-v10-738cfe3bea7f3f93": {
      "instrument_id": "lk-act-2006-17",
      "sha256": "738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY ACT, No. 17 OF 2006"
    },
    "engine-v10-749a9d200f6b438d": {
      "instrument_id": "lk-act-2005-36",
      "sha256": "749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 36 OF 2005"
    },
    "engine-v10-7603f6d11a7efe52": {
      "instrument_id": "lk-act-2013-20",
      "sha256": "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, No. 20 OF 2013"
    },
    "engine-v10-7c5287361c3de3d1": {
      "instrument_id": "lk-act-2018-29",
      "sha256": "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288",
      "title": "CARRIAGE BY AIR ACT, No. 29 OF 2018"
    },
    "engine-v10-7c65a1d9b54f8188": {
      "instrument_id": "lk-act-2013-29",
      "sha256": "7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 29 OF 2013"
    },
    "engine-v10-7de4ec283f8bc6bf": {
      "instrument_id": "lk-act-2022-25",
      "sha256": "6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY ACT, No. 25 OF 2022"
    },
    "engine-v10-82a9bf4bbcf40c3b": {
      "instrument_id": "lk-act-2007-48",
      "sha256": "82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155",
      "title": "SPECIAL COMMODITY LEVY ACT, No. 48 OF 2007"
    },
    "engine-v10-8710db26120aeab6": {
      "instrument_id": "lk-act-2008-5",
      "sha256": "8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2",
      "title": "DEFENCE SERVICES COlVIMAND AND STAFF COLLEGE ACT, No. 5 OF 2008"
    },
    "engine-v10-8788c9db433b33a7": {
      "instrument_id": "lk-act-2003-35",
      "sha256": "8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN ACT, No. 35 OF 2003"
    },
    "engine-v10-8dab62f83f4c88f4": {
      "instrument_id": "lk-act-2015-12",
      "sha256": "46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 12 OF 2015"
    },
    "engine-v10-954bf58b4d319712": {
      "instrument_id": "lk-act-2023-24",
      "sha256": "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 24 OF 2023"
    },
    "engine-v10-9afda3b1ee76364d": {
      "instrument_id": "lk-act-2008-12",
      "sha256": "9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 12 OF 2008"
    },
    "engine-v10-9b5df559fd4f729f": {
      "instrument_id": "lk-act-2012-12",
      "sha256": "9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3",
      "title": "FINANCE ACT, No. 12 OF 2012"
    },
    "engine-v10-9c6a86c5e7eeb01c": {
      "instrument_id": "lk-act-2012-4",
      "sha256": "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, NO. 4 OF 2012"
    },
    "engine-v10-9f7a25495e980023": {
      "instrument_id": "lk-act-2011-18",
      "sha256": "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY ACT, No. 18 OF 2011"
    },
    "engine-v10-a05af5a077184a5f": {
      "instrument_id": "lk-act-2022-27",
      "sha256": "a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 27 OF 2022"
    },
    "engine-v10-a3b3e391565b11ad": {
      "instrument_id": "lk-act-2012-10",
      "sha256": "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 10 OF 2012"
    },
    "engine-v10-a46c7fda815b7525": {
      "instrument_id": "lk-act-2009-6",
      "sha256": "a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN (AMENDMENT) ACT, No. 6 OF 2009"
    },
    "engine-v10-a7805df36ec051e9": {
      "instrument_id": "lk-act-2016-14",
      "sha256": "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) ACT, No. 14 OF 2016"
    },
    "engine-v10-a98839990788e066": {
      "instrument_id": "lk-act-2011-23",
      "sha256": "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2",
      "title": "TAX APPEALS COMMISSION ACT, No. 23 OF 2011"
    },
    "engine-v10-af71306c92055221": {
      "instrument_id": "lk-act-2014-12",
      "sha256": "af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b",
      "title": "SPECIAL COMMODITY LEVY (AMENDMENT) ACT, No. 12 OF 2014"
    },
    "engine-v10-af956197361b1759": {
      "instrument_id": "lk-act-2019-21",
      "sha256": "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb",
      "title": "FINANCE ACT, No. 21 OF 2019"
    },
    "engine-v10-b2df76a65c2d47ba": {
      "instrument_id": "lk-act-2023-33",
      "sha256": "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b",
      "title": "FINANCE ACT, No. 33 OF 2023"
    },
    "engine-v10-b6a34344daa596f1": {
      "instrument_id": "lk-act-2009-32",
      "sha256": "0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 32 OF 2009"
    },
    "engine-v10-b85b87f48cd5826a": {
      "instrument_id": "lk-act-2023-8",
      "sha256": "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610",
      "title": "CARRIAGE BY AIR (AMENDMENT) ACT, No. 8 OF 2023"
    },
    "engine-v10-b8cdc6d11c2f4445": {
      "instrument_id": "lk-act-2009-9",
      "sha256": "1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56",
      "title": "NATION BUILDING TAX ACT, NO. 9 OF 2009"
    },
    "engine-v10-bbcc48aefa8b7821": {
      "instrument_id": "lk-act-2006-51",
      "sha256": "bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY ACT, NO. 51 OF 2006"
    },
    "engine-v10-bcea2bdb1dab3d9a": {
      "instrument_id": "lk-act-2023-15",
      "sha256": "f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2023"
    },
    "engine-v10-bf58648b0725d7a6": {
      "instrument_id": "lk-act-2013-12",
      "sha256": "bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e",
      "title": "FINANCE ACT, No. 12 OF 2013"
    },
    "engine-v10-c76b30a6c00f7c88": {
      "instrument_id": "lk-act-2009-7",
      "sha256": "c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 7 OF 2009"
    },
    "engine-v10-cac167d4a6c44875": {
      "instrument_id": "lk-act-2009-30",
      "sha256": "cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) (AMENDMENT) ACT, NO. 30 OF 2009"
    },
    "engine-v10-cdc3d36908929a0a": {
      "instrument_id": "lk-act-2014-38",
      "sha256": "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57",
      "title": "LAND (RESTRICTIONS ON ALIENATION) ACT, No. 38 OF 2014"
    },
    "engine-v10-d0919c7e899414c7": {
      "instrument_id": "lk-act-2026-10",
      "sha256": "5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 10 OF 2026"
    },
    "engine-v10-d48b9922872a1b5d": {
      "instrument_id": "lk-act-2020-2",
      "sha256": "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c",
      "title": "FINANCE (AMENDMENT) ACT, No. 2 OF 2020"
    },
    "engine-v10-d55bbb7be0bd4556": {
      "instrument_id": "lk-act-2002-33",
      "sha256": "d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) ACT, No. 33 OF 2002"
    },
    "engine-v10-d5655884e7890ad4": {
      "instrument_id": "lk-act-2011-41",
      "sha256": "d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 41 OF 2011"
    },
    "engine-v10-d642e2c2ccc797a3": {
      "instrument_id": "lk-act-2005-25",
      "sha256": "d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING ACT, No. 25 OF 2005"
    },
    "engine-v10-dd75ecf4f046bb27": {
      "instrument_id": "lk-act-2007-9",
      "sha256": "dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db",
      "title": "RESETTLEMENT AUTHORITY ACT, NO. 09 OF 2007"
    },
    "engine-v10-e07930075fecb0c6": {
      "instrument_id": "lk-act-2025-10",
      "sha256": "e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 10 OF 2025"
    },
    "engine-v10-e5c66a5c29d64edb": {
      "instrument_id": "lk-act-2012-9",
      "sha256": "917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT. No. 9 OF 2012"
    },
    "engine-v10-e9c25a8a1864ff0f": {
      "instrument_id": "lk-act-2014-11",
      "sha256": "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 11 OF 2014"
    },
    "engine-v10-e9c4c4a58ccd7a26": {
      "instrument_id": "lk-act-2016-22",
      "sha256": "5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 22 OF 2016"
    },
    "engine-v10-e9df7c60d5594c5d": {
      "instrument_id": "lk-act-2013-11",
      "sha256": "d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 11 OF 2013"
    },
    "engine-v10-ea252d114e78e690": {
      "instrument_id": "lk-act-2018-20",
      "sha256": "0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2018"
    },
    "engine-v10-ee4575005a7a4d00": {
      "instrument_id": "lk-act-2025-9",
      "sha256": "ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 9 OF 2025"
    },
    "engine-v10-f0bd7e658e651246": {
      "instrument_id": "lk-act-2018-21",
      "sha256": "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 21 OF 2018"
    },
    "engine-v10-f4f8e9bda1d04084": {
      "instrument_id": "lk-act-2007-47",
      "sha256": "f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 47 OF 2007"
    },
    "engine-v10-f6238c841da14718": {
      "instrument_id": "lk-act-2020-3",
      "sha256": "ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 3 OF 2020"
    },
    "engine-v10-f64704a9df6e8c40": {
      "instrument_id": "lk-act-2014-18",
      "sha256": "f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY (AMENDMENT) ACT, No. 18 OF 2014"
    },
    "engine-v10-fb74b60e8c0dbccd": {
      "instrument_id": "lk-act-2008-33",
      "sha256": "fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY (AMENDMENT) ACT, No. 33 OF 2008"
    },
    "engine-v11-010eaa2e62ff4030": {
      "instrument_id": "lk-act-2025-26",
      "sha256": "010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 26 OF 2025"
    },
    "engine-v11-020691ed319c4e1b": {
      "instrument_id": "lk-act-2004-11",
      "sha256": "020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe",
      "title": "FINANCE ACT, No. 11 OF 2004"
    },
    "engine-v11-038fce99adb29b52": {
      "instrument_id": "lk-act-2018-35",
      "sha256": "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7",
      "title": "FINANCE ACT, No. 35 OF 2018"
    },
    "engine-v11-0484e30bd9beee74": {
      "instrument_id": "lk-act-2017-7",
      "sha256": "0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 7 OF 2017"
    },
    "engine-v11-06838282e43ff13b": {
      "instrument_id": "lk-act-1999-8",
      "sha256": "06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e",
      "title": "TOBACCO TAX ACT, No. 08 OF 1999"
    },
    "engine-v11-08303ae9f5fa3082": {
      "instrument_id": "lk-act-2018-12",
      "sha256": "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 12 OF 2018"
    },
    "engine-v11-0a2e020ab1a01498": {
      "instrument_id": "lk-act-2017-14",
      "sha256": "0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY (AMENDMENT) ACT, No. 14 OF 2017"
    },
    "engine-v11-0d908137412311ad": {
      "instrument_id": "lk-act-2019-20",
      "sha256": "9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2019"
    },
    "engine-v11-10df115f0c104eef": {
      "instrument_id": "lk-act-2016-4",
      "sha256": "10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 4 OF 2016"
    },
    "engine-v11-11defaa0f2254736": {
      "instrument_id": "lk-act-2006-12",
      "sha256": "11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) ACT, No. 12 OF 2006"
    },
    "engine-v11-15a38c5892d864b3": {
      "instrument_id": "lk-act-2013-8",
      "sha256": "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 8 OF 2013"
    },
    "engine-v11-177df77d8625abca": {
      "instrument_id": "lk-act-2024-15",
      "sha256": "64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2024"
    },
    "engine-v11-17d2d1d251a59b67": {
      "instrument_id": "lk-act-2007-13",
      "sha256": "17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f",
      "title": "FINANCE (AMENDMENT) ACT, No. 13 OF 2007"
    },
    "engine-v11-1bbd3c02b957c261": {
      "instrument_id": "lk-act-2025-24",
      "sha256": "5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 24 OF 2025"
    },
    "engine-v11-1c611f654f4d2029": {
      "instrument_id": "lk-act-2013-3",
      "sha256": "1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 3 OF 2013"
    },
    "engine-v11-24045391b4ecbcd3": {
      "instrument_id": "lk-act-2008-14",
      "sha256": "24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470",
      "title": "STRATEGIC DEVELOPMENT PROJECTS ACT, No. 14 OF 2008"
    },
    "engine-v11-24e8fa6345a290f4": {
      "instrument_id": "lk-act-2011-12",
      "sha256": "24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 12 OF 2011"
    },
    "engine-v11-283e1252ff238d03": {
      "instrument_id": "lk-act-2008-10",
      "sha256": "283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 10 OF 2008"
    },
    "engine-v11-28acaf68eae337aa": {
      "instrument_id": "lk-act-2014-9",
      "sha256": "28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 9 OF 2014"
    },
    "engine-v11-2b840f450fcd0d65": {
      "instrument_id": "lk-act-2016-13",
      "sha256": "2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 13 OF 2016"
    },
    "engine-v11-2c83dc5b0edbf1e8": {
      "instrument_id": "lk-act-2022-6",
      "sha256": "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) (AMENDMENT) ACT, No. 6 OF 2022"
    },
    "engine-v11-2cec4c3f6fea90c0": {
      "instrument_id": "lk-act-2017-3",
      "sha256": "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 3 OF 2017"
    },
    "engine-v11-2fab47e1fd8d4922": {
      "instrument_id": "lk-act-2015-13",
      "sha256": "2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 13 OF 2015"
    },
    "engine-v11-340852bc820f0054": {
      "instrument_id": "lk-act-2013-16",
      "sha256": "340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 16 OF 2013"
    },
    "engine-v11-3706ee7993257c74": {
      "instrument_id": "lk-act-2007-55",
      "sha256": "3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) ACT, No. 55 OF 2007"
    },
    "engine-v11-386743ac371b1e75": {
      "instrument_id": "lk-act-2005-7",
      "sha256": "386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2005"
    },
    "engine-v11-3ad87b14401803d4": {
      "instrument_id": "lk-act-2021-16",
      "sha256": "9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 16 OF 2021"
    },
    "engine-v11-3c899d6dad3585c8": {
      "instrument_id": "lk-act-2010-14",
      "sha256": "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558",
      "title": "CIVIL AVIATION ACT, No. 14 OF 2010"
    },
    "engine-v11-3d8d0dc5d494c5ed": {
      "instrument_id": "lk-act-2016-21",
      "sha256": "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 21 OF 2016"
    },
    "engine-v11-3e6289785b5d2ace": {
      "instrument_id": "lk-act-2025-11",
      "sha256": "f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 11 OF 2025"
    },
    "engine-v11-4041a8ef167eb084": {
      "instrument_id": "lk-act-2011-13",
      "sha256": "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) ACT, No. 13 OF 2011"
    },
    "engine-v11-418781f54cdfd082": {
      "instrument_id": "lk-act-2013-5",
      "sha256": "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2013"
    },
    "engine-v11-43e8c4dc7e4ca1a3": {
      "instrument_id": "lk-act-2014-10",
      "sha256": "fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2014"
    },
    "engine-v11-47c9fe736e85ea10": {
      "instrument_id": "lk-act-2011-15",
      "sha256": "47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045",
      "title": "FINANCE (AMENDMENT) ACT, No. 15 OF 2011"
    },
    "engine-v11-48e79ad5c5ebdff5": {
      "instrument_id": "lk-act-1999-54",
      "sha256": "48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7",
      "title": "RANA VIRU SEVA AUTHORITY ACT, No. 54 OF 1999"
    },
    "engine-v11-4f2fcade80a8b194": {
      "instrument_id": "lk-act-2018-33",
      "sha256": "4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 33 OF 2018"
    },
    "engine-v11-4ff365ba7583281e": {
      "instrument_id": "lk-act-2016-3",
      "sha256": "357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS ACT, No. 3 OF 2016"
    },
    "engine-v11-505c9b943b0a883a": {
      "instrument_id": "lk-act-2009-18",
      "sha256": "505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e",
      "title": "FINANCE (AMENDMENT) ACT, NO. 18 OF 2009"
    },
    "engine-v11-52056495ca84b30f": {
      "instrument_id": "lk-act-2020-4",
      "sha256": "52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 4 OF 2020"
    },
    "engine-v11-52d986f40394d4c4": {
      "instrument_id": "lk-act-2017-9",
      "sha256": "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) (AMENDMENT) ACT, No. 9 OF 2017"
    },
    "engine-v11-540977e80ed06d0c": {
      "instrument_id": "lk-act-2011-10",
      "sha256": "902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2011"
    },
    "engine-v11-5470e4359f0e6f4b": {
      "instrument_id": "lk-act-2005-5",
      "sha256": "5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e",
      "title": "FINANCE ACT, No. 5 OF 2005"
    },
    "engine-v11-54d614a9a98dcdde": {
      "instrument_id": "lk-act-2013-15",
      "sha256": "54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 15 OF 2013"
    },
    "engine-v11-55de35382c0b1fd0": {
      "instrument_id": "lk-act-2012-20",
      "sha256": "55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 20 OF 2012"
    },
    "engine-v11-5604933fce046827": {
      "instrument_id": "lk-act-2017-13",
      "sha256": "03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 13 OF 2017"
    },
    "engine-v11-565a4f3edcbaec3d": {
      "instrument_id": "lk-act-2003-27",
      "sha256": "565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY ACT, No. 27 OF 2003"
    },
    "engine-v11-581d20f6abcc200b": {
      "instrument_id": "lk-act-1999-17",
      "sha256": "581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY ACT, No. 17 OF 1999"
    },
    "engine-v11-616ac68a0a7889f1": {
      "instrument_id": "lk-act-2020-5",
      "sha256": "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2020"
    },
    "engine-v11-627abbb7b65581a2": {
      "instrument_id": "lk-act-2013-10",
      "sha256": "627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd",
      "title": "RESETTLEMENT AUTHORITY (AMENDMENT) ACT, No. 10 OF 2013"
    },
    "engine-v11-63dbc7faff9ae200": {
      "instrument_id": "lk-act-2011-11",
      "sha256": "63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2011"
    },
    "engine-v11-65ca8020951f93cd": {
      "instrument_id": "lk-act-2007-15",
      "sha256": "65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 15 OF 2007"
    },
    "engine-v11-6617b32ac9f373cc": {
      "instrument_id": "lk-act-2011-21",
      "sha256": "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117",
      "title": "TELECOMMUNICATION LEVY ACT, No. 21 OF 2011"
    },
    "engine-v11-67a43366df903e38": {
      "instrument_id": "lk-act-2012-13",
      "sha256": "67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 13 OF 2012"
    },
    "engine-v11-6aecc8d3e0a62312": {
      "instrument_id": "lk-act-2003-3",
      "sha256": "6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) ACT, No. 3 OF 2003"
    },
    "engine-v11-6b75e3d7ebe56d2c": {
      "instrument_id": "lk-act-2012-11",
      "sha256": "6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2012"
    },
    "engine-v11-726b6e86023ab900": {
      "instrument_id": "lk-act-2009-13",
      "sha256": "726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50",
      "title": "FINANCE (AMENDMENT) ACT, NO. 13 OF 2009"
    },
    "engine-v11-738cfe3bea7f3f93": {
      "instrument_id": "lk-act-2006-17",
      "sha256": "738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY ACT, No. 17 OF 2006"
    },
    "engine-v11-749a9d200f6b438d": {
      "instrument_id": "lk-act-2005-36",
      "sha256": "749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 36 OF 2005"
    },
    "engine-v11-7603f6d11a7efe52": {
      "instrument_id": "lk-act-2013-20",
      "sha256": "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, No. 20 OF 2013"
    },
    "engine-v11-7c5287361c3de3d1": {
      "instrument_id": "lk-act-2018-29",
      "sha256": "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288",
      "title": "CARRIAGE BY AIR ACT, No. 29 OF 2018"
    },
    "engine-v11-7c65a1d9b54f8188": {
      "instrument_id": "lk-act-2013-29",
      "sha256": "7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 29 OF 2013"
    },
    "engine-v11-7de4ec283f8bc6bf": {
      "instrument_id": "lk-act-2022-25",
      "sha256": "6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY ACT, No. 25 OF 2022"
    },
    "engine-v11-815b132e5eab9c93": {
      "instrument_id": "lk-act-2013-6",
      "sha256": "815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 6 OF 2013"
    },
    "engine-v11-82a9bf4bbcf40c3b": {
      "instrument_id": "lk-act-2007-48",
      "sha256": "82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155",
      "title": "SPECIAL COMMODITY LEVY ACT, No. 48 OF 2007"
    },
    "engine-v11-8316b2609f3b2de5": {
      "instrument_id": "lk-act-2006-11",
      "sha256": "8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376",
      "title": "FINANCE ACT, No. 11 OF 2006"
    },
    "engine-v11-8710db26120aeab6": {
      "instrument_id": "lk-act-2008-5",
      "sha256": "8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2",
      "title": "DEFENCE SERVICES COlVIMAND AND STAFF COLLEGE ACT, No. 5 OF 2008"
    },
    "engine-v11-8788c9db433b33a7": {
      "instrument_id": "lk-act-2003-35",
      "sha256": "8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN ACT, No. 35 OF 2003"
    },
    "engine-v11-8dab62f83f4c88f4": {
      "instrument_id": "lk-act-2015-12",
      "sha256": "46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 12 OF 2015"
    },
    "engine-v11-954bf58b4d319712": {
      "instrument_id": "lk-act-2023-24",
      "sha256": "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 24 OF 2023"
    },
    "engine-v11-9afda3b1ee76364d": {
      "instrument_id": "lk-act-2008-12",
      "sha256": "9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 12 OF 2008"
    },
    "engine-v11-9b5df559fd4f729f": {
      "instrument_id": "lk-act-2012-12",
      "sha256": "9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3",
      "title": "FINANCE ACT, No. 12 OF 2012"
    },
    "engine-v11-9c193a8aa321127f": {
      "instrument_id": "lk-act-2009-16",
      "sha256": "9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, NO. 16 OF 2009"
    },
    "engine-v11-9c6a86c5e7eeb01c": {
      "instrument_id": "lk-act-2012-4",
      "sha256": "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, NO. 4 OF 2012"
    },
    "engine-v11-9f7a25495e980023": {
      "instrument_id": "lk-act-2011-18",
      "sha256": "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY ACT, No. 18 OF 2011"
    },
    "engine-v11-a05af5a077184a5f": {
      "instrument_id": "lk-act-2022-27",
      "sha256": "a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 27 OF 2022"
    },
    "engine-v11-a3b3e391565b11ad": {
      "instrument_id": "lk-act-2012-10",
      "sha256": "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 10 OF 2012"
    },
    "engine-v11-a46c7fda815b7525": {
      "instrument_id": "lk-act-2009-6",
      "sha256": "a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN (AMENDMENT) ACT, No. 6 OF 2009"
    },
    "engine-v11-a74b43534cfef9da": {
      "instrument_id": "lk-act-2004-9",
      "sha256": "a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f",
      "title": "TOBACCO TAX (AMENDMENT) ACT, No. 9 OF 2004"
    },
    "engine-v11-a7805df36ec051e9": {
      "instrument_id": "lk-act-2016-14",
      "sha256": "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) ACT, No. 14 OF 2016"
    },
    "engine-v11-a98839990788e066": {
      "instrument_id": "lk-act-2011-23",
      "sha256": "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2",
      "title": "TAX APPEALS COMMISSION ACT, No. 23 OF 2011"
    },
    "engine-v11-af71306c92055221": {
      "instrument_id": "lk-act-2014-12",
      "sha256": "af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b",
      "title": "SPECIAL COMMODITY LEVY (AMENDMENT) ACT, No. 12 OF 2014"
    },
    "engine-v11-af956197361b1759": {
      "instrument_id": "lk-act-2019-21",
      "sha256": "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb",
      "title": "FINANCE ACT, No. 21 OF 2019"
    },
    "engine-v11-afc60811205dc516": {
      "instrument_id": "lk-act-2007-37",
      "sha256": "afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa",
      "title": "FINANCE (AMENDMENT) ACT, No. 37 OF 2007"
    },
    "engine-v11-b2df76a65c2d47ba": {
      "instrument_id": "lk-act-2023-33",
      "sha256": "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b",
      "title": "FINANCE ACT, No. 33 OF 2023"
    },
    "engine-v11-b6a34344daa596f1": {
      "instrument_id": "lk-act-2009-32",
      "sha256": "0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 32 OF 2009"
    },
    "engine-v11-b85b87f48cd5826a": {
      "instrument_id": "lk-act-2023-8",
      "sha256": "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610",
      "title": "CARRIAGE BY AIR (AMENDMENT) ACT, No. 8 OF 2023"
    },
    "engine-v11-b8cdc6d11c2f4445": {
      "instrument_id": "lk-act-2009-9",
      "sha256": "1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56",
      "title": "NATION BUILDING TAX ACT, NO. 9 OF 2009"
    },
    "engine-v11-bbcc48aefa8b7821": {
      "instrument_id": "lk-act-2006-51",
      "sha256": "bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY ACT, NO. 51 OF 2006"
    },
    "engine-v11-bcea2bdb1dab3d9a": {
      "instrument_id": "lk-act-2023-15",
      "sha256": "f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2023"
    },
    "engine-v11-bf58648b0725d7a6": {
      "instrument_id": "lk-act-2013-12",
      "sha256": "bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e",
      "title": "FINANCE ACT, No. 12 OF 2013"
    },
    "engine-v11-c65bfaf8558fda4a": {
      "instrument_id": "lk-act-2006-13",
      "sha256": "c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d",
      "title": "ECONOMIC SERVICE CHARGE ACT, No. 13 OF 2006"
    },
    "engine-v11-c76b30a6c00f7c88": {
      "instrument_id": "lk-act-2009-7",
      "sha256": "c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 7 OF 2009"
    },
    "engine-v11-cac167d4a6c44875": {
      "instrument_id": "lk-act-2009-30",
      "sha256": "cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) (AMENDMENT) ACT, NO. 30 OF 2009"
    },
    "engine-v11-cdc3d36908929a0a": {
      "instrument_id": "lk-act-2014-38",
      "sha256": "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57",
      "title": "LAND (RESTRICTIONS ON ALIENATION) ACT, No. 38 OF 2014"
    },
    "engine-v11-d0919c7e899414c7": {
      "instrument_id": "lk-act-2026-10",
      "sha256": "5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 10 OF 2026"
    },
    "engine-v11-d34778de42b67646": {
      "instrument_id": "lk-act-2008-7",
      "sha256": "d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2008"
    },
    "engine-v11-d48b9922872a1b5d": {
      "instrument_id": "lk-act-2020-2",
      "sha256": "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c",
      "title": "FINANCE (AMENDMENT) ACT, No. 2 OF 2020"
    },
    "engine-v11-d55bbb7be0bd4556": {
      "instrument_id": "lk-act-2002-33",
      "sha256": "d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) ACT, No. 33 OF 2002"
    },
    "engine-v11-d5655884e7890ad4": {
      "instrument_id": "lk-act-2011-41",
      "sha256": "d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 41 OF 2011"
    },
    "engine-v11-d642e2c2ccc797a3": {
      "instrument_id": "lk-act-2005-25",
      "sha256": "d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING ACT, No. 25 OF 2005"
    },
    "engine-v11-dcda00b6755405a0": {
      "instrument_id": "lk-act-2021-12",
      "sha256": "dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 12 OF 2021"
    },
    "engine-v11-dd75ecf4f046bb27": {
      "instrument_id": "lk-act-2007-9",
      "sha256": "dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db",
      "title": "RESETTLEMENT AUTHORITY ACT, NO. 09 OF 2007"
    },
    "engine-v11-e07930075fecb0c6": {
      "instrument_id": "lk-act-2025-10",
      "sha256": "e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 10 OF 2025"
    },
    "engine-v11-e1f6da4e727adb53": {
      "instrument_id": "lk-act-2008-8",
      "sha256": "e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb",
      "title": "FINANCE (AMENDMENT) ACT, No. 8 OF 2008"
    },
    "engine-v11-e5c66a5c29d64edb": {
      "instrument_id": "lk-act-2012-9",
      "sha256": "917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT. No. 9 OF 2012"
    },
    "engine-v11-e9c25a8a1864ff0f": {
      "instrument_id": "lk-act-2014-11",
      "sha256": "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 11 OF 2014"
    },
    "engine-v11-e9c4c4a58ccd7a26": {
      "instrument_id": "lk-act-2016-22",
      "sha256": "5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 22 OF 2016"
    },
    "engine-v11-e9df7c60d5594c5d": {
      "instrument_id": "lk-act-2013-11",
      "sha256": "d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 11 OF 2013"
    },
    "engine-v11-ea155b19391a469d": {
      "instrument_id": "lk-act-2008-11",
      "sha256": "ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2008"
    },
    "engine-v11-ea252d114e78e690": {
      "instrument_id": "lk-act-2018-20",
      "sha256": "0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2018"
    },
    "engine-v11-ee4575005a7a4d00": {
      "instrument_id": "lk-act-2025-9",
      "sha256": "ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 9 OF 2025"
    },
    "engine-v11-f0bd7e658e651246": {
      "instrument_id": "lk-act-2018-21",
      "sha256": "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 21 OF 2018"
    },
    "engine-v11-f0e2d86e0272fb15": {
      "instrument_id": "lk-act-2003-25",
      "sha256": "f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3",
      "title": "FINANCE ACT, No. 25 OF 2003"
    },
    "engine-v11-f4f8e9bda1d04084": {
      "instrument_id": "lk-act-2007-47",
      "sha256": "f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 47 OF 2007"
    },
    "engine-v11-f6238c841da14718": {
      "instrument_id": "lk-act-2020-3",
      "sha256": "ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 3 OF 2020"
    },
    "engine-v11-f64704a9df6e8c40": {
      "instrument_id": "lk-act-2014-18",
      "sha256": "f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY (AMENDMENT) ACT, No. 18 OF 2014"
    },
    "engine-v11-fb74b60e8c0dbccd": {
      "instrument_id": "lk-act-2008-33",
      "sha256": "fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY (AMENDMENT) ACT, No. 33 OF 2008"
    },
    "engine-v11-fe1ea4997df06af6": {
      "instrument_id": "lk-act-2007-45",
      "sha256": "fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef",
      "title": "FINANCE (AMENDMENT) ACT, NO. 45 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-010eaa2e62ff4030": {
      "instrument_id": "lk-act-2025-26",
      "sha256": "010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 26 OF 2025"
    },
    "engine-v11-reconciled-4c016154ebbe-020691ed319c4e1b": {
      "instrument_id": "lk-act-2004-11",
      "sha256": "020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe",
      "title": "FINANCE ACT, No. 11 OF 2004"
    },
    "engine-v11-reconciled-4c016154ebbe-038fce99adb29b52": {
      "instrument_id": "lk-act-2018-35",
      "sha256": "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7",
      "title": "FINANCE ACT, No. 35 OF 2018"
    },
    "engine-v11-reconciled-4c016154ebbe-0484e30bd9beee74": {
      "instrument_id": "lk-act-2017-7",
      "sha256": "0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 7 OF 2017"
    },
    "engine-v11-reconciled-4c016154ebbe-06838282e43ff13b": {
      "instrument_id": "lk-act-1999-8",
      "sha256": "06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e",
      "title": "TOBACCO TAX ACT, No. 08 OF 1999"
    },
    "engine-v11-reconciled-4c016154ebbe-08303ae9f5fa3082": {
      "instrument_id": "lk-act-2018-12",
      "sha256": "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 12 OF 2018"
    },
    "engine-v11-reconciled-4c016154ebbe-0a2e020ab1a01498": {
      "instrument_id": "lk-act-2017-14",
      "sha256": "0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY (AMENDMENT) ACT, No. 14 OF 2017"
    },
    "engine-v11-reconciled-4c016154ebbe-0d908137412311ad": {
      "instrument_id": "lk-act-2019-20",
      "sha256": "9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2019"
    },
    "engine-v11-reconciled-4c016154ebbe-10df115f0c104eef": {
      "instrument_id": "lk-act-2016-4",
      "sha256": "10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 4 OF 2016"
    },
    "engine-v11-reconciled-4c016154ebbe-11defaa0f2254736": {
      "instrument_id": "lk-act-2006-12",
      "sha256": "11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) ACT, No. 12 OF 2006"
    },
    "engine-v11-reconciled-4c016154ebbe-15a38c5892d864b3": {
      "instrument_id": "lk-act-2013-8",
      "sha256": "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 8 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-177df77d8625abca": {
      "instrument_id": "lk-act-2024-15",
      "sha256": "64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2024"
    },
    "engine-v11-reconciled-4c016154ebbe-17d2d1d251a59b67": {
      "instrument_id": "lk-act-2007-13",
      "sha256": "17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f",
      "title": "FINANCE (AMENDMENT) ACT, No. 13 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-1bbd3c02b957c261": {
      "instrument_id": "lk-act-2025-24",
      "sha256": "5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 24 OF 2025"
    },
    "engine-v11-reconciled-4c016154ebbe-1c611f654f4d2029": {
      "instrument_id": "lk-act-2013-3",
      "sha256": "1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 3 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-24045391b4ecbcd3": {
      "instrument_id": "lk-act-2008-14",
      "sha256": "24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470",
      "title": "STRATEGIC DEVELOPMENT PROJECTS ACT, No. 14 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-24e8fa6345a290f4": {
      "instrument_id": "lk-act-2011-12",
      "sha256": "24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 12 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-283e1252ff238d03": {
      "instrument_id": "lk-act-2008-10",
      "sha256": "283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 10 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-28acaf68eae337aa": {
      "instrument_id": "lk-act-2014-9",
      "sha256": "28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 9 OF 2014"
    },
    "engine-v11-reconciled-4c016154ebbe-2b840f450fcd0d65": {
      "instrument_id": "lk-act-2016-13",
      "sha256": "2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 13 OF 2016"
    },
    "engine-v11-reconciled-4c016154ebbe-2c83dc5b0edbf1e8": {
      "instrument_id": "lk-act-2022-6",
      "sha256": "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) (AMENDMENT) ACT, No. 6 OF 2022"
    },
    "engine-v11-reconciled-4c016154ebbe-2cec4c3f6fea90c0": {
      "instrument_id": "lk-act-2017-3",
      "sha256": "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 3 OF 2017"
    },
    "engine-v11-reconciled-4c016154ebbe-2fab47e1fd8d4922": {
      "instrument_id": "lk-act-2015-13",
      "sha256": "2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 13 OF 2015"
    },
    "engine-v11-reconciled-4c016154ebbe-340852bc820f0054": {
      "instrument_id": "lk-act-2013-16",
      "sha256": "340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 16 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-3706ee7993257c74": {
      "instrument_id": "lk-act-2007-55",
      "sha256": "3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) ACT, No. 55 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-386743ac371b1e75": {
      "instrument_id": "lk-act-2005-7",
      "sha256": "386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2005"
    },
    "engine-v11-reconciled-4c016154ebbe-3ad87b14401803d4": {
      "instrument_id": "lk-act-2021-16",
      "sha256": "9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 16 OF 2021"
    },
    "engine-v11-reconciled-4c016154ebbe-3c899d6dad3585c8": {
      "instrument_id": "lk-act-2010-14",
      "sha256": "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558",
      "title": "CIVIL AVIATION ACT, No. 14 OF 2010"
    },
    "engine-v11-reconciled-4c016154ebbe-3d8d0dc5d494c5ed": {
      "instrument_id": "lk-act-2016-21",
      "sha256": "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 21 OF 2016"
    },
    "engine-v11-reconciled-4c016154ebbe-3e6289785b5d2ace": {
      "instrument_id": "lk-act-2025-11",
      "sha256": "f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 11 OF 2025"
    },
    "engine-v11-reconciled-4c016154ebbe-4041a8ef167eb084": {
      "instrument_id": "lk-act-2011-13",
      "sha256": "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) ACT, No. 13 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-418781f54cdfd082": {
      "instrument_id": "lk-act-2013-5",
      "sha256": "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-43e8c4dc7e4ca1a3": {
      "instrument_id": "lk-act-2014-10",
      "sha256": "fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2014"
    },
    "engine-v11-reconciled-4c016154ebbe-47c9fe736e85ea10": {
      "instrument_id": "lk-act-2011-15",
      "sha256": "47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045",
      "title": "FINANCE (AMENDMENT) ACT, No. 15 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-48e79ad5c5ebdff5": {
      "instrument_id": "lk-act-1999-54",
      "sha256": "48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7",
      "title": "RANA VIRU SEVA AUTHORITY ACT, No. 54 OF 1999"
    },
    "engine-v11-reconciled-4c016154ebbe-4f2fcade80a8b194": {
      "instrument_id": "lk-act-2018-33",
      "sha256": "4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 33 OF 2018"
    },
    "engine-v11-reconciled-4c016154ebbe-4ff365ba7583281e": {
      "instrument_id": "lk-act-2016-3",
      "sha256": "357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS ACT, No. 3 OF 2016"
    },
    "engine-v11-reconciled-4c016154ebbe-505c9b943b0a883a": {
      "instrument_id": "lk-act-2009-18",
      "sha256": "505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e",
      "title": "FINANCE (AMENDMENT) ACT, NO. 18 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-52056495ca84b30f": {
      "instrument_id": "lk-act-2020-4",
      "sha256": "52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 4 OF 2020"
    },
    "engine-v11-reconciled-4c016154ebbe-52d986f40394d4c4": {
      "instrument_id": "lk-act-2017-9",
      "sha256": "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) (AMENDMENT) ACT, No. 9 OF 2017"
    },
    "engine-v11-reconciled-4c016154ebbe-540977e80ed06d0c": {
      "instrument_id": "lk-act-2011-10",
      "sha256": "902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-5470e4359f0e6f4b": {
      "instrument_id": "lk-act-2005-5",
      "sha256": "5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e",
      "title": "FINANCE ACT, No. 5 OF 2005"
    },
    "engine-v11-reconciled-4c016154ebbe-54d614a9a98dcdde": {
      "instrument_id": "lk-act-2013-15",
      "sha256": "54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 15 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-55de35382c0b1fd0": {
      "instrument_id": "lk-act-2012-20",
      "sha256": "55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 20 OF 2012"
    },
    "engine-v11-reconciled-4c016154ebbe-5604933fce046827": {
      "instrument_id": "lk-act-2017-13",
      "sha256": "03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 13 OF 2017"
    },
    "engine-v11-reconciled-4c016154ebbe-565a4f3edcbaec3d": {
      "instrument_id": "lk-act-2003-27",
      "sha256": "565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY ACT, No. 27 OF 2003"
    },
    "engine-v11-reconciled-4c016154ebbe-581d20f6abcc200b": {
      "instrument_id": "lk-act-1999-17",
      "sha256": "581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY ACT, No. 17 OF 1999"
    },
    "engine-v11-reconciled-4c016154ebbe-616ac68a0a7889f1": {
      "instrument_id": "lk-act-2020-5",
      "sha256": "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2020"
    },
    "engine-v11-reconciled-4c016154ebbe-627abbb7b65581a2": {
      "instrument_id": "lk-act-2013-10",
      "sha256": "627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd",
      "title": "RESETTLEMENT AUTHORITY (AMENDMENT) ACT, No. 10 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-63dbc7faff9ae200": {
      "instrument_id": "lk-act-2011-11",
      "sha256": "63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-65ca8020951f93cd": {
      "instrument_id": "lk-act-2007-15",
      "sha256": "65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 15 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-6617b32ac9f373cc": {
      "instrument_id": "lk-act-2011-21",
      "sha256": "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117",
      "title": "TELECOMMUNICATION LEVY ACT, No. 21 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-67a43366df903e38": {
      "instrument_id": "lk-act-2012-13",
      "sha256": "67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 13 OF 2012"
    },
    "engine-v11-reconciled-4c016154ebbe-6aecc8d3e0a62312": {
      "instrument_id": "lk-act-2003-3",
      "sha256": "6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) ACT, No. 3 OF 2003"
    },
    "engine-v11-reconciled-4c016154ebbe-6b75e3d7ebe56d2c": {
      "instrument_id": "lk-act-2012-11",
      "sha256": "6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2012"
    },
    "engine-v11-reconciled-4c016154ebbe-726b6e86023ab900": {
      "instrument_id": "lk-act-2009-13",
      "sha256": "726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50",
      "title": "FINANCE (AMENDMENT) ACT, NO. 13 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-738cfe3bea7f3f93": {
      "instrument_id": "lk-act-2006-17",
      "sha256": "738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY ACT, No. 17 OF 2006"
    },
    "engine-v11-reconciled-4c016154ebbe-749a9d200f6b438d": {
      "instrument_id": "lk-act-2005-36",
      "sha256": "749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 36 OF 2005"
    },
    "engine-v11-reconciled-4c016154ebbe-7603f6d11a7efe52": {
      "instrument_id": "lk-act-2013-20",
      "sha256": "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, No. 20 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-7c5287361c3de3d1": {
      "instrument_id": "lk-act-2018-29",
      "sha256": "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288",
      "title": "CARRIAGE BY AIR ACT, No. 29 OF 2018"
    },
    "engine-v11-reconciled-4c016154ebbe-7c65a1d9b54f8188": {
      "instrument_id": "lk-act-2013-29",
      "sha256": "7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 29 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-7de4ec283f8bc6bf": {
      "instrument_id": "lk-act-2022-25",
      "sha256": "6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY ACT, No. 25 OF 2022"
    },
    "engine-v11-reconciled-4c016154ebbe-815b132e5eab9c93": {
      "instrument_id": "lk-act-2013-6",
      "sha256": "815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 6 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-82a9bf4bbcf40c3b": {
      "instrument_id": "lk-act-2007-48",
      "sha256": "82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155",
      "title": "SPECIAL COMMODITY LEVY ACT, No. 48 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-8316b2609f3b2de5": {
      "instrument_id": "lk-act-2006-11",
      "sha256": "8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376",
      "title": "FINANCE ACT, No. 11 OF 2006"
    },
    "engine-v11-reconciled-4c016154ebbe-8710db26120aeab6": {
      "instrument_id": "lk-act-2008-5",
      "sha256": "8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2",
      "title": "DEFENCE SERVICES COlVIMAND AND STAFF COLLEGE ACT, No. 5 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-8788c9db433b33a7": {
      "instrument_id": "lk-act-2003-35",
      "sha256": "8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN ACT, No. 35 OF 2003"
    },
    "engine-v11-reconciled-4c016154ebbe-8dab62f83f4c88f4": {
      "instrument_id": "lk-act-2015-12",
      "sha256": "46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 12 OF 2015"
    },
    "engine-v11-reconciled-4c016154ebbe-954bf58b4d319712": {
      "instrument_id": "lk-act-2023-24",
      "sha256": "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 24 OF 2023"
    },
    "engine-v11-reconciled-4c016154ebbe-9afda3b1ee76364d": {
      "instrument_id": "lk-act-2008-12",
      "sha256": "9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 12 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-9b5df559fd4f729f": {
      "instrument_id": "lk-act-2012-12",
      "sha256": "9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3",
      "title": "FINANCE ACT, No. 12 OF 2012"
    },
    "engine-v11-reconciled-4c016154ebbe-9c193a8aa321127f": {
      "instrument_id": "lk-act-2009-16",
      "sha256": "9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, NO. 16 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-9c6a86c5e7eeb01c": {
      "instrument_id": "lk-act-2012-4",
      "sha256": "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, NO. 4 OF 2012"
    },
    "engine-v11-reconciled-4c016154ebbe-9f7a25495e980023": {
      "instrument_id": "lk-act-2011-18",
      "sha256": "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY ACT, No. 18 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-a05af5a077184a5f": {
      "instrument_id": "lk-act-2022-27",
      "sha256": "a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 27 OF 2022"
    },
    "engine-v11-reconciled-4c016154ebbe-a3b3e391565b11ad": {
      "instrument_id": "lk-act-2012-10",
      "sha256": "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 10 OF 2012"
    },
    "engine-v11-reconciled-4c016154ebbe-a46c7fda815b7525": {
      "instrument_id": "lk-act-2009-6",
      "sha256": "a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN (AMENDMENT) ACT, No. 6 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-a74b43534cfef9da": {
      "instrument_id": "lk-act-2004-9",
      "sha256": "a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f",
      "title": "TOBACCO TAX (AMENDMENT) ACT, No. 9 OF 2004"
    },
    "engine-v11-reconciled-4c016154ebbe-a7805df36ec051e9": {
      "instrument_id": "lk-act-2016-14",
      "sha256": "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) ACT, No. 14 OF 2016"
    },
    "engine-v11-reconciled-4c016154ebbe-a98839990788e066": {
      "instrument_id": "lk-act-2011-23",
      "sha256": "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2",
      "title": "TAX APPEALS COMMISSION ACT, No. 23 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-af71306c92055221": {
      "instrument_id": "lk-act-2014-12",
      "sha256": "af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b",
      "title": "SPECIAL COMMODITY LEVY (AMENDMENT) ACT, No. 12 OF 2014"
    },
    "engine-v11-reconciled-4c016154ebbe-af956197361b1759": {
      "instrument_id": "lk-act-2019-21",
      "sha256": "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb",
      "title": "FINANCE ACT, No. 21 OF 2019"
    },
    "engine-v11-reconciled-4c016154ebbe-afc60811205dc516": {
      "instrument_id": "lk-act-2007-37",
      "sha256": "afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa",
      "title": "FINANCE (AMENDMENT) ACT, No. 37 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-b2df76a65c2d47ba": {
      "instrument_id": "lk-act-2023-33",
      "sha256": "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b",
      "title": "FINANCE ACT, No. 33 OF 2023"
    },
    "engine-v11-reconciled-4c016154ebbe-b6a34344daa596f1": {
      "instrument_id": "lk-act-2009-32",
      "sha256": "0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 32 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-b85b87f48cd5826a": {
      "instrument_id": "lk-act-2023-8",
      "sha256": "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610",
      "title": "CARRIAGE BY AIR (AMENDMENT) ACT, No. 8 OF 2023"
    },
    "engine-v11-reconciled-4c016154ebbe-b8cdc6d11c2f4445": {
      "instrument_id": "lk-act-2009-9",
      "sha256": "1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56",
      "title": "NATION BUILDING TAX ACT, NO. 9 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-bbcc48aefa8b7821": {
      "instrument_id": "lk-act-2006-51",
      "sha256": "bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY ACT, NO. 51 OF 2006"
    },
    "engine-v11-reconciled-4c016154ebbe-bcea2bdb1dab3d9a": {
      "instrument_id": "lk-act-2023-15",
      "sha256": "f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2023"
    },
    "engine-v11-reconciled-4c016154ebbe-bf58648b0725d7a6": {
      "instrument_id": "lk-act-2013-12",
      "sha256": "bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e",
      "title": "FINANCE ACT, No. 12 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-c65bfaf8558fda4a": {
      "instrument_id": "lk-act-2006-13",
      "sha256": "c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d",
      "title": "ECONOMIC SERVICE CHARGE ACT, No. 13 OF 2006"
    },
    "engine-v11-reconciled-4c016154ebbe-c76b30a6c00f7c88": {
      "instrument_id": "lk-act-2009-7",
      "sha256": "c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 7 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-cac167d4a6c44875": {
      "instrument_id": "lk-act-2009-30",
      "sha256": "cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) (AMENDMENT) ACT, NO. 30 OF 2009"
    },
    "engine-v11-reconciled-4c016154ebbe-cdc3d36908929a0a": {
      "instrument_id": "lk-act-2014-38",
      "sha256": "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57",
      "title": "LAND (RESTRICTIONS ON ALIENATION) ACT, No. 38 OF 2014"
    },
    "engine-v11-reconciled-4c016154ebbe-d0919c7e899414c7": {
      "instrument_id": "lk-act-2026-10",
      "sha256": "5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 10 OF 2026"
    },
    "engine-v11-reconciled-4c016154ebbe-d34778de42b67646": {
      "instrument_id": "lk-act-2008-7",
      "sha256": "d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-d48b9922872a1b5d": {
      "instrument_id": "lk-act-2020-2",
      "sha256": "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c",
      "title": "FINANCE (AMENDMENT) ACT, No. 2 OF 2020"
    },
    "engine-v11-reconciled-4c016154ebbe-d55bbb7be0bd4556": {
      "instrument_id": "lk-act-2002-33",
      "sha256": "d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) ACT, No. 33 OF 2002"
    },
    "engine-v11-reconciled-4c016154ebbe-d5655884e7890ad4": {
      "instrument_id": "lk-act-2011-41",
      "sha256": "d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 41 OF 2011"
    },
    "engine-v11-reconciled-4c016154ebbe-d642e2c2ccc797a3": {
      "instrument_id": "lk-act-2005-25",
      "sha256": "d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING ACT, No. 25 OF 2005"
    },
    "engine-v11-reconciled-4c016154ebbe-dcda00b6755405a0": {
      "instrument_id": "lk-act-2021-12",
      "sha256": "dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 12 OF 2021"
    },
    "engine-v11-reconciled-4c016154ebbe-dd75ecf4f046bb27": {
      "instrument_id": "lk-act-2007-9",
      "sha256": "dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db",
      "title": "RESETTLEMENT AUTHORITY ACT, NO. 09 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-e07930075fecb0c6": {
      "instrument_id": "lk-act-2025-10",
      "sha256": "e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 10 OF 2025"
    },
    "engine-v11-reconciled-4c016154ebbe-e1f6da4e727adb53": {
      "instrument_id": "lk-act-2008-8",
      "sha256": "e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb",
      "title": "FINANCE (AMENDMENT) ACT, No. 8 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-e5c66a5c29d64edb": {
      "instrument_id": "lk-act-2012-9",
      "sha256": "917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT. No. 9 OF 2012"
    },
    "engine-v11-reconciled-4c016154ebbe-e9c25a8a1864ff0f": {
      "instrument_id": "lk-act-2014-11",
      "sha256": "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 11 OF 2014"
    },
    "engine-v11-reconciled-4c016154ebbe-e9c4c4a58ccd7a26": {
      "instrument_id": "lk-act-2016-22",
      "sha256": "5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 22 OF 2016"
    },
    "engine-v11-reconciled-4c016154ebbe-e9df7c60d5594c5d": {
      "instrument_id": "lk-act-2013-11",
      "sha256": "d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 11 OF 2013"
    },
    "engine-v11-reconciled-4c016154ebbe-ea155b19391a469d": {
      "instrument_id": "lk-act-2008-11",
      "sha256": "ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-ea252d114e78e690": {
      "instrument_id": "lk-act-2018-20",
      "sha256": "0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2018"
    },
    "engine-v11-reconciled-4c016154ebbe-ee4575005a7a4d00": {
      "instrument_id": "lk-act-2025-9",
      "sha256": "ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 9 OF 2025"
    },
    "engine-v11-reconciled-4c016154ebbe-f0bd7e658e651246": {
      "instrument_id": "lk-act-2018-21",
      "sha256": "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 21 OF 2018"
    },
    "engine-v11-reconciled-4c016154ebbe-f0e2d86e0272fb15": {
      "instrument_id": "lk-act-2003-25",
      "sha256": "f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3",
      "title": "FINANCE ACT, No. 25 OF 2003"
    },
    "engine-v11-reconciled-4c016154ebbe-f4f8e9bda1d04084": {
      "instrument_id": "lk-act-2007-47",
      "sha256": "f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 47 OF 2007"
    },
    "engine-v11-reconciled-4c016154ebbe-f6238c841da14718": {
      "instrument_id": "lk-act-2020-3",
      "sha256": "ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 3 OF 2020"
    },
    "engine-v11-reconciled-4c016154ebbe-f64704a9df6e8c40": {
      "instrument_id": "lk-act-2014-18",
      "sha256": "f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY (AMENDMENT) ACT, No. 18 OF 2014"
    },
    "engine-v11-reconciled-4c016154ebbe-fb74b60e8c0dbccd": {
      "instrument_id": "lk-act-2008-33",
      "sha256": "fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY (AMENDMENT) ACT, No. 33 OF 2008"
    },
    "engine-v11-reconciled-4c016154ebbe-fe1ea4997df06af6": {
      "instrument_id": "lk-act-2007-45",
      "sha256": "fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef",
      "title": "FINANCE (AMENDMENT) ACT, NO. 45 OF 2007"
    },
    "engine-v12-010eaa2e62ff4030": {
      "instrument_id": "lk-act-2025-26",
      "sha256": "010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 26 OF 2025"
    },
    "engine-v12-020691ed319c4e1b": {
      "instrument_id": "lk-act-2004-11",
      "sha256": "020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe",
      "title": "FINANCE ACT, No. 11 OF 2004"
    },
    "engine-v12-038fce99adb29b52": {
      "instrument_id": "lk-act-2018-35",
      "sha256": "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7",
      "title": "FINANCE ACT, No. 35 OF 2018"
    },
    "engine-v12-0484e30bd9beee74": {
      "instrument_id": "lk-act-2017-7",
      "sha256": "0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 7 OF 2017"
    },
    "engine-v12-06838282e43ff13b": {
      "instrument_id": "lk-act-1999-8",
      "sha256": "06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e",
      "title": "TOBACCO TAX ACT, No. 08 OF 1999"
    },
    "engine-v12-08303ae9f5fa3082": {
      "instrument_id": "lk-act-2018-12",
      "sha256": "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 12 OF 2018"
    },
    "engine-v12-0a2e020ab1a01498": {
      "instrument_id": "lk-act-2017-14",
      "sha256": "0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY (AMENDMENT) ACT, No. 14 OF 2017"
    },
    "engine-v12-0d908137412311ad": {
      "instrument_id": "lk-act-2019-20",
      "sha256": "9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2019"
    },
    "engine-v12-10df115f0c104eef": {
      "instrument_id": "lk-act-2016-4",
      "sha256": "10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 4 OF 2016"
    },
    "engine-v12-11defaa0f2254736": {
      "instrument_id": "lk-act-2006-12",
      "sha256": "11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) ACT, No. 12 OF 2006"
    },
    "engine-v12-15a38c5892d864b3": {
      "instrument_id": "lk-act-2013-8",
      "sha256": "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 8 OF 2013"
    },
    "engine-v12-177df77d8625abca": {
      "instrument_id": "lk-act-2024-15",
      "sha256": "64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2024"
    },
    "engine-v12-17d2d1d251a59b67": {
      "instrument_id": "lk-act-2007-13",
      "sha256": "17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f",
      "title": "FINANCE (AMENDMENT) ACT, No. 13 OF 2007"
    },
    "engine-v12-1bbd3c02b957c261": {
      "instrument_id": "lk-act-2025-24",
      "sha256": "5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 24 OF 2025"
    },
    "engine-v12-1c611f654f4d2029": {
      "instrument_id": "lk-act-2013-3",
      "sha256": "1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 3 OF 2013"
    },
    "engine-v12-239f61c451410588": {
      "instrument_id": "lk-act-2023-14",
      "sha256": "2a086eb2ab9b222f2f707486ef32436fe5a500ccd4e84530e38cb7aacdd476e2",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 14 OF 2023"
    },
    "engine-v12-24045391b4ecbcd3": {
      "instrument_id": "lk-act-2008-14",
      "sha256": "24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470",
      "title": "STRATEGIC DEVELOPMENT PROJECTS ACT, No. 14 OF 2008"
    },
    "engine-v12-24e8fa6345a290f4": {
      "instrument_id": "lk-act-2011-12",
      "sha256": "24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 12 OF 2011"
    },
    "engine-v12-283e1252ff238d03": {
      "instrument_id": "lk-act-2008-10",
      "sha256": "283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 10 OF 2008"
    },
    "engine-v12-28acaf68eae337aa": {
      "instrument_id": "lk-act-2014-9",
      "sha256": "28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 9 OF 2014"
    },
    "engine-v12-2b840f450fcd0d65": {
      "instrument_id": "lk-act-2016-13",
      "sha256": "2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 13 OF 2016"
    },
    "engine-v12-2c83dc5b0edbf1e8": {
      "instrument_id": "lk-act-2022-6",
      "sha256": "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) (AMENDMENT) ACT, No. 6 OF 2022"
    },
    "engine-v12-2cec4c3f6fea90c0": {
      "instrument_id": "lk-act-2017-3",
      "sha256": "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 3 OF 2017"
    },
    "engine-v12-2fab47e1fd8d4922": {
      "instrument_id": "lk-act-2015-13",
      "sha256": "2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 13 OF 2015"
    },
    "engine-v12-340852bc820f0054": {
      "instrument_id": "lk-act-2013-16",
      "sha256": "340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 16 OF 2013"
    },
    "engine-v12-3706ee7993257c74": {
      "instrument_id": "lk-act-2007-55",
      "sha256": "3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) ACT, No. 55 OF 2007"
    },
    "engine-v12-3767ee02072b2fee": {
      "instrument_id": "lk-act-2025-2",
      "sha256": "0dff13924d408a621ce6dd01c2069c652c6a55be5740b897d145589454e5f7f8",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 2 OF 2025"
    },
    "engine-v12-386743ac371b1e75": {
      "instrument_id": "lk-act-2005-7",
      "sha256": "386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2005"
    },
    "engine-v12-3ad87b14401803d4": {
      "instrument_id": "lk-act-2021-16",
      "sha256": "9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 16 OF 2021"
    },
    "engine-v12-3c899d6dad3585c8": {
      "instrument_id": "lk-act-2010-14",
      "sha256": "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558",
      "title": "CIVIL AVIATION ACT, No. 14 OF 2010"
    },
    "engine-v12-3d8d0dc5d494c5ed": {
      "instrument_id": "lk-act-2016-21",
      "sha256": "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 21 OF 2016"
    },
    "engine-v12-3e6289785b5d2ace": {
      "instrument_id": "lk-act-2025-11",
      "sha256": "f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 11 OF 2025"
    },
    "engine-v12-4041a8ef167eb084": {
      "instrument_id": "lk-act-2011-13",
      "sha256": "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) ACT, No. 13 OF 2011"
    },
    "engine-v12-418781f54cdfd082": {
      "instrument_id": "lk-act-2013-5",
      "sha256": "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2013"
    },
    "engine-v12-43e8c4dc7e4ca1a3": {
      "instrument_id": "lk-act-2014-10",
      "sha256": "fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2014"
    },
    "engine-v12-47c9fe736e85ea10": {
      "instrument_id": "lk-act-2011-15",
      "sha256": "47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045",
      "title": "FINANCE (AMENDMENT) ACT, No. 15 OF 2011"
    },
    "engine-v12-47d16ccba8e0c17d": {
      "instrument_id": "lk-act-2021-10",
      "sha256": "47d16ccba8e0c17df9164828cddf28541500edd469b5d2a02bc864c8d1d05cc0",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 10 OF 2021"
    },
    "engine-v12-48e79ad5c5ebdff5": {
      "instrument_id": "lk-act-1999-54",
      "sha256": "48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7",
      "title": "RANA VIRU SEVA AUTHORITY ACT, No. 54 OF 1999"
    },
    "engine-v12-4f2fcade80a8b194": {
      "instrument_id": "lk-act-2018-33",
      "sha256": "4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 33 OF 2018"
    },
    "engine-v12-4ff365ba7583281e": {
      "instrument_id": "lk-act-2016-3",
      "sha256": "357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS ACT, No. 3 OF 2016"
    },
    "engine-v12-505c9b943b0a883a": {
      "instrument_id": "lk-act-2009-18",
      "sha256": "505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e",
      "title": "FINANCE (AMENDMENT) ACT, NO. 18 OF 2009"
    },
    "engine-v12-52056495ca84b30f": {
      "instrument_id": "lk-act-2020-4",
      "sha256": "52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 4 OF 2020"
    },
    "engine-v12-52d986f40394d4c4": {
      "instrument_id": "lk-act-2017-9",
      "sha256": "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) (AMENDMENT) ACT, No. 9 OF 2017"
    },
    "engine-v12-540977e80ed06d0c": {
      "instrument_id": "lk-act-2011-10",
      "sha256": "902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2011"
    },
    "engine-v12-5470e4359f0e6f4b": {
      "instrument_id": "lk-act-2005-5",
      "sha256": "5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e",
      "title": "FINANCE ACT, No. 5 OF 2005"
    },
    "engine-v12-54d614a9a98dcdde": {
      "instrument_id": "lk-act-2013-15",
      "sha256": "54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 15 OF 2013"
    },
    "engine-v12-55de35382c0b1fd0": {
      "instrument_id": "lk-act-2012-20",
      "sha256": "55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 20 OF 2012"
    },
    "engine-v12-5604933fce046827": {
      "instrument_id": "lk-act-2017-13",
      "sha256": "03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 13 OF 2017"
    },
    "engine-v12-565a4f3edcbaec3d": {
      "instrument_id": "lk-act-2003-27",
      "sha256": "565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY ACT, No. 27 OF 2003"
    },
    "engine-v12-581d20f6abcc200b": {
      "instrument_id": "lk-act-1999-17",
      "sha256": "581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY ACT, No. 17 OF 1999"
    },
    "engine-v12-616ac68a0a7889f1": {
      "instrument_id": "lk-act-2020-5",
      "sha256": "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2020"
    },
    "engine-v12-627abbb7b65581a2": {
      "instrument_id": "lk-act-2013-10",
      "sha256": "627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd",
      "title": "RESETTLEMENT AUTHORITY (AMENDMENT) ACT, No. 10 OF 2013"
    },
    "engine-v12-63dbc7faff9ae200": {
      "instrument_id": "lk-act-2011-11",
      "sha256": "63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2011"
    },
    "engine-v12-65ca8020951f93cd": {
      "instrument_id": "lk-act-2007-15",
      "sha256": "65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 15 OF 2007"
    },
    "engine-v12-6617b32ac9f373cc": {
      "instrument_id": "lk-act-2011-21",
      "sha256": "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117",
      "title": "TELECOMMUNICATION LEVY ACT, No. 21 OF 2011"
    },
    "engine-v12-67a43366df903e38": {
      "instrument_id": "lk-act-2012-13",
      "sha256": "67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 13 OF 2012"
    },
    "engine-v12-6aecc8d3e0a62312": {
      "instrument_id": "lk-act-2003-3",
      "sha256": "6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) ACT, No. 3 OF 2003"
    },
    "engine-v12-6b75e3d7ebe56d2c": {
      "instrument_id": "lk-act-2012-11",
      "sha256": "6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2012"
    },
    "engine-v12-726b6e86023ab900": {
      "instrument_id": "lk-act-2009-13",
      "sha256": "726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50",
      "title": "FINANCE (AMENDMENT) ACT, NO. 13 OF 2009"
    },
    "engine-v12-738cfe3bea7f3f93": {
      "instrument_id": "lk-act-2006-17",
      "sha256": "738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY ACT, No. 17 OF 2006"
    },
    "engine-v12-749a9d200f6b438d": {
      "instrument_id": "lk-act-2005-36",
      "sha256": "749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 36 OF 2005"
    },
    "engine-v12-7603f6d11a7efe52": {
      "instrument_id": "lk-act-2013-20",
      "sha256": "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, No. 20 OF 2013"
    },
    "engine-v12-7c5287361c3de3d1": {
      "instrument_id": "lk-act-2018-29",
      "sha256": "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288",
      "title": "CARRIAGE BY AIR ACT, No. 29 OF 2018"
    },
    "engine-v12-7c65a1d9b54f8188": {
      "instrument_id": "lk-act-2013-29",
      "sha256": "7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 29 OF 2013"
    },
    "engine-v12-7da67ada42276e0a": {
      "instrument_id": "lk-act-2022-45",
      "sha256": "23b1485cbf651508fd7ed93b3e80a61fb3e8816225b49abb75fc3caaa28a2a27",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 45 OF 2022"
    },
    "engine-v12-7de4ec283f8bc6bf": {
      "instrument_id": "lk-act-2022-25",
      "sha256": "6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY ACT, No. 25 OF 2022"
    },
    "engine-v12-815b132e5eab9c93": {
      "instrument_id": "lk-act-2013-6",
      "sha256": "815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 6 OF 2013"
    },
    "engine-v12-82a9bf4bbcf40c3b": {
      "instrument_id": "lk-act-2007-48",
      "sha256": "82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155",
      "title": "SPECIAL COMMODITY LEVY ACT, No. 48 OF 2007"
    },
    "engine-v12-8316b2609f3b2de5": {
      "instrument_id": "lk-act-2006-11",
      "sha256": "8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376",
      "title": "FINANCE ACT, No. 11 OF 2006"
    },
    "engine-v12-86f342be653bdd32": {
      "instrument_id": "lk-act-2023-4",
      "sha256": "66e2bef45624e3c5f50b8ca449ba61a99b8c93873c5bdac5fcd746beb744c8c0",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 4 OF 2023"
    },
    "engine-v12-8710db26120aeab6": {
      "instrument_id": "lk-act-2008-5",
      "sha256": "8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2",
      "title": "DEFENCE SERVICES COlVIMAND AND STAFF COLLEGE ACT, No. 5 OF 2008"
    },
    "engine-v12-8788c9db433b33a7": {
      "instrument_id": "lk-act-2003-35",
      "sha256": "8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN ACT, No. 35 OF 2003"
    },
    "engine-v12-8dab62f83f4c88f4": {
      "instrument_id": "lk-act-2015-12",
      "sha256": "46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 12 OF 2015"
    },
    "engine-v12-954bf58b4d319712": {
      "instrument_id": "lk-act-2023-24",
      "sha256": "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 24 OF 2023"
    },
    "engine-v12-9afda3b1ee76364d": {
      "instrument_id": "lk-act-2008-12",
      "sha256": "9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 12 OF 2008"
    },
    "engine-v12-9b5df559fd4f729f": {
      "instrument_id": "lk-act-2012-12",
      "sha256": "9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3",
      "title": "FINANCE ACT, No. 12 OF 2012"
    },
    "engine-v12-9c193a8aa321127f": {
      "instrument_id": "lk-act-2009-16",
      "sha256": "9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, NO. 16 OF 2009"
    },
    "engine-v12-9c6a86c5e7eeb01c": {
      "instrument_id": "lk-act-2012-4",
      "sha256": "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, NO. 4 OF 2012"
    },
    "engine-v12-9f7a25495e980023": {
      "instrument_id": "lk-act-2011-18",
      "sha256": "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY ACT, No. 18 OF 2011"
    },
    "engine-v12-a05af5a077184a5f": {
      "instrument_id": "lk-act-2022-27",
      "sha256": "a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 27 OF 2022"
    },
    "engine-v12-a3b3e391565b11ad": {
      "instrument_id": "lk-act-2012-10",
      "sha256": "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 10 OF 2012"
    },
    "engine-v12-a46c7fda815b7525": {
      "instrument_id": "lk-act-2009-6",
      "sha256": "a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN (AMENDMENT) ACT, No. 6 OF 2009"
    },
    "engine-v12-a74b43534cfef9da": {
      "instrument_id": "lk-act-2004-9",
      "sha256": "a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f",
      "title": "TOBACCO TAX (AMENDMENT) ACT, No. 9 OF 2004"
    },
    "engine-v12-a7805df36ec051e9": {
      "instrument_id": "lk-act-2016-14",
      "sha256": "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) ACT, No. 14 OF 2016"
    },
    "engine-v12-a98839990788e066": {
      "instrument_id": "lk-act-2011-23",
      "sha256": "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2",
      "title": "TAX APPEALS COMMISSION ACT, No. 23 OF 2011"
    },
    "engine-v12-af71306c92055221": {
      "instrument_id": "lk-act-2014-12",
      "sha256": "af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b",
      "title": "SPECIAL COMMODITY LEVY (AMENDMENT) ACT, No. 12 OF 2014"
    },
    "engine-v12-af956197361b1759": {
      "instrument_id": "lk-act-2019-21",
      "sha256": "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb",
      "title": "FINANCE ACT, No. 21 OF 2019"
    },
    "engine-v12-afc60811205dc516": {
      "instrument_id": "lk-act-2007-37",
      "sha256": "afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa",
      "title": "FINANCE (AMENDMENT) ACT, No. 37 OF 2007"
    },
    "engine-v12-b2df76a65c2d47ba": {
      "instrument_id": "lk-act-2023-33",
      "sha256": "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b",
      "title": "FINANCE ACT, No. 33 OF 2023"
    },
    "engine-v12-b6a34344daa596f1": {
      "instrument_id": "lk-act-2009-32",
      "sha256": "0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 32 OF 2009"
    },
    "engine-v12-b85b87f48cd5826a": {
      "instrument_id": "lk-act-2023-8",
      "sha256": "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610",
      "title": "CARRIAGE BY AIR (AMENDMENT) ACT, No. 8 OF 2023"
    },
    "engine-v12-b8cdc6d11c2f4445": {
      "instrument_id": "lk-act-2009-9",
      "sha256": "1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56",
      "title": "NATION BUILDING TAX ACT, NO. 9 OF 2009"
    },
    "engine-v12-bbcc48aefa8b7821": {
      "instrument_id": "lk-act-2006-51",
      "sha256": "bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY ACT, NO. 51 OF 2006"
    },
    "engine-v12-bcea2bdb1dab3d9a": {
      "instrument_id": "lk-act-2023-15",
      "sha256": "f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2023"
    },
    "engine-v12-bf58648b0725d7a6": {
      "instrument_id": "lk-act-2013-12",
      "sha256": "bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e",
      "title": "FINANCE ACT, No. 12 OF 2013"
    },
    "engine-v12-c65bfaf8558fda4a": {
      "instrument_id": "lk-act-2006-13",
      "sha256": "c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d",
      "title": "ECONOMIC SERVICE CHARGE ACT, No. 13 OF 2006"
    },
    "engine-v12-c76b30a6c00f7c88": {
      "instrument_id": "lk-act-2009-7",
      "sha256": "c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 7 OF 2009"
    },
    "engine-v12-cac167d4a6c44875": {
      "instrument_id": "lk-act-2009-30",
      "sha256": "cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) (AMENDMENT) ACT, NO. 30 OF 2009"
    },
    "engine-v12-cdc3d36908929a0a": {
      "instrument_id": "lk-act-2014-38",
      "sha256": "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57",
      "title": "LAND (RESTRICTIONS ON ALIENATION) ACT, No. 38 OF 2014"
    },
    "engine-v12-d0919c7e899414c7": {
      "instrument_id": "lk-act-2026-10",
      "sha256": "5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 10 OF 2026"
    },
    "engine-v12-d34778de42b67646": {
      "instrument_id": "lk-act-2008-7",
      "sha256": "d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2008"
    },
    "engine-v12-d48b9922872a1b5d": {
      "instrument_id": "lk-act-2020-2",
      "sha256": "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c",
      "title": "FINANCE (AMENDMENT) ACT, No. 2 OF 2020"
    },
    "engine-v12-d55bbb7be0bd4556": {
      "instrument_id": "lk-act-2002-33",
      "sha256": "d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) ACT, No. 33 OF 2002"
    },
    "engine-v12-d5655884e7890ad4": {
      "instrument_id": "lk-act-2011-41",
      "sha256": "d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 41 OF 2011"
    },
    "engine-v12-d642e2c2ccc797a3": {
      "instrument_id": "lk-act-2005-25",
      "sha256": "d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING ACT, No. 25 OF 2005"
    },
    "engine-v12-dcda00b6755405a0": {
      "instrument_id": "lk-act-2021-12",
      "sha256": "dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 12 OF 2021"
    },
    "engine-v12-dd75ecf4f046bb27": {
      "instrument_id": "lk-act-2007-9",
      "sha256": "dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db",
      "title": "RESETTLEMENT AUTHORITY ACT, NO. 09 OF 2007"
    },
    "engine-v12-e07930075fecb0c6": {
      "instrument_id": "lk-act-2025-10",
      "sha256": "e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 10 OF 2025"
    },
    "engine-v12-e1f6da4e727adb53": {
      "instrument_id": "lk-act-2008-8",
      "sha256": "e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb",
      "title": "FINANCE (AMENDMENT) ACT, No. 8 OF 2008"
    },
    "engine-v12-e5c66a5c29d64edb": {
      "instrument_id": "lk-act-2012-9",
      "sha256": "917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT. No. 9 OF 2012"
    },
    "engine-v12-e857f11ec026b424": {
      "instrument_id": "lk-act-2017-24",
      "sha256": "e857f11ec026b424c4c8a5bc458f3fdd9cf1cca96e667b9a9bb80d8ccd972d77",
      "title": "INLAND REVENUE ACT, No. 24 OF 2017"
    },
    "engine-v12-e9c25a8a1864ff0f": {
      "instrument_id": "lk-act-2014-11",
      "sha256": "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 11 OF 2014"
    },
    "engine-v12-e9c4c4a58ccd7a26": {
      "instrument_id": "lk-act-2016-22",
      "sha256": "5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 22 OF 2016"
    },
    "engine-v12-e9df7c60d5594c5d": {
      "instrument_id": "lk-act-2013-11",
      "sha256": "d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 11 OF 2013"
    },
    "engine-v12-ea155b19391a469d": {
      "instrument_id": "lk-act-2008-11",
      "sha256": "ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2008"
    },
    "engine-v12-ea252d114e78e690": {
      "instrument_id": "lk-act-2018-20",
      "sha256": "0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2018"
    },
    "engine-v12-ee4575005a7a4d00": {
      "instrument_id": "lk-act-2025-9",
      "sha256": "ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 9 OF 2025"
    },
    "engine-v12-f0bd7e658e651246": {
      "instrument_id": "lk-act-2018-21",
      "sha256": "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 21 OF 2018"
    },
    "engine-v12-f0e2d86e0272fb15": {
      "instrument_id": "lk-act-2003-25",
      "sha256": "f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3",
      "title": "FINANCE ACT, No. 25 OF 2003"
    },
    "engine-v12-f4f8e9bda1d04084": {
      "instrument_id": "lk-act-2007-47",
      "sha256": "f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 47 OF 2007"
    },
    "engine-v12-f6238c841da14718": {
      "instrument_id": "lk-act-2020-3",
      "sha256": "ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 3 OF 2020"
    },
    "engine-v12-f64704a9df6e8c40": {
      "instrument_id": "lk-act-2014-18",
      "sha256": "f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY (AMENDMENT) ACT, No. 18 OF 2014"
    },
    "engine-v12-fb74b60e8c0dbccd": {
      "instrument_id": "lk-act-2008-33",
      "sha256": "fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY (AMENDMENT) ACT, No. 33 OF 2008"
    },
    "engine-v12-fe1ea4997df06af6": {
      "instrument_id": "lk-act-2007-45",
      "sha256": "fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef",
      "title": "FINANCE (AMENDMENT) ACT, NO. 45 OF 2007"
    },
    "engine-v12-ui-final-ab345900-010eaa2e62ff4030": {
      "instrument_id": "lk-act-2025-26",
      "sha256": "010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 26 OF 2025"
    },
    "engine-v12-ui-final-ab345900-020691ed319c4e1b": {
      "instrument_id": "lk-act-2004-11",
      "sha256": "020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe",
      "title": "FINANCE ACT, No. 11 OF 2004"
    },
    "engine-v12-ui-final-ab345900-038fce99adb29b52": {
      "instrument_id": "lk-act-2018-35",
      "sha256": "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7",
      "title": "FINANCE ACT, No. 35 OF 2018"
    },
    "engine-v12-ui-final-ab345900-0484e30bd9beee74": {
      "instrument_id": "lk-act-2017-7",
      "sha256": "0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 7 OF 2017"
    },
    "engine-v12-ui-final-ab345900-06838282e43ff13b": {
      "instrument_id": "lk-act-1999-8",
      "sha256": "06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e",
      "title": "TOBACCO TAX ACT, No. 08 OF 1999"
    },
    "engine-v12-ui-final-ab345900-08303ae9f5fa3082": {
      "instrument_id": "lk-act-2018-12",
      "sha256": "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 12 OF 2018"
    },
    "engine-v12-ui-final-ab345900-0a2e020ab1a01498": {
      "instrument_id": "lk-act-2017-14",
      "sha256": "0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY (AMENDMENT) ACT, No. 14 OF 2017"
    },
    "engine-v12-ui-final-ab345900-0d908137412311ad": {
      "instrument_id": "lk-act-2019-20",
      "sha256": "9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2019"
    },
    "engine-v12-ui-final-ab345900-10df115f0c104eef": {
      "instrument_id": "lk-act-2016-4",
      "sha256": "10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 4 OF 2016"
    },
    "engine-v12-ui-final-ab345900-11defaa0f2254736": {
      "instrument_id": "lk-act-2006-12",
      "sha256": "11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) ACT, No. 12 OF 2006"
    },
    "engine-v12-ui-final-ab345900-15a38c5892d864b3": {
      "instrument_id": "lk-act-2013-8",
      "sha256": "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 8 OF 2013"
    },
    "engine-v12-ui-final-ab345900-177df77d8625abca": {
      "instrument_id": "lk-act-2024-15",
      "sha256": "64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2024"
    },
    "engine-v12-ui-final-ab345900-17d2d1d251a59b67": {
      "instrument_id": "lk-act-2007-13",
      "sha256": "17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f",
      "title": "FINANCE (AMENDMENT) ACT, No. 13 OF 2007"
    },
    "engine-v12-ui-final-ab345900-1bbd3c02b957c261": {
      "instrument_id": "lk-act-2025-24",
      "sha256": "5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 24 OF 2025"
    },
    "engine-v12-ui-final-ab345900-1c611f654f4d2029": {
      "instrument_id": "lk-act-2013-3",
      "sha256": "1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 3 OF 2013"
    },
    "engine-v12-ui-final-ab345900-239f61c451410588": {
      "instrument_id": "lk-act-2023-14",
      "sha256": "2a086eb2ab9b222f2f707486ef32436fe5a500ccd4e84530e38cb7aacdd476e2",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 14 OF 2023"
    },
    "engine-v12-ui-final-ab345900-24045391b4ecbcd3": {
      "instrument_id": "lk-act-2008-14",
      "sha256": "24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470",
      "title": "STRATEGIC DEVELOPMENT PROJECTS ACT, No. 14 OF 2008"
    },
    "engine-v12-ui-final-ab345900-24e8fa6345a290f4": {
      "instrument_id": "lk-act-2011-12",
      "sha256": "24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 12 OF 2011"
    },
    "engine-v12-ui-final-ab345900-283e1252ff238d03": {
      "instrument_id": "lk-act-2008-10",
      "sha256": "283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 10 OF 2008"
    },
    "engine-v12-ui-final-ab345900-28acaf68eae337aa": {
      "instrument_id": "lk-act-2014-9",
      "sha256": "28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 9 OF 2014"
    },
    "engine-v12-ui-final-ab345900-2b840f450fcd0d65": {
      "instrument_id": "lk-act-2016-13",
      "sha256": "2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 13 OF 2016"
    },
    "engine-v12-ui-final-ab345900-2c83dc5b0edbf1e8": {
      "instrument_id": "lk-act-2022-6",
      "sha256": "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) (AMENDMENT) ACT, No. 6 OF 2022"
    },
    "engine-v12-ui-final-ab345900-2cec4c3f6fea90c0": {
      "instrument_id": "lk-act-2017-3",
      "sha256": "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 3 OF 2017"
    },
    "engine-v12-ui-final-ab345900-2fab47e1fd8d4922": {
      "instrument_id": "lk-act-2015-13",
      "sha256": "2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 13 OF 2015"
    },
    "engine-v12-ui-final-ab345900-340852bc820f0054": {
      "instrument_id": "lk-act-2013-16",
      "sha256": "340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 16 OF 2013"
    },
    "engine-v12-ui-final-ab345900-3706ee7993257c74": {
      "instrument_id": "lk-act-2007-55",
      "sha256": "3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) ACT, No. 55 OF 2007"
    },
    "engine-v12-ui-final-ab345900-3767ee02072b2fee": {
      "instrument_id": "lk-act-2025-2",
      "sha256": "0dff13924d408a621ce6dd01c2069c652c6a55be5740b897d145589454e5f7f8",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 2 OF 2025"
    },
    "engine-v12-ui-final-ab345900-386743ac371b1e75": {
      "instrument_id": "lk-act-2005-7",
      "sha256": "386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2005"
    },
    "engine-v12-ui-final-ab345900-3ad87b14401803d4": {
      "instrument_id": "lk-act-2021-16",
      "sha256": "9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 16 OF 2021"
    },
    "engine-v12-ui-final-ab345900-3c899d6dad3585c8": {
      "instrument_id": "lk-act-2010-14",
      "sha256": "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558",
      "title": "CIVIL AVIATION ACT, No. 14 OF 2010"
    },
    "engine-v12-ui-final-ab345900-3d8d0dc5d494c5ed": {
      "instrument_id": "lk-act-2016-21",
      "sha256": "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 21 OF 2016"
    },
    "engine-v12-ui-final-ab345900-3e6289785b5d2ace": {
      "instrument_id": "lk-act-2025-11",
      "sha256": "f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 11 OF 2025"
    },
    "engine-v12-ui-final-ab345900-4041a8ef167eb084": {
      "instrument_id": "lk-act-2011-13",
      "sha256": "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) ACT, No. 13 OF 2011"
    },
    "engine-v12-ui-final-ab345900-418781f54cdfd082": {
      "instrument_id": "lk-act-2013-5",
      "sha256": "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2013"
    },
    "engine-v12-ui-final-ab345900-43e8c4dc7e4ca1a3": {
      "instrument_id": "lk-act-2014-10",
      "sha256": "fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2014"
    },
    "engine-v12-ui-final-ab345900-47c9fe736e85ea10": {
      "instrument_id": "lk-act-2011-15",
      "sha256": "47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045",
      "title": "FINANCE (AMENDMENT) ACT, No. 15 OF 2011"
    },
    "engine-v12-ui-final-ab345900-47d16ccba8e0c17d": {
      "instrument_id": "lk-act-2021-10",
      "sha256": "47d16ccba8e0c17df9164828cddf28541500edd469b5d2a02bc864c8d1d05cc0",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 10 OF 2021"
    },
    "engine-v12-ui-final-ab345900-48e79ad5c5ebdff5": {
      "instrument_id": "lk-act-1999-54",
      "sha256": "48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7",
      "title": "RANA VIRU SEVA AUTHORITY ACT, No. 54 OF 1999"
    },
    "engine-v12-ui-final-ab345900-4f2fcade80a8b194": {
      "instrument_id": "lk-act-2018-33",
      "sha256": "4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 33 OF 2018"
    },
    "engine-v12-ui-final-ab345900-4ff365ba7583281e": {
      "instrument_id": "lk-act-2016-3",
      "sha256": "357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS ACT, No. 3 OF 2016"
    },
    "engine-v12-ui-final-ab345900-505c9b943b0a883a": {
      "instrument_id": "lk-act-2009-18",
      "sha256": "505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e",
      "title": "FINANCE (AMENDMENT) ACT, NO. 18 OF 2009"
    },
    "engine-v12-ui-final-ab345900-52056495ca84b30f": {
      "instrument_id": "lk-act-2020-4",
      "sha256": "52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 4 OF 2020"
    },
    "engine-v12-ui-final-ab345900-52d986f40394d4c4": {
      "instrument_id": "lk-act-2017-9",
      "sha256": "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) (AMENDMENT) ACT, No. 9 OF 2017"
    },
    "engine-v12-ui-final-ab345900-540977e80ed06d0c": {
      "instrument_id": "lk-act-2011-10",
      "sha256": "902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2011"
    },
    "engine-v12-ui-final-ab345900-5470e4359f0e6f4b": {
      "instrument_id": "lk-act-2005-5",
      "sha256": "5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e",
      "title": "FINANCE ACT, No. 5 OF 2005"
    },
    "engine-v12-ui-final-ab345900-54d614a9a98dcdde": {
      "instrument_id": "lk-act-2013-15",
      "sha256": "54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 15 OF 2013"
    },
    "engine-v12-ui-final-ab345900-55de35382c0b1fd0": {
      "instrument_id": "lk-act-2012-20",
      "sha256": "55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 20 OF 2012"
    },
    "engine-v12-ui-final-ab345900-5604933fce046827": {
      "instrument_id": "lk-act-2017-13",
      "sha256": "03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 13 OF 2017"
    },
    "engine-v12-ui-final-ab345900-565a4f3edcbaec3d": {
      "instrument_id": "lk-act-2003-27",
      "sha256": "565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY ACT, No. 27 OF 2003"
    },
    "engine-v12-ui-final-ab345900-581d20f6abcc200b": {
      "instrument_id": "lk-act-1999-17",
      "sha256": "581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY ACT, No. 17 OF 1999"
    },
    "engine-v12-ui-final-ab345900-616ac68a0a7889f1": {
      "instrument_id": "lk-act-2020-5",
      "sha256": "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2020"
    },
    "engine-v12-ui-final-ab345900-627abbb7b65581a2": {
      "instrument_id": "lk-act-2013-10",
      "sha256": "627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd",
      "title": "RESETTLEMENT AUTHORITY (AMENDMENT) ACT, No. 10 OF 2013"
    },
    "engine-v12-ui-final-ab345900-63dbc7faff9ae200": {
      "instrument_id": "lk-act-2011-11",
      "sha256": "63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2011"
    },
    "engine-v12-ui-final-ab345900-65ca8020951f93cd": {
      "instrument_id": "lk-act-2007-15",
      "sha256": "65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 15 OF 2007"
    },
    "engine-v12-ui-final-ab345900-6617b32ac9f373cc": {
      "instrument_id": "lk-act-2011-21",
      "sha256": "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117",
      "title": "TELECOMMUNICATION LEVY ACT, No. 21 OF 2011"
    },
    "engine-v12-ui-final-ab345900-67a43366df903e38": {
      "instrument_id": "lk-act-2012-13",
      "sha256": "67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 13 OF 2012"
    },
    "engine-v12-ui-final-ab345900-6aecc8d3e0a62312": {
      "instrument_id": "lk-act-2003-3",
      "sha256": "6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) ACT, No. 3 OF 2003"
    },
    "engine-v12-ui-final-ab345900-6b75e3d7ebe56d2c": {
      "instrument_id": "lk-act-2012-11",
      "sha256": "6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2012"
    },
    "engine-v12-ui-final-ab345900-726b6e86023ab900": {
      "instrument_id": "lk-act-2009-13",
      "sha256": "726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50",
      "title": "FINANCE (AMENDMENT) ACT, NO. 13 OF 2009"
    },
    "engine-v12-ui-final-ab345900-738cfe3bea7f3f93": {
      "instrument_id": "lk-act-2006-17",
      "sha256": "738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY ACT, No. 17 OF 2006"
    },
    "engine-v12-ui-final-ab345900-749a9d200f6b438d": {
      "instrument_id": "lk-act-2005-36",
      "sha256": "749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 36 OF 2005"
    },
    "engine-v12-ui-final-ab345900-7603f6d11a7efe52": {
      "instrument_id": "lk-act-2013-20",
      "sha256": "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, No. 20 OF 2013"
    },
    "engine-v12-ui-final-ab345900-7c5287361c3de3d1": {
      "instrument_id": "lk-act-2018-29",
      "sha256": "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288",
      "title": "CARRIAGE BY AIR ACT, No. 29 OF 2018"
    },
    "engine-v12-ui-final-ab345900-7c65a1d9b54f8188": {
      "instrument_id": "lk-act-2013-29",
      "sha256": "7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab",
      "title": "DEFENCE SERVICES COMMAND AND STAFF COLLEGE (AMENDMENT) ACT, No. 29 OF 2013"
    },
    "engine-v12-ui-final-ab345900-7da67ada42276e0a": {
      "instrument_id": "lk-act-2022-45",
      "sha256": "23b1485cbf651508fd7ed93b3e80a61fb3e8816225b49abb75fc3caaa28a2a27",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 45 OF 2022"
    },
    "engine-v12-ui-final-ab345900-7de4ec283f8bc6bf": {
      "instrument_id": "lk-act-2022-25",
      "sha256": "6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY ACT, No. 25 OF 2022"
    },
    "engine-v12-ui-final-ab345900-815b132e5eab9c93": {
      "instrument_id": "lk-act-2013-6",
      "sha256": "815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 6 OF 2013"
    },
    "engine-v12-ui-final-ab345900-82a9bf4bbcf40c3b": {
      "instrument_id": "lk-act-2007-48",
      "sha256": "82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155",
      "title": "SPECIAL COMMODITY LEVY ACT, No. 48 OF 2007"
    },
    "engine-v12-ui-final-ab345900-8316b2609f3b2de5": {
      "instrument_id": "lk-act-2006-11",
      "sha256": "8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376",
      "title": "FINANCE ACT, No. 11 OF 2006"
    },
    "engine-v12-ui-final-ab345900-86f342be653bdd32": {
      "instrument_id": "lk-act-2023-4",
      "sha256": "66e2bef45624e3c5f50b8ca449ba61a99b8c93873c5bdac5fcd746beb744c8c0",
      "title": "INLAND REVENUE (AMENDMENT) ACT, No. 4 OF 2023"
    },
    "engine-v12-ui-final-ab345900-8710db26120aeab6": {
      "instrument_id": "lk-act-2008-5",
      "sha256": "8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2",
      "title": "DEFENCE SERVICES COlVIMAND AND STAFF COLLEGE ACT, No. 5 OF 2008"
    },
    "engine-v12-ui-final-ab345900-8788c9db433b33a7": {
      "instrument_id": "lk-act-2003-35",
      "sha256": "8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN ACT, No. 35 OF 2003"
    },
    "engine-v12-ui-final-ab345900-8dab62f83f4c88f4": {
      "instrument_id": "lk-act-2015-12",
      "sha256": "46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 12 OF 2015"
    },
    "engine-v12-ui-final-ab345900-954bf58b4d319712": {
      "instrument_id": "lk-act-2023-24",
      "sha256": "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 24 OF 2023"
    },
    "engine-v12-ui-final-ab345900-9afda3b1ee76364d": {
      "instrument_id": "lk-act-2008-12",
      "sha256": "9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 12 OF 2008"
    },
    "engine-v12-ui-final-ab345900-9b5df559fd4f729f": {
      "instrument_id": "lk-act-2012-12",
      "sha256": "9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3",
      "title": "FINANCE ACT, No. 12 OF 2012"
    },
    "engine-v12-ui-final-ab345900-9c193a8aa321127f": {
      "instrument_id": "lk-act-2009-16",
      "sha256": "9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, NO. 16 OF 2009"
    },
    "engine-v12-ui-final-ab345900-9c6a86c5e7eeb01c": {
      "instrument_id": "lk-act-2012-4",
      "sha256": "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, NO. 4 OF 2012"
    },
    "engine-v12-ui-final-ab345900-9f7a25495e980023": {
      "instrument_id": "lk-act-2011-18",
      "sha256": "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY ACT, No. 18 OF 2011"
    },
    "engine-v12-ui-final-ab345900-a05af5a077184a5f": {
      "instrument_id": "lk-act-2022-27",
      "sha256": "a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 27 OF 2022"
    },
    "engine-v12-ui-final-ab345900-a3b3e391565b11ad": {
      "instrument_id": "lk-act-2012-10",
      "sha256": "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 10 OF 2012"
    },
    "engine-v12-ui-final-ab345900-a46c7fda815b7525": {
      "instrument_id": "lk-act-2009-6",
      "sha256": "a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN (AMENDMENT) ACT, No. 6 OF 2009"
    },
    "engine-v12-ui-final-ab345900-a74b43534cfef9da": {
      "instrument_id": "lk-act-2004-9",
      "sha256": "a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f",
      "title": "TOBACCO TAX (AMENDMENT) ACT, No. 9 OF 2004"
    },
    "engine-v12-ui-final-ab345900-a7805df36ec051e9": {
      "instrument_id": "lk-act-2016-14",
      "sha256": "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) ACT, No. 14 OF 2016"
    },
    "engine-v12-ui-final-ab345900-a98839990788e066": {
      "instrument_id": "lk-act-2011-23",
      "sha256": "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2",
      "title": "TAX APPEALS COMMISSION ACT, No. 23 OF 2011"
    },
    "engine-v12-ui-final-ab345900-af71306c92055221": {
      "instrument_id": "lk-act-2014-12",
      "sha256": "af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b",
      "title": "SPECIAL COMMODITY LEVY (AMENDMENT) ACT, No. 12 OF 2014"
    },
    "engine-v12-ui-final-ab345900-af956197361b1759": {
      "instrument_id": "lk-act-2019-21",
      "sha256": "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb",
      "title": "FINANCE ACT, No. 21 OF 2019"
    },
    "engine-v12-ui-final-ab345900-afc60811205dc516": {
      "instrument_id": "lk-act-2007-37",
      "sha256": "afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa",
      "title": "FINANCE (AMENDMENT) ACT, No. 37 OF 2007"
    },
    "engine-v12-ui-final-ab345900-b2df76a65c2d47ba": {
      "instrument_id": "lk-act-2023-33",
      "sha256": "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b",
      "title": "FINANCE ACT, No. 33 OF 2023"
    },
    "engine-v12-ui-final-ab345900-b6a34344daa596f1": {
      "instrument_id": "lk-act-2009-32",
      "sha256": "0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 32 OF 2009"
    },
    "engine-v12-ui-final-ab345900-b85b87f48cd5826a": {
      "instrument_id": "lk-act-2023-8",
      "sha256": "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610",
      "title": "CARRIAGE BY AIR (AMENDMENT) ACT, No. 8 OF 2023"
    },
    "engine-v12-ui-final-ab345900-b8cdc6d11c2f4445": {
      "instrument_id": "lk-act-2009-9",
      "sha256": "1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56",
      "title": "NATION BUILDING TAX ACT, NO. 9 OF 2009"
    },
    "engine-v12-ui-final-ab345900-bbcc48aefa8b7821": {
      "instrument_id": "lk-act-2006-51",
      "sha256": "bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY ACT, NO. 51 OF 2006"
    },
    "engine-v12-ui-final-ab345900-bcea2bdb1dab3d9a": {
      "instrument_id": "lk-act-2023-15",
      "sha256": "f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2023"
    },
    "engine-v12-ui-final-ab345900-bf58648b0725d7a6": {
      "instrument_id": "lk-act-2013-12",
      "sha256": "bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e",
      "title": "FINANCE ACT, No. 12 OF 2013"
    },
    "engine-v12-ui-final-ab345900-c65bfaf8558fda4a": {
      "instrument_id": "lk-act-2006-13",
      "sha256": "c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d",
      "title": "ECONOMIC SERVICE CHARGE ACT, No. 13 OF 2006"
    },
    "engine-v12-ui-final-ab345900-c76b30a6c00f7c88": {
      "instrument_id": "lk-act-2009-7",
      "sha256": "c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 7 OF 2009"
    },
    "engine-v12-ui-final-ab345900-cac167d4a6c44875": {
      "instrument_id": "lk-act-2009-30",
      "sha256": "cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) (AMENDMENT) ACT, NO. 30 OF 2009"
    },
    "engine-v12-ui-final-ab345900-cdc3d36908929a0a": {
      "instrument_id": "lk-act-2014-38",
      "sha256": "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57",
      "title": "LAND (RESTRICTIONS ON ALIENATION) ACT, No. 38 OF 2014"
    },
    "engine-v12-ui-final-ab345900-d0919c7e899414c7": {
      "instrument_id": "lk-act-2026-10",
      "sha256": "5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 10 OF 2026"
    },
    "engine-v12-ui-final-ab345900-d34778de42b67646": {
      "instrument_id": "lk-act-2008-7",
      "sha256": "d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4",
      "title": "FINANCE (AMENDMENT) ACT, No. 7 OF 2008"
    },
    "engine-v12-ui-final-ab345900-d48b9922872a1b5d": {
      "instrument_id": "lk-act-2020-2",
      "sha256": "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c",
      "title": "FINANCE (AMENDMENT) ACT, No. 2 OF 2020"
    },
    "engine-v12-ui-final-ab345900-d55bbb7be0bd4556": {
      "instrument_id": "lk-act-2002-33",
      "sha256": "d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) ACT, No. 33 OF 2002"
    },
    "engine-v12-ui-final-ab345900-d5655884e7890ad4": {
      "instrument_id": "lk-act-2011-41",
      "sha256": "d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING (AMENDMENT) ACT, No. 41 OF 2011"
    },
    "engine-v12-ui-final-ab345900-d642e2c2ccc797a3": {
      "instrument_id": "lk-act-2005-25",
      "sha256": "d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e",
      "title": "CONVENTION ON THE SUPPRESSION OF TERRORIST FINANCING ACT, No. 25 OF 2005"
    },
    "engine-v12-ui-final-ab345900-dcda00b6755405a0": {
      "instrument_id": "lk-act-2021-12",
      "sha256": "dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc",
      "title": "FISCAL MANAGEMENT (RESPONSIBILITY) (AMENDMENT) ACT, No. 12 OF 2021"
    },
    "engine-v12-ui-final-ab345900-dd75ecf4f046bb27": {
      "instrument_id": "lk-act-2007-9",
      "sha256": "dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db",
      "title": "RESETTLEMENT AUTHORITY ACT, NO. 09 OF 2007"
    },
    "engine-v12-ui-final-ab345900-e07930075fecb0c6": {
      "instrument_id": "lk-act-2025-10",
      "sha256": "e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 10 OF 2025"
    },
    "engine-v12-ui-final-ab345900-e1f6da4e727adb53": {
      "instrument_id": "lk-act-2008-8",
      "sha256": "e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb",
      "title": "FINANCE (AMENDMENT) ACT, No. 8 OF 2008"
    },
    "engine-v12-ui-final-ab345900-e5c66a5c29d64edb": {
      "instrument_id": "lk-act-2012-9",
      "sha256": "917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT. No. 9 OF 2012"
    },
    "engine-v12-ui-final-ab345900-e857f11ec026b424": {
      "instrument_id": "lk-act-2017-24",
      "sha256": "e857f11ec026b424c4c8a5bc458f3fdd9cf1cca96e667b9a9bb80d8ccd972d77",
      "title": "INLAND REVENUE ACT, No. 24 OF 2017"
    },
    "engine-v12-ui-final-ab345900-e9c25a8a1864ff0f": {
      "instrument_id": "lk-act-2014-11",
      "sha256": "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 11 OF 2014"
    },
    "engine-v12-ui-final-ab345900-e9c4c4a58ccd7a26": {
      "instrument_id": "lk-act-2016-22",
      "sha256": "5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 22 OF 2016"
    },
    "engine-v12-ui-final-ab345900-e9df7c60d5594c5d": {
      "instrument_id": "lk-act-2013-11",
      "sha256": "d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 11 OF 2013"
    },
    "engine-v12-ui-final-ab345900-ea155b19391a469d": {
      "instrument_id": "lk-act-2008-11",
      "sha256": "ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5",
      "title": "ECONOMIC SERVICE CHARGE (AMENDMENT) ACT, No. 11 OF 2008"
    },
    "engine-v12-ui-final-ab345900-ea252d114e78e690": {
      "instrument_id": "lk-act-2018-20",
      "sha256": "0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2018"
    },
    "engine-v12-ui-final-ab345900-ee4575005a7a4d00": {
      "instrument_id": "lk-act-2025-9",
      "sha256": "ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 9 OF 2025"
    },
    "engine-v12-ui-final-ab345900-f0bd7e658e651246": {
      "instrument_id": "lk-act-2018-21",
      "sha256": "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 21 OF 2018"
    },
    "engine-v12-ui-final-ab345900-f0e2d86e0272fb15": {
      "instrument_id": "lk-act-2003-25",
      "sha256": "f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3",
      "title": "FINANCE ACT, No. 25 OF 2003"
    },
    "engine-v12-ui-final-ab345900-f4f8e9bda1d04084": {
      "instrument_id": "lk-act-2007-47",
      "sha256": "f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 47 OF 2007"
    },
    "engine-v12-ui-final-ab345900-f6238c841da14718": {
      "instrument_id": "lk-act-2020-3",
      "sha256": "ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 3 OF 2020"
    },
    "engine-v12-ui-final-ab345900-f64704a9df6e8c40": {
      "instrument_id": "lk-act-2014-18",
      "sha256": "f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY (AMENDMENT) ACT, No. 18 OF 2014"
    },
    "engine-v12-ui-final-ab345900-fb74b60e8c0dbccd": {
      "instrument_id": "lk-act-2008-33",
      "sha256": "fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY (AMENDMENT) ACT, No. 33 OF 2008"
    },
    "engine-v12-ui-final-ab345900-fe1ea4997df06af6": {
      "instrument_id": "lk-act-2007-45",
      "sha256": "fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef",
      "title": "FINANCE (AMENDMENT) ACT, NO. 45 OF 2007"
    },
    "engine-v5-038fce99adb29b52": {
      "instrument_id": "lk-act-2018-35",
      "sha256": "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7",
      "title": "FINANCE ACT, No. 35 OF 2018"
    },
    "engine-v5-08303ae9f5fa3082": {
      "instrument_id": "lk-act-2018-12",
      "sha256": "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 12 OF 2018"
    },
    "engine-v5-0d908137412311ad": {
      "instrument_id": "lk-act-2019-20",
      "sha256": "9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2019"
    },
    "engine-v5-10df115f0c104eef": {
      "instrument_id": "lk-act-2016-4",
      "sha256": "10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 4 OF 2016"
    },
    "engine-v5-15a38c5892d864b3": {
      "instrument_id": "lk-act-2013-8",
      "sha256": "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 8 OF 2013"
    },
    "engine-v5-2c83dc5b0edbf1e8": {
      "instrument_id": "lk-act-2022-6",
      "sha256": "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) (AMENDMENT) ACT, No. 6 OF 2022"
    },
    "engine-v5-2cec4c3f6fea90c0": {
      "instrument_id": "lk-act-2017-3",
      "sha256": "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 3 OF 2017"
    },
    "engine-v5-3c899d6dad3585c8": {
      "instrument_id": "lk-act-2010-14",
      "sha256": "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558",
      "title": "CIVIL AVIATION ACT, No. 14 OF 2010"
    },
    "engine-v5-3d8d0dc5d494c5ed": {
      "instrument_id": "lk-act-2016-21",
      "sha256": "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 21 OF 2016"
    },
    "engine-v5-4041a8ef167eb084": {
      "instrument_id": "lk-act-2011-13",
      "sha256": "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) ACT, No. 13 OF 2011"
    },
    "engine-v5-418781f54cdfd082": {
      "instrument_id": "lk-act-2013-5",
      "sha256": "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2013"
    },
    "engine-v5-43e8c4dc7e4ca1a3": {
      "instrument_id": "lk-act-2014-10",
      "sha256": "fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2014"
    },
    "engine-v5-52d986f40394d4c4": {
      "instrument_id": "lk-act-2017-9",
      "sha256": "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) (AMENDMENT) ACT, No. 9 OF 2017"
    },
    "engine-v5-540977e80ed06d0c": {
      "instrument_id": "lk-act-2011-10",
      "sha256": "902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 10 OF 2011"
    },
    "engine-v5-5604933fce046827": {
      "instrument_id": "lk-act-2017-13",
      "sha256": "03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 13 OF 2017"
    },
    "engine-v5-616ac68a0a7889f1": {
      "instrument_id": "lk-act-2020-5",
      "sha256": "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2020"
    },
    "engine-v5-6617b32ac9f373cc": {
      "instrument_id": "lk-act-2011-21",
      "sha256": "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117",
      "title": "TELECOMMUNICATION LEVY ACT, No. 21 OF 2011"
    },
    "engine-v5-7603f6d11a7efe52": {
      "instrument_id": "lk-act-2013-20",
      "sha256": "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, No. 20 OF 2013"
    },
    "engine-v5-7c5287361c3de3d1": {
      "instrument_id": "lk-act-2018-29",
      "sha256": "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288",
      "title": "CARRIAGE BY AIR ACT, No. 29 OF 2018"
    },
    "engine-v5-8dab62f83f4c88f4": {
      "instrument_id": "lk-act-2015-12",
      "sha256": "46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 12 OF 2015"
    },
    "engine-v5-954bf58b4d319712": {
      "instrument_id": "lk-act-2023-24",
      "sha256": "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 24 OF 2023"
    },
    "engine-v5-9c6a86c5e7eeb01c": {
      "instrument_id": "lk-act-2012-4",
      "sha256": "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, NO. 4 OF 2012"
    },
    "engine-v5-9f7a25495e980023": {
      "instrument_id": "lk-act-2011-18",
      "sha256": "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY ACT, No. 18 OF 2011"
    },
    "engine-v5-a3b3e391565b11ad": {
      "instrument_id": "lk-act-2012-10",
      "sha256": "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 10 OF 2012"
    },
    "engine-v5-a7805df36ec051e9": {
      "instrument_id": "lk-act-2016-14",
      "sha256": "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) ACT, No. 14 OF 2016"
    },
    "engine-v5-a98839990788e066": {
      "instrument_id": "lk-act-2011-23",
      "sha256": "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2",
      "title": "TAX APPEALS COMMISSION ACT, No. 23 OF 2011"
    },
    "engine-v5-af956197361b1759": {
      "instrument_id": "lk-act-2019-21",
      "sha256": "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb",
      "title": "FINANCE ACT, No. 21 OF 2019"
    },
    "engine-v5-b2df76a65c2d47ba": {
      "instrument_id": "lk-act-2023-33",
      "sha256": "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b",
      "title": "FINANCE ACT, No. 33 OF 2023"
    },
    "engine-v5-b6a34344daa596f1": {
      "instrument_id": "lk-act-2009-32",
      "sha256": "0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 32 OF 2009"
    },
    "engine-v5-b85b87f48cd5826a": {
      "instrument_id": "lk-act-2023-8",
      "sha256": "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610",
      "title": "CARRIAGE BY AIR (AMENDMENT) ACT, No. 8 OF 2023"
    },
    "engine-v5-b8cdc6d11c2f4445": {
      "instrument_id": "lk-act-2009-9",
      "sha256": "1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56",
      "title": "NATION BUILDING TAX ACT, NO. 9 OF 2009"
    },
    "engine-v5-cdc3d36908929a0a": {
      "instrument_id": "lk-act-2014-38",
      "sha256": "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57",
      "title": "LAND (RESTRICTIONS ON ALIENATION) ACT, No. 38 OF 2014"
    },
    "engine-v5-d48b9922872a1b5d": {
      "instrument_id": "lk-act-2020-2",
      "sha256": "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c",
      "title": "FINANCE (AMENDMENT) ACT, No. 2 OF 2020"
    },
    "engine-v5-e07930075fecb0c6": {
      "instrument_id": "lk-act-2025-10",
      "sha256": "e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 10 OF 2025"
    },
    "engine-v5-e5c66a5c29d64edb": {
      "instrument_id": "lk-act-2012-9",
      "sha256": "917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT. No. 9 OF 2012"
    },
    "engine-v5-e9c25a8a1864ff0f": {
      "instrument_id": "lk-act-2014-11",
      "sha256": "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 11 OF 2014"
    },
    "engine-v5-e9c4c4a58ccd7a26": {
      "instrument_id": "lk-act-2016-22",
      "sha256": "5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 22 OF 2016"
    },
    "engine-v5-e9df7c60d5594c5d": {
      "instrument_id": "lk-act-2013-11",
      "sha256": "d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 11 OF 2013"
    },
    "engine-v5-ea252d114e78e690": {
      "instrument_id": "lk-act-2018-20",
      "sha256": "0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 20 OF 2018"
    },
    "engine-v5-f0bd7e658e651246": {
      "instrument_id": "lk-act-2018-21",
      "sha256": "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 21 OF 2018"
    },
    "engine-v5-f6238c841da14718": {
      "instrument_id": "lk-act-2020-3",
      "sha256": "ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7",
      "title": "NATION BUILDING TAX (AMENDMENT) ACT, No. 3 OF 2020"
    },
    "engine-v9-010eaa2e62ff4030": {
      "instrument_id": "lk-act-2025-26",
      "sha256": "010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 26 OF 2025"
    },
    "engine-v9-038fce99adb29b52": {
      "instrument_id": "lk-act-2018-35",
      "sha256": "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7",
      "title": "FINANCE ACT, No. 35 OF 2018"
    },
    "engine-v9-08303ae9f5fa3082": {
      "instrument_id": "lk-act-2018-12",
      "sha256": "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 12 OF 2018"
    },
    "engine-v9-0a2e020ab1a01498": {
      "instrument_id": "lk-act-2017-14",
      "sha256": "0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY (AMENDMENT) ACT, No. 14 OF 2017"
    },
    "engine-v9-11defaa0f2254736": {
      "instrument_id": "lk-act-2006-12",
      "sha256": "11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) ACT, No. 12 OF 2006"
    },
    "engine-v9-15a38c5892d864b3": {
      "instrument_id": "lk-act-2013-8",
      "sha256": "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 8 OF 2013"
    },
    "engine-v9-177df77d8625abca": {
      "instrument_id": "lk-act-2024-15",
      "sha256": "64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2024"
    },
    "engine-v9-1bbd3c02b957c261": {
      "instrument_id": "lk-act-2025-24",
      "sha256": "5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 24 OF 2025"
    },
    "engine-v9-24045391b4ecbcd3": {
      "instrument_id": "lk-act-2008-14",
      "sha256": "24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470",
      "title": "STRATEGIC DEVELOPMENT PROJECTS ACT, No. 14 OF 2008"
    },
    "engine-v9-24e8fa6345a290f4": {
      "instrument_id": "lk-act-2011-12",
      "sha256": "24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 12 OF 2011"
    },
    "engine-v9-283e1252ff238d03": {
      "instrument_id": "lk-act-2008-10",
      "sha256": "283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c",
      "title": "STAMP DUTY (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 10 OF 2008"
    },
    "engine-v9-2c83dc5b0edbf1e8": {
      "instrument_id": "lk-act-2022-6",
      "sha256": "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) (AMENDMENT) ACT, No. 6 OF 2022"
    },
    "engine-v9-2cec4c3f6fea90c0": {
      "instrument_id": "lk-act-2017-3",
      "sha256": "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 3 OF 2017"
    },
    "engine-v9-340852bc820f0054": {
      "instrument_id": "lk-act-2013-16",
      "sha256": "340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029",
      "title": "STRATEGIC DEVELOPMENT PROJECTS (AMENDMENT) ACT, No. 16 OF 2013"
    },
    "engine-v9-3706ee7993257c74": {
      "instrument_id": "lk-act-2007-55",
      "sha256": "3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) ACT, No. 55 OF 2007"
    },
    "engine-v9-3ad87b14401803d4": {
      "instrument_id": "lk-act-2021-16",
      "sha256": "9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 16 OF 2021"
    },
    "engine-v9-3c899d6dad3585c8": {
      "instrument_id": "lk-act-2010-14",
      "sha256": "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558",
      "title": "CIVIL AVIATION ACT, No. 14 OF 2010"
    },
    "engine-v9-3d8d0dc5d494c5ed": {
      "instrument_id": "lk-act-2016-21",
      "sha256": "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 21 OF 2016"
    },
    "engine-v9-3e6289785b5d2ace": {
      "instrument_id": "lk-act-2025-11",
      "sha256": "f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS (AMENDMENT) ACT, No. 11 OF 2025"
    },
    "engine-v9-4041a8ef167eb084": {
      "instrument_id": "lk-act-2011-13",
      "sha256": "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc",
      "title": "PROVINCIAL COUNCILS (TRANSFER OF STAMP DUTY) ACT, No. 13 OF 2011"
    },
    "engine-v9-418781f54cdfd082": {
      "instrument_id": "lk-act-2013-5",
      "sha256": "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2013"
    },
    "engine-v9-48e79ad5c5ebdff5": {
      "instrument_id": "lk-act-1999-54",
      "sha256": "48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7",
      "title": "RANA VIRU SEVA AUTHORITY ACT, No. 54 OF 1999"
    },
    "engine-v9-4ff365ba7583281e": {
      "instrument_id": "lk-act-2016-3",
      "sha256": "357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1",
      "title": "NATIONAL MINIMUM WAGE OF WORKERS ACT, No. 3 OF 2016"
    },
    "engine-v9-52d986f40394d4c4": {
      "instrument_id": "lk-act-2017-9",
      "sha256": "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) (AMENDMENT) ACT, No. 9 OF 2017"
    },
    "engine-v9-55de35382c0b1fd0": {
      "instrument_id": "lk-act-2012-20",
      "sha256": "55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 20 OF 2012"
    },
    "engine-v9-565a4f3edcbaec3d": {
      "instrument_id": "lk-act-2003-27",
      "sha256": "565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY ACT, No. 27 OF 2003"
    },
    "engine-v9-581d20f6abcc200b": {
      "instrument_id": "lk-act-1999-17",
      "sha256": "581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7",
      "title": "SUGATHADASA NATIONAL SPORTS COMPLEX AUTHORITY ACT, No. 17 OF 1999"
    },
    "engine-v9-616ac68a0a7889f1": {
      "instrument_id": "lk-act-2020-5",
      "sha256": "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 5 OF 2020"
    },
    "engine-v9-627abbb7b65581a2": {
      "instrument_id": "lk-act-2013-10",
      "sha256": "627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd",
      "title": "RESETTLEMENT AUTHORITY (AMENDMENT) ACT, No. 10 OF 2013"
    },
    "engine-v9-6617b32ac9f373cc": {
      "instrument_id": "lk-act-2011-21",
      "sha256": "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117",
      "title": "TELECOMMUNICATION LEVY ACT, No. 21 OF 2011"
    },
    "engine-v9-738cfe3bea7f3f93": {
      "instrument_id": "lk-act-2006-17",
      "sha256": "738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY ACT, No. 17 OF 2006"
    },
    "engine-v9-749a9d200f6b438d": {
      "instrument_id": "lk-act-2005-36",
      "sha256": "749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS ACT, No. 36 OF 2005"
    },
    "engine-v9-7603f6d11a7efe52": {
      "instrument_id": "lk-act-2013-20",
      "sha256": "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, No. 20 OF 2013"
    },
    "engine-v9-7c5287361c3de3d1": {
      "instrument_id": "lk-act-2018-29",
      "sha256": "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288",
      "title": "CARRIAGE BY AIR ACT, No. 29 OF 2018"
    },
    "engine-v9-7de4ec283f8bc6bf": {
      "instrument_id": "lk-act-2022-25",
      "sha256": "6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY ACT, No. 25 OF 2022"
    },
    "engine-v9-82a9bf4bbcf40c3b": {
      "instrument_id": "lk-act-2007-48",
      "sha256": "82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155",
      "title": "SPECIAL COMMODITY LEVY ACT, No. 48 OF 2007"
    },
    "engine-v9-8788c9db433b33a7": {
      "instrument_id": "lk-act-2003-35",
      "sha256": "8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN ACT, No. 35 OF 2003"
    },
    "engine-v9-954bf58b4d319712": {
      "instrument_id": "lk-act-2023-24",
      "sha256": "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21",
      "title": "CIVIL AVIATION (AMENDMENT) ACT, No. 24 OF 2023"
    },
    "engine-v9-9afda3b1ee76364d": {
      "instrument_id": "lk-act-2008-12",
      "sha256": "9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 12 OF 2008"
    },
    "engine-v9-9c6a86c5e7eeb01c": {
      "instrument_id": "lk-act-2012-4",
      "sha256": "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe",
      "title": "TAX APPEALS COMMISSION (AMENDMENT) ACT, NO. 4 OF 2012"
    },
    "engine-v9-9f7a25495e980023": {
      "instrument_id": "lk-act-2011-18",
      "sha256": "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY ACT, No. 18 OF 2011"
    },
    "engine-v9-a05af5a077184a5f": {
      "instrument_id": "lk-act-2022-27",
      "sha256": "a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) (AMENDMENT) ACT, No. 27 OF 2022"
    },
    "engine-v9-a3b3e391565b11ad": {
      "instrument_id": "lk-act-2012-10",
      "sha256": "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47",
      "title": "PORTS AND AIRPORTS DEVELOPMENT LEVY (AMENDMENT) ACT, No. 10 OF 2012"
    },
    "engine-v9-a46c7fda815b7525": {
      "instrument_id": "lk-act-2009-6",
      "sha256": "a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2",
      "title": "GRANT OF CITIZENSHIP TO PERSONS OF INDIAN ORIGIN (AMENDMENT) ACT, No. 6 OF 2009"
    },
    "engine-v9-a7805df36ec051e9": {
      "instrument_id": "lk-act-2016-14",
      "sha256": "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2",
      "title": "OFFICE ON MISSING PERSONS (ESTABLISHMENT, ADMINISTRATION AND DISCHARGE OF FUNCTIONS) ACT, No. 14 OF 2016"
    },
    "engine-v9-a98839990788e066": {
      "instrument_id": "lk-act-2011-23",
      "sha256": "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2",
      "title": "TAX APPEALS COMMISSION ACT, No. 23 OF 2011"
    },
    "engine-v9-af71306c92055221": {
      "instrument_id": "lk-act-2014-12",
      "sha256": "af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b",
      "title": "SPECIAL COMMODITY LEVY (AMENDMENT) ACT, No. 12 OF 2014"
    },
    "engine-v9-af956197361b1759": {
      "instrument_id": "lk-act-2019-21",
      "sha256": "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb",
      "title": "FINANCE ACT, No. 21 OF 2019"
    },
    "engine-v9-b2df76a65c2d47ba": {
      "instrument_id": "lk-act-2023-33",
      "sha256": "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b",
      "title": "FINANCE ACT, No. 33 OF 2023"
    },
    "engine-v9-b85b87f48cd5826a": {
      "instrument_id": "lk-act-2023-8",
      "sha256": "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610",
      "title": "CARRIAGE BY AIR (AMENDMENT) ACT, No. 8 OF 2023"
    },
    "engine-v9-bbcc48aefa8b7821": {
      "instrument_id": "lk-act-2006-51",
      "sha256": "bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY ACT, NO. 51 OF 2006"
    },
    "engine-v9-bcea2bdb1dab3d9a": {
      "instrument_id": "lk-act-2023-15",
      "sha256": "f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 15 OF 2023"
    },
    "engine-v9-c76b30a6c00f7c88": {
      "instrument_id": "lk-act-2009-7",
      "sha256": "c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42",
      "title": "RANAVIRU SEVA AUTHORITY (AMENDMENT) ACT, No. 7 OF 2009"
    },
    "engine-v9-cac167d4a6c44875": {
      "instrument_id": "lk-act-2009-30",
      "sha256": "cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c",
      "title": "LOCAL AUTHORITIES (SPECIAL PROVISIONS) (AMENDMENT) ACT, NO. 30 OF 2009"
    },
    "engine-v9-cdc3d36908929a0a": {
      "instrument_id": "lk-act-2014-38",
      "sha256": "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57",
      "title": "LAND (RESTRICTIONS ON ALIENATION) ACT, No. 38 OF 2014"
    },
    "engine-v9-d0919c7e899414c7": {
      "instrument_id": "lk-act-2026-10",
      "sha256": "5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160",
      "title": "SOCIAL SECURITY CONTRIBUTION LEVY (AMENDMENT) ACT, No. 10 OF 2026"
    },
    "engine-v9-d48b9922872a1b5d": {
      "instrument_id": "lk-act-2020-2",
      "sha256": "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c",
      "title": "FINANCE (AMENDMENT) ACT, No. 2 OF 2020"
    },
    "engine-v9-d55bbb7be0bd4556": {
      "instrument_id": "lk-act-2002-33",
      "sha256": "d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac",
      "title": "PETROLEUM PRODUCTS (SPECIAL PROVISIONS) ACT, No. 33 OF 2002"
    },
    "engine-v9-dd75ecf4f046bb27": {
      "instrument_id": "lk-act-2007-9",
      "sha256": "dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db",
      "title": "RESETTLEMENT AUTHORITY ACT, NO. 09 OF 2007"
    },
    "engine-v9-e9c25a8a1864ff0f": {
      "instrument_id": "lk-act-2014-11",
      "sha256": "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a",
      "title": "TELECOMMUNICATION LEVY (AMENDMENT) ACT, No. 11 OF 2014"
    },
    "engine-v9-ee4575005a7a4d00": {
      "instrument_id": "lk-act-2025-9",
      "sha256": "ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b",
      "title": "BUDGETARY RELIEF ALLOWANCE OF WORKERS (AMENDMENT) ACT, No. 9 OF 2025"
    },
    "engine-v9-f0bd7e658e651246": {
      "instrument_id": "lk-act-2018-21",
      "sha256": "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb",
      "title": "LAND (RESTRICTIONS ON ALIENATION) (AMENDMENT) ACT, No. 21 OF 2018"
    },
    "engine-v9-f4f8e9bda1d04084": {
      "instrument_id": "lk-act-2007-47",
      "sha256": "f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e",
      "title": "REGIONAL INFRASTRUCTURE DEVELOPMENT LEVY (AMENDMENT) ACT, No. 47 OF 2007"
    },
    "engine-v9-f64704a9df6e8c40": {
      "instrument_id": "lk-act-2014-18",
      "sha256": "f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4",
      "title": "NATIONAL ENTERPRISE DEVELOPMENT AUTHORITY (AMENDMENT) ACT, No. 18 OF 2014"
    },
    "engine-v9-fb74b60e8c0dbccd": {
      "instrument_id": "lk-act-2008-33",
      "sha256": "fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098",
      "title": "INFORMATION AND COMMUNICATION TECHNOLOGY (AMENDMENT) ACT, No. 33 OF 2008"
    }
  },
  "engine_batch": "gold-v12-engine-ab345900ce34-37-families",
  "objects": {
    "0022ff30299c4239d96a1d9064e471d5847d9739882652bfa147434873e7ecc4": {
      "bytes": 73396,
      "filename": "14-2014_default-taxes-special-provisions-amendment_g5943.pdf",
      "key": "originals/0022ff30299c4239d96a1d9064e471d5847d9739882652bfa147434873e7ecc4.pdf",
      "pages": 18,
      "sources": [
        "original-pdfs/2010-16 default-taxes-special-provisions-act-no-16-of-2010/14-2014_default-taxes-special-provisions-amendment_g5943.pdf"
      ]
    },
    "010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e": {
      "bytes": 361519,
      "filename": "26-2025_010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e.pdf",
      "key": "originals/010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e.pdf",
      "pages": 10,
      "sources": [
        "original-pdfs/verified-v11/26-2025_010eaa2e62ff40300ae6198ef8ca73acf282a31808c2e2bacd761720f05cd57e.pdf"
      ]
    },
    "020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe": {
      "bytes": 57137,
      "filename": "11-2004_020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe.pdf",
      "key": "originals/020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe.pdf",
      "pages": 21,
      "sources": [
        "original-pdfs/verified-v11/11-2004_020691ed319c4e1b6a37b45176603f64503d9234553fc2a9a37d601d39bf56fe.pdf"
      ]
    },
    "0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb": {
      "bytes": 19367,
      "filename": "32-2009_0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb.pdf",
      "key": "originals/0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/32-2009_0322a813b0afc93687566e81d3eda72799b8e18978bd163df0ec95396ee23edb.pdf"
      ]
    },
    "03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696": {
      "bytes": 70613,
      "filename": "13-2017_03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696.pdf",
      "key": "originals/03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/13-2017_03711bb8c31196a598fe4fb7ae84ba956a64104d8b91edefb9b7829e47e91696.pdf"
      ]
    },
    "0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7": {
      "bytes": 72703,
      "filename": "7-2017_0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7.pdf",
      "key": "originals/0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7.pdf",
      "pages": 8,
      "sources": [
        "original-pdfs/verified-v11/7-2017_0484e30bd9beee744c4b61f8e9d856c7ba5c09c3041484096faa51f1c20532b7.pdf"
      ]
    },
    "06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e": {
      "bytes": 45594,
      "filename": "8-1999_06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e.pdf",
      "key": "originals/06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e.pdf",
      "pages": 16,
      "sources": [
        "original-pdfs/verified-v11/8-1999_06838282e43ff13b5bd853a2a138721746102ba16386f284a2004cc21ad2064e.pdf"
      ]
    },
    "08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7": {
      "bytes": 82134,
      "filename": "12-2018_08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7.pdf",
      "key": "originals/08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/12-2018_08303ae9f5fa30821fbe6e612ebc9a072f9904f5d2232fc4088ea66f257452b7.pdf"
      ]
    },
    "091be7eb1a4f5d9e4d7eace0fcbdd6d8e61172b4819d2183d7386754b8b11a6e": {
      "bytes": 31226,
      "filename": "12-2023_appropriation-amendment_g6304.pdf",
      "key": "originals/091be7eb1a4f5d9e4d7eace0fcbdd6d8e61172b4819d2183d7386754b8b11a6e.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/2022-43 appropriation-act-no-43-of-2022/12-2023_appropriation-amendment_g6304.pdf"
      ]
    },
    "0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae": {
      "bytes": 69549,
      "filename": "14-2017_0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae.pdf",
      "key": "originals/0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/14-2017_0a2e020ab1a014983bf0a1df34eaaa99ef53c66ebe3ce45e1ff0032fd51352ae.pdf"
      ]
    },
    "0bd7cd86dfcbeca22bd55b2ddfcab7820bbae3f1a5149059bbd250b58696e0b7": {
      "bytes": 294671,
      "filename": "14-2025_sri-lanka-electricity-amendment_g6385.pdf",
      "key": "originals/0bd7cd86dfcbeca22bd55b2ddfcab7820bbae3f1a5149059bbd250b58696e0b7.pdf",
      "pages": 38,
      "sources": [
        "original-pdfs/2024-36 sri-lanka-electricity-act-no-36-of-2024/14-2025_sri-lanka-electricity-amendment_g6385.pdf"
      ]
    },
    "0dff13924d408a621ce6dd01c2069c652c6a55be5740b897d145589454e5f7f8": {
      "bytes": 251441,
      "filename": "02-2025_inland-revenue-amendment_g6379.pdf",
      "key": "originals/0dff13924d408a621ce6dd01c2069c652c6a55be5740b897d145589454e5f7f8.pdf",
      "pages": 10,
      "sources": [
        "original-pdfs/2017-24 inland-revenue-act-no-24-of-2017/02-2025_inland-revenue-amendment_g6379.pdf"
      ]
    },
    "0e4274f31885d0848b3ec7a4ad26db98f10f192fbcfc896d2df1331df7aa962d": {
      "bytes": 142715,
      "filename": "01-2015_appropriation-amendment_g5968.pdf",
      "key": "originals/0e4274f31885d0848b3ec7a4ad26db98f10f192fbcfc896d2df1331df7aa962d.pdf",
      "pages": 48,
      "sources": [
        "original-pdfs/2014-41 appropriation-act-no-41-of-2014/01-2015_appropriation-amendment_g5968.pdf"
      ]
    },
    "0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583": {
      "bytes": 121515,
      "filename": "20-2018_0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583.pdf",
      "key": "originals/0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/20-2018_0eeb8ee972766623b3eb6e8fa5cb86a2d172fc5d46bdc80659d4c17e10bd5583.pdf"
      ]
    },
    "10cce8943e6cf0a2f5d8f2f2ad5d866fb365011bfe40ee0e3170fab79dd191d5": {
      "bytes": 253853,
      "filename": "01-2026_colombo-port-city-economic-commission-amendment_g6411.pdf",
      "key": "originals/10cce8943e6cf0a2f5d8f2f2ad5d866fb365011bfe40ee0e3170fab79dd191d5.pdf",
      "pages": 18,
      "sources": [
        "original-pdfs/2021-11 colombo-port-city-economic-commission-act-no-11-of-2021/01-2026_colombo-port-city-economic-commission-amendment_g6411.pdf"
      ]
    },
    "10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4": {
      "bytes": 87581,
      "filename": "4-2016_10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4.pdf",
      "key": "originals/10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4.pdf",
      "pages": 16,
      "sources": [
        "original-pdfs/verified-v11/4-2016_10df115f0c104eef01cce38eba9f61e5b40c35ad577ba918a7922c0498f8adb4.pdf"
      ]
    },
    "11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0": {
      "bytes": 30978,
      "filename": "12-2006_11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0.pdf",
      "key": "originals/11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0.pdf",
      "pages": 9,
      "sources": [
        "original-pdfs/verified-v11/12-2006_11defaa0f22547364647ac5b53c0484e03e5a171d29e1c4c201c707b17ed5fc0.pdf"
      ]
    },
    "15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245": {
      "bytes": 75501,
      "filename": "8-2013_15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245.pdf",
      "key": "originals/15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/8-2013_15a38c5892d864b3f73bf18a80979b9e90ecbb24bca59f45de93d9b88283b245.pdf"
      ]
    },
    "17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f": {
      "bytes": 21053,
      "filename": "13-2007_17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f.pdf",
      "key": "originals/17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/13-2007_17d2d1d251a59b6794dc2f690b70880b0213c9fa20d383bc479fb1adcce03e4f.pdf"
      ]
    },
    "1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56": {
      "bytes": 39081,
      "filename": "9-2009_1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56.pdf",
      "key": "originals/1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56.pdf",
      "pages": 13,
      "sources": [
        "original-pdfs/verified-v11/9-2009_1b278826ae06ac34fb14510538a577fc3edcef183103cc91eac8edea3f658c56.pdf"
      ]
    },
    "1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61": {
      "bytes": 73438,
      "filename": "3-2013_1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61.pdf",
      "key": "originals/1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/3-2013_1c611f654f4d202966074467874fd33112de5240b353bd5340f5691833f56a61.pdf"
      ]
    },
    "1d60c15ee7251e7214e630e894e148049e8c204e75ceb088b158c38f91cfd05c": {
      "bytes": 88285,
      "filename": "33-2013_convention-against-doping-in-sport_g5929.pdf",
      "key": "originals/1d60c15ee7251e7214e630e894e148049e8c204e75ceb088b158c38f91cfd05c.pdf",
      "pages": 25,
      "sources": [
        "original-pdfs/2013-33 convention-against-doping-in-sport-act-no-33-of-2013/33-2013_convention-against-doping-in-sport_g5929.pdf"
      ]
    },
    "23b1485cbf651508fd7ed93b3e80a61fb3e8816225b49abb75fc3caaa28a2a27": {
      "bytes": 208462,
      "filename": "45-2022_inland-revenue-amendment_g6282.pdf",
      "key": "originals/23b1485cbf651508fd7ed93b3e80a61fb3e8816225b49abb75fc3caaa28a2a27.pdf",
      "pages": 35,
      "sources": [
        "original-pdfs/2017-24 inland-revenue-act-no-24-of-2017/45-2022_inland-revenue-amendment_g6282.pdf"
      ]
    },
    "23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3": {
      "bytes": 64469,
      "filename": "21-2016_23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3.pdf",
      "key": "originals/23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/21-2016_23b274a0f53a718763aa6518be409369ab3e16a921c0a5aac9983b5ecbbcbed3.pdf"
      ]
    },
    "24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470": {
      "bytes": 20053,
      "filename": "14-2008_24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470.pdf",
      "key": "originals/24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/14-2008_24045391b4ecbcd33c0b72ef519d1a634c6bd604271bbd9a5da513d2764cd470.pdf"
      ]
    },
    "24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f": {
      "bytes": 16591,
      "filename": "12-2011_24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f.pdf",
      "key": "originals/24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/12-2011_24e8fa6345a290f4dae571bae8ae0a63c20bcd1d522396c390ca1b2627646d6f.pdf"
      ]
    },
    "283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c": {
      "bytes": 17461,
      "filename": "10-2008_283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c.pdf",
      "key": "originals/283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/10-2008_283e1252ff238d03616111671cbc7560c4821f7d6b952fcca845069461c5324c.pdf"
      ]
    },
    "28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a": {
      "bytes": 66284,
      "filename": "9-2014_28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a.pdf",
      "key": "originals/28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/9-2014_28acaf68eae337aa6b76a4ed8b257d04c674721fc28bb7cb7dd31791bdc8b84a.pdf"
      ]
    },
    "2a086eb2ab9b222f2f707486ef32436fe5a500ccd4e84530e38cb7aacdd476e2": {
      "bytes": 68327,
      "filename": "14-2023_inland-revenue-amendment_g6306.pdf",
      "key": "originals/2a086eb2ab9b222f2f707486ef32436fe5a500ccd4e84530e38cb7aacdd476e2.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/2017-24 inland-revenue-act-no-24-of-2017/14-2023_inland-revenue-amendment_g6306.pdf"
      ]
    },
    "2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d": {
      "bytes": 63233,
      "filename": "13-2016_2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d.pdf",
      "key": "originals/2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/13-2016_2b840f450fcd0d65252ec9636b669f3ebee9d297f6acb05e37cce07f86baa37d.pdf"
      ]
    },
    "2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f": {
      "bytes": 76785,
      "filename": "3-2017_2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f.pdf",
      "key": "originals/2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/3-2017_2cec4c3f6fea90c062d0fdaffab8d1fbfd6ba426c99a2ea2c98ea4c51d32d91f.pdf"
      ]
    },
    "2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2": {
      "bytes": 31556,
      "filename": "23-2011_2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2.pdf",
      "key": "originals/2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2.pdf",
      "pages": 9,
      "sources": [
        "original-pdfs/verified-v11/23-2011_2d9b80ff265c2979949dba1bc1f21e7cfea7c0fd915cc811bd6319bb55284cf2.pdf"
      ]
    },
    "2de5b0cb20ce47a74b1890e4d476b9e81d9c8435f9e688dbe0918f64674af6a6": {
      "bytes": 134773,
      "filename": "16-2022_sri-lanka-electricity-amendment_g6258.pdf",
      "key": "originals/2de5b0cb20ce47a74b1890e4d476b9e81d9c8435f9e688dbe0918f64674af6a6.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/2009-20 sri-lanka-electricity-act-no-20-of-2009/16-2022_sri-lanka-electricity-amendment_g6258.pdf"
      ]
    },
    "2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78": {
      "bytes": 90065,
      "filename": "13-2015_2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78.pdf",
      "key": "originals/2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/13-2015_2fab47e1fd8d492206caf60632b94e563fd0efce5b5909d0d19f8d7b544cce78.pdf"
      ]
    },
    "311fd0e1e5630c9dfe3b7ba5ea2dd9f7338426cb10aba3c4a5c3ea0fad7b79f9": {
      "bytes": 168069,
      "filename": "42-2023_appropriation-amendment_g6284.pdf",
      "key": "originals/311fd0e1e5630c9dfe3b7ba5ea2dd9f7338426cb10aba3c4a5c3ea0fad7b79f9.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/2021-30 appropriation-act-no-30-of-2021/42-2023_appropriation-amendment_g6284.pdf"
      ]
    },
    "3213ea269b3e92a8dab935f42e1c199d9308834401e3fa7a6f29f36f2cee2e7a": {
      "bytes": 71991,
      "filename": "09-2013_customs-amendment_g5898.pdf",
      "key": "originals/3213ea269b3e92a8dab935f42e1c199d9308834401e3fa7a6f29f36f2cee2e7a.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/2011-23 tax-appeals-commission-act-no-23-of-2011/09-2013_customs-amendment_g5898.pdf"
      ]
    },
    "340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029": {
      "bytes": 71859,
      "filename": "16-2013_340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029.pdf",
      "key": "originals/340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/16-2013_340852bc820f0054ecba3446844e958ec1d7705d0fa98e851a5bca8d8cdb2029.pdf"
      ]
    },
    "34ecd29d852227582fffa745d8d831411994e4a23b90fefae5a73a7c44261782": {
      "bytes": 171475,
      "filename": "36-2013_appropriation_g5930.pdf",
      "key": "originals/34ecd29d852227582fffa745d8d831411994e4a23b90fefae5a73a7c44261782.pdf",
      "pages": 56,
      "sources": [
        "original-pdfs/2013-36 appropriation-act-no-36-of-2013/36-2013_appropriation_g5930.pdf"
      ]
    },
    "357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1": {
      "bytes": 64171,
      "filename": "3-2016_357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1.pdf",
      "key": "originals/357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1.pdf",
      "pages": 12,
      "sources": [
        "original-pdfs/verified-v11/3-2016_357235fac383087649c79a32dfed1fe16cd6a036681ac1704b6dca37bffaf3d1.pdf"
      ]
    },
    "3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d": {
      "bytes": 21850,
      "filename": "55-2007_3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d.pdf",
      "key": "originals/3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/55-2007_3706ee7993257c74b6e145e7783c900d62eb8142d5ec102aefc89a2a047c569d.pdf"
      ]
    },
    "386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3": {
      "bytes": 41233,
      "filename": "7-2005_386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3.pdf",
      "key": "originals/386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3.pdf",
      "pages": 11,
      "sources": [
        "original-pdfs/verified-v11/7-2005_386743ac371b1e751b9ee2395d10f78a0f37098a7d77d38f5b4754d13af844a3.pdf"
      ]
    },
    "39e91bc3d51e983bd4d3cc4b79c07c484bec65d2f561334e8e3388443da474b7": {
      "bytes": 111254,
      "filename": "23-2016_appropriation-amendment_g6022.pdf",
      "key": "originals/39e91bc3d51e983bd4d3cc4b79c07c484bec65d2f561334e8e3388443da474b7.pdf",
      "pages": 33,
      "sources": [
        "original-pdfs/2015-16 appropriation-act-no-16-of-2015/23-2016_appropriation-amendment_g6022.pdf"
      ]
    },
    "3a22d8f76def0dab87b28aef68b6c2567e9a9f3a9c93f1aa7a16d413fc883952": {
      "bytes": 162563,
      "filename": "16-2015_appropriation_g5993.pdf",
      "key": "originals/3a22d8f76def0dab87b28aef68b6c2567e9a9f3a9c93f1aa7a16d413fc883952.pdf",
      "pages": 57,
      "sources": [
        "original-pdfs/2015-16 appropriation-act-no-16-of-2015/16-2015_appropriation_g5993.pdf"
      ]
    },
    "3a673819c4a6aa974618ca9506fb5a643674423b86879340ddea25481a43bc39": {
      "bytes": 160632,
      "filename": "24-2016_appropriation_g6029.pdf",
      "key": "originals/3a673819c4a6aa974618ca9506fb5a643674423b86879340ddea25481a43bc39.pdf",
      "pages": 59,
      "sources": [
        "original-pdfs/2016-24 appropriation-act-no-24-of-2016/24-2016_appropriation_g6029.pdf"
      ]
    },
    "3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb": {
      "bytes": 130841,
      "filename": "21-2019_3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb.pdf",
      "key": "originals/3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb.pdf",
      "pages": 11,
      "sources": [
        "original-pdfs/verified-v11/21-2019_3b1190b7cea087609ae9485687f576e093dc3eab84ed3240283501b303134deb.pdf"
      ]
    },
    "3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558": {
      "bytes": 205028,
      "filename": "14-2010_3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558.pdf",
      "key": "originals/3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558.pdf",
      "pages": 99,
      "sources": [
        "original-pdfs/verified-v11/14-2010_3c899d6dad3585c800ae9f6c22e15a9cea6891bf303e432e52cd97de0a634558.pdf"
      ]
    },
    "46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0": {
      "bytes": 80222,
      "filename": "12-2015_46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0.pdf",
      "key": "originals/46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0.pdf",
      "pages": 13,
      "sources": [
        "original-pdfs/verified-v11/12-2015_46c996d588eae237c2b61a3f05bc6f0d77af6d3d82effab7fd14deb2e5e555d0.pdf"
      ]
    },
    "47b5d55b761c920a79d2df71385d2c0dbdbeee118f787cfd4118dad3b67c47c8": {
      "bytes": 109789,
      "filename": "28-2023_anti-corruption-amendment_g6318.pdf",
      "key": "originals/47b5d55b761c920a79d2df71385d2c0dbdbeee118f787cfd4118dad3b67c47c8.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/2023-9 anti-corruption-act-no-9-of-2023/28-2023_anti-corruption-amendment_g6318.pdf"
      ]
    },
    "47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045": {
      "bytes": 37017,
      "filename": "15-2011_47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045.pdf",
      "key": "originals/47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045.pdf",
      "pages": 15,
      "sources": [
        "original-pdfs/verified-v11/15-2011_47c9fe736e85ea10d8d00376fa575374483a29825b8d4c8812ef388219bbc045.pdf"
      ]
    },
    "47d16ccba8e0c17df9164828cddf28541500edd469b5d2a02bc864c8d1d05cc0": {
      "bytes": 253121,
      "filename": "10-2021_inland-revenue-amendment_g6216.pdf",
      "key": "originals/47d16ccba8e0c17df9164828cddf28541500edd469b5d2a02bc864c8d1d05cc0.pdf",
      "pages": 71,
      "sources": [
        "original-pdfs/2017-24 inland-revenue-act-no-24-of-2017/10-2021_inland-revenue-amendment_g6216.pdf"
      ]
    },
    "48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7": {
      "bytes": 35970,
      "filename": "54-1999_48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7.pdf",
      "key": "originals/48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7.pdf",
      "pages": 12,
      "sources": [
        "original-pdfs/verified-v11/54-1999_48e79ad5c5ebdff59d9e318500607ed32ce045964bdd46da5394b1493197e5c7.pdf"
      ]
    },
    "4c6cb7794041b2eef98c663653ff7239331664d26d45463460b470e51b62fc84": {
      "bytes": 130307,
      "filename": "01-2013_divineguma_g5881.pdf",
      "key": "originals/4c6cb7794041b2eef98c663653ff7239331664d26d45463460b470e51b62fc84.pdf",
      "pages": 34,
      "sources": [
        "original-pdfs/2013-1 divineguma-act-no-1-of-2013/01-2013_divineguma_g5881.pdf"
      ]
    },
    "4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c": {
      "bytes": 118292,
      "filename": "33-2018_4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c.pdf",
      "key": "originals/4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/33-2018_4f2fcade80a8b194384139a3796a4ee58e2aa921fd048427cedfde6c0c3bd72c.pdf"
      ]
    },
    "505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e": {
      "bytes": 21263,
      "filename": "18-2009_505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e.pdf",
      "key": "originals/505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/18-2009_505c9b943b0a883a0538e6f546aacf972126418fb27fb6b06a3bfc2cba0f961e.pdf"
      ]
    },
    "516f123c5fa78e9778c1464f5a01b6b391d898a55ecc048d597d1e6bfc0438f5": {
      "bytes": 107333,
      "filename": "26-2021_appropriation-amendment_g6233.pdf",
      "key": "originals/516f123c5fa78e9778c1464f5a01b6b391d898a55ecc048d597d1e6bfc0438f5.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/2020-7 appropriation-act-no-7-of-2020/26-2021_appropriation-amendment_g6233.pdf"
      ]
    },
    "52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1": {
      "bytes": 97801,
      "filename": "4-2020_52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1.pdf",
      "key": "originals/52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/4-2020_52056495ca84b30f2a13c01e00dfa8388241e892e332ea12c769d5fa9ca11dd1.pdf"
      ]
    },
    "5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e": {
      "bytes": 72054,
      "filename": "22-2016_5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e.pdf",
      "key": "originals/5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e.pdf",
      "pages": 8,
      "sources": [
        "original-pdfs/verified-v11/22-2016_5243ad65cb81578b3d423a3d02aed792c8855fc1f4c88b765ff2f5a542d8416e.pdf"
      ]
    },
    "5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead": {
      "bytes": 349445,
      "filename": "24-2025_5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead.pdf",
      "key": "originals/5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/24-2025_5261dfdbbc4c9d7c7efa89b3731f9fbab007b47e2dd9f598346e45aeb0ea0ead.pdf"
      ]
    },
    "52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb": {
      "bytes": 46856,
      "filename": "9-2017_52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb.pdf",
      "key": "originals/52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/9-2017_52d986f40394d4c4a234b28752f747a4e3d79c3c0719a7907b83d838d22bf1eb.pdf"
      ]
    },
    "5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e": {
      "bytes": 46596,
      "filename": "5-2005_5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e.pdf",
      "key": "originals/5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e.pdf",
      "pages": 16,
      "sources": [
        "original-pdfs/verified-v11/5-2005_5470e4359f0e6f4be101820e27ca6b355ca6ce574a53161d4fe99e35d1b0726e.pdf"
      ]
    },
    "54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0": {
      "bytes": 67831,
      "filename": "15-2013_54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0.pdf",
      "key": "originals/54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/15-2013_54d614a9a98dcddea955625f7377328e22f5d548af9c97c7d6226bdbe4fdffd0.pdf"
      ]
    },
    "551071b042deb6a71b6fdb0f81d45dc1f3908c145943e3ffc5ee3a1c73cfcf49": {
      "bytes": 31163,
      "filename": "40-2009_society-of-structural-engineers-of-sri-lanka-incorporation_dup.pdf",
      "key": "originals/551071b042deb6a71b6fdb0f81d45dc1f3908c145943e3ffc5ee3a1c73cfcf49.pdf",
      "pages": 9,
      "sources": [
        "original-pdfs/2009-40 society-of-structural-engineers-of-sri-lanka-incorporation-act-no-40-of-2009/40-2009_society-of-structural-engineers-of-sri-lanka-incorporation_dup.pdf",
        "original-pdfs/2009-40 society-of-structural-engineers-of-sri-lanka-incorporation-act-no-40-of-2009/unknown_society-of-structural-engineers-sri-lanka-incorporation_dup.pdf"
      ]
    },
    "55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91": {
      "bytes": 71153,
      "filename": "20-2012_55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91.pdf",
      "key": "originals/55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/20-2012_55de35382c0b1fd0f14d648712dc7ec2a4bd7fe6a7810b14130287fec8783a91.pdf"
      ]
    },
    "565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86": {
      "bytes": 31435,
      "filename": "27-2003_565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86.pdf",
      "key": "originals/565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86.pdf",
      "pages": 9,
      "sources": [
        "original-pdfs/verified-v11/27-2003_565a4f3edcbaec3dcdc155617a25c3ccd5e38aec83bbaeb8ee74f06c83d76f86.pdf"
      ]
    },
    "581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7": {
      "bytes": 36284,
      "filename": "17-1999_581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7.pdf",
      "key": "originals/581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7.pdf",
      "pages": 12,
      "sources": [
        "original-pdfs/verified-v11/17-1999_581d20f6abcc200bbd5bd1c6c43de0cbebce6db4d756f202f4efe483a8e2d4d7.pdf"
      ]
    },
    "5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160": {
      "bytes": 301116,
      "filename": "10-2026_5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160.pdf",
      "key": "originals/5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/10-2026_5835db66e0ad2f4cbda93a9896940e049f7229fb145510e101bf412b8491d160.pdf"
      ]
    },
    "5b48e8f34cc5f42377b70ce0d29ad2cf702677cfa55349f7aed5b37978d47258": {
      "bytes": 139866,
      "filename": "04-2015_assistance-to-and-protection-of-victims-of-crime-and-witnesses_g5971.pdf",
      "key": "originals/5b48e8f34cc5f42377b70ce0d29ad2cf702677cfa55349f7aed5b37978d47258.pdf",
      "pages": 54,
      "sources": [
        "original-pdfs/2015-4 assistance-to-and-protection-of-victims-of-crime-and-witnesses-act-no-4-of-2015/04-2015_assistance-to-and-protection-of-victims-of-crime-and-witnesses_g5971.pdf"
      ]
    },
    "5ba86db3d7a11b6e01d95bcae916e9f17a1354a5a6d25c9de648d8f1e9add7b4": {
      "bytes": 97421,
      "filename": "10-2015_finance_g5988.pdf",
      "key": "originals/5ba86db3d7a11b6e01d95bcae916e9f17a1354a5a6d25c9de648d8f1e9add7b4.pdf",
      "pages": 21,
      "sources": [
        "original-pdfs/2015-10 finance-act-no-10-of-2015/10-2015_finance_g5988.pdf"
      ]
    },
    "5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1": {
      "bytes": 118516,
      "filename": "6-2022_5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1.pdf",
      "key": "originals/5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/6-2022_5f78dbbcdb91fb702fd8e27684da0dd88355a2c34d05a7aa8e810b3eed0c0af1.pdf"
      ]
    },
    "6186f402309b19987e2a0ff759e9085b369357b0230f5034b0a6523d72b9760e": {
      "bytes": 240773,
      "filename": "22-2025_personal-data-protection-amendment_g6384.pdf",
      "key": "originals/6186f402309b19987e2a0ff759e9085b369357b0230f5034b0a6523d72b9760e.pdf",
      "pages": 13,
      "sources": [
        "original-pdfs/2022-9 personal-data-protection-act-no-9-of-2022/22-2025_personal-data-protection-amendment_g6384.pdf"
      ]
    },
    "627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd": {
      "bytes": 71991,
      "filename": "10-2013_627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd.pdf",
      "key": "originals/627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/10-2013_627abbb7b65581a250e9363953a1f4a1b74a13a202d0895b1d88c5a022ba5bfd.pdf"
      ]
    },
    "63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b": {
      "bytes": 135136,
      "filename": "33-2023_63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b.pdf",
      "key": "originals/63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/33-2023_63361746547f271da141184d8999187b6185eced57bdf6ad898e7dc6dabfee1b.pdf"
      ]
    },
    "63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4": {
      "bytes": 30356,
      "filename": "11-2011_63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4.pdf",
      "key": "originals/63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/11-2011_63dbc7faff9ae2002124a9e3671604d8d9352b402e534256f2ebc3af0baee3a4.pdf"
      ]
    },
    "6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58": {
      "bytes": 248742,
      "filename": "25-2022_6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58.pdf",
      "key": "originals/6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58.pdf",
      "pages": 53,
      "sources": [
        "original-pdfs/verified-v11/25-2022_6448cefc00a9cc951dde7d921b03a887a137142225db917b9c11d2f3553f7f58.pdf"
      ]
    },
    "64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2": {
      "bytes": 129393,
      "filename": "15-2024_64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2.pdf",
      "key": "originals/64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/15-2024_64adfc3f5bac308926f92af55a2f6bbc4118d7e3e9e2c8b679e92894e7fd68b2.pdf"
      ]
    },
    "65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57": {
      "bytes": 45731,
      "filename": "15-2007_65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57.pdf",
      "key": "originals/65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57.pdf",
      "pages": 9,
      "sources": [
        "original-pdfs/verified-v11/15-2007_65ca8020951f93cda7e5f34602ad6aefc564935c6c79f37ebf60c81139761f57.pdf"
      ]
    },
    "6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117": {
      "bytes": 24103,
      "filename": "21-2011_6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117.pdf",
      "key": "originals/6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/21-2011_6617b32ac9f373cc70bd1692476cfe527e4fa0ee080ed4a294160880190cc117.pdf"
      ]
    },
    "66e2bef45624e3c5f50b8ca449ba61a99b8c93873c5bdac5fcd746beb744c8c0": {
      "bytes": 170383,
      "filename": "04-2023_inland-revenue-amendment_g6293.pdf",
      "key": "originals/66e2bef45624e3c5f50b8ca449ba61a99b8c93873c5bdac5fcd746beb744c8c0.pdf",
      "pages": 21,
      "sources": [
        "original-pdfs/2017-24 inland-revenue-act-no-24-of-2017/04-2023_inland-revenue-amendment_g6293.pdf"
      ]
    },
    "670e6c22c9f04e001588711609dcdf995ce0ee516f6396710012255ef929697d": {
      "bytes": 207626,
      "filename": "17-2024_secured-transactions_g6326.pdf",
      "key": "originals/670e6c22c9f04e001588711609dcdf995ce0ee516f6396710012255ef929697d.pdf",
      "pages": 60,
      "sources": [
        "original-pdfs/2009-49 secured-transactions-act-no-49-of-2009/17-2024_secured-transactions_g6326.pdf"
      ]
    },
    "67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba": {
      "bytes": 74950,
      "filename": "13-2012_67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba.pdf",
      "key": "originals/67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/13-2012_67a43366df903e385b5a30a365b38066e231800cef1fe593b29593846db28bba.pdf"
      ]
    },
    "68364f2c22fa25f5eb1c69566cb7211a1165847dea81343208ceaf461675db74": {
      "bytes": 114385,
      "filename": "47-2014_appropriation-amendment_g5967.pdf",
      "key": "originals/68364f2c22fa25f5eb1c69566cb7211a1165847dea81343208ceaf461675db74.pdf",
      "pages": 38,
      "sources": [
        "original-pdfs/2013-36 appropriation-act-no-36-of-2013/47-2014_appropriation-amendment_g5967.pdf"
      ]
    },
    "6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e": {
      "bytes": 53277,
      "filename": "3-2003_6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e.pdf",
      "key": "originals/6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e.pdf",
      "pages": 16,
      "sources": [
        "original-pdfs/verified-v11/3-2003_6aecc8d3e0a62312b6bcc49f0384742a0076b778e69d50cb40408eb8dcbebc8e.pdf"
      ]
    },
    "6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf": {
      "bytes": 26398,
      "filename": "11-2012_6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf.pdf",
      "key": "originals/6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/11-2012_6b75e3d7ebe56d2ccab5abb95e5542029b5ae878d8f9d69dbbe444182af01edf.pdf"
      ]
    },
    "6c6675f6f6c68c6c0307a68cd1333edfecccdebfa88e80408c6c31794a46ad3b": {
      "bytes": 199040,
      "filename": "15-2025_samurdhi-amendment_g6391.pdf",
      "key": "originals/6c6675f6f6c68c6c0307a68cd1333edfecccdebfa88e80408c6c31794a46ad3b.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/2013-1 divineguma-act-no-1-of-2013/15-2025_samurdhi-amendment_g6391.pdf"
      ]
    },
    "6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc": {
      "bytes": 38171,
      "filename": "13-2011_6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc.pdf",
      "key": "originals/6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/13-2011_6c841502fd62e1e73488daffaf93b95ce3e43465434588c462a5300094fae7bc.pdf"
      ]
    },
    "6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47": {
      "bytes": 74345,
      "filename": "10-2012_6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47.pdf",
      "key": "originals/6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/10-2012_6cb89fac96a283dfb30a2e40057ca035e99b2fcb01c30cdcd715ebcdef711c47.pdf"
      ]
    },
    "6d8bf23dc1bbf22b6b967479204d1171f65d19180c5a60fc3561d392c2fc7669": {
      "bytes": 99286,
      "filename": "16-2016_registration-of-deaths-temporary-provisions-amendment_g6018.pdf",
      "key": "originals/6d8bf23dc1bbf22b6b967479204d1171f65d19180c5a60fc3561d392c2fc7669.pdf",
      "pages": 20,
      "sources": [
        "original-pdfs/2010-19 registration-of-deaths-temporary-provisions-act-no-19-of-2010/16-2016_registration-of-deaths-temporary-provisions-amendment_g6018.pdf"
      ]
    },
    "6fcdf94fe219d9f7cd18c4790a2c6332568c65eb72846790480e65834012ef46": {
      "bytes": 159327,
      "filename": "09-2022_personal-data-protection_g6242.pdf",
      "key": "originals/6fcdf94fe219d9f7cd18c4790a2c6332568c65eb72846790480e65834012ef46.pdf",
      "pages": 65,
      "sources": [
        "original-pdfs/2022-9 personal-data-protection-act-no-9-of-2022/09-2022_personal-data-protection_g6242.pdf"
      ]
    },
    "71dff7e89010b5526c81917ea9c47358db9de55933dd5d173e5f22d13013e49c": {
      "bytes": 97558,
      "filename": "27-2017_assistance-to-and-protection-of-victims-of-crime-and-witnesses-amendment_g6047.pdf",
      "key": "originals/71dff7e89010b5526c81917ea9c47358db9de55933dd5d173e5f22d13013e49c.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/2015-4 assistance-to-and-protection-of-victims-of-crime-and-witnesses-act-no-4-of-2015/27-2017_assistance-to-and-protection-of-victims-of-crime-and-witnesses-amendment_g6047.pdf"
      ]
    },
    "726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50": {
      "bytes": 25118,
      "filename": "13-2009_726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50.pdf",
      "key": "originals/726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/13-2009_726b6e86023ab900d5a011011144ce24ea35036604ff86059f9c88a87f8c2b50.pdf"
      ]
    },
    "738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03": {
      "bytes": 55560,
      "filename": "17-2006_738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03.pdf",
      "key": "originals/738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03.pdf",
      "pages": 18,
      "sources": [
        "original-pdfs/verified-v11/17-2006_738cfe3bea7f3f935b987a4b252176c8ec87834ffad96e7f717359b0776f7e03.pdf"
      ]
    },
    "749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e": {
      "bytes": 33550,
      "filename": "36-2005_749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e.pdf",
      "key": "originals/749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e.pdf",
      "pages": 11,
      "sources": [
        "original-pdfs/verified-v11/36-2005_749a9d200f6b438d737f59b59026eb4d5912d4a11905af3f175c4f608971ca1e.pdf"
      ]
    },
    "7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288": {
      "bytes": 182136,
      "filename": "29-2018_7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288.pdf",
      "key": "originals/7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288.pdf",
      "pages": 27,
      "sources": [
        "original-pdfs/verified-v11/29-2018_7c5287361c3de3d13cce7a5d67d15c2bb632bf03865c0c2dd6a37600bbc3e288.pdf"
      ]
    },
    "7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab": {
      "bytes": 68888,
      "filename": "29-2013_7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab.pdf",
      "key": "originals/7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/29-2013_7c65a1d9b54f8188c6b9d8a3c414d26c8927119cc2d4086e67dca33cd7bb96ab.pdf"
      ]
    },
    "7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8": {
      "bytes": 99280,
      "filename": "5-2020_7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8.pdf",
      "key": "originals/7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/5-2020_7fd9345226b25bb97ac799736017993e99c241cc32bf6974fd427a1524f9a0b8.pdf"
      ]
    },
    "815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5": {
      "bytes": 73363,
      "filename": "6-2013_815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5.pdf",
      "key": "originals/815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/6-2013_815b132e5eab9c93f78dd9c3e8014f889093b7eefdf443dfc7900e22ee1834d5.pdf"
      ]
    },
    "82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155": {
      "bytes": 22740,
      "filename": "48-2007_82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155.pdf",
      "key": "originals/82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/48-2007_82a9bf4bbcf40c3bd7d04ab7a68e4850977296ec188a012f128d1150ee9ec155.pdf"
      ]
    },
    "8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376": {
      "bytes": 38946,
      "filename": "11-2006_8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376.pdf",
      "key": "originals/8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376.pdf",
      "pages": 12,
      "sources": [
        "original-pdfs/verified-v11/11-2006_8316b2609f3b2de55d8004cad921c597a5ddac5d57df94aa852ff82f42ead376.pdf"
      ]
    },
    "8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2": {
      "bytes": 1124516,
      "filename": "5-2008_8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2.pdf",
      "key": "originals/8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2.pdf",
      "pages": 18,
      "sources": [
        "original-pdfs/verified-v11/5-2008_8710db26120aeab60998f8998b754feb73e1dc2f48a34bf7ff4ccf08800c40f2.pdf"
      ]
    },
    "8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc": {
      "bytes": 24535,
      "filename": "35-2003_8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc.pdf",
      "key": "originals/8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc.pdf",
      "pages": 8,
      "sources": [
        "original-pdfs/verified-v11/35-2003_8788c9db433b33a7fd24ed2c8c8b10e2896cb7a70a9200d564659f4f1b997afc.pdf"
      ]
    },
    "902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310": {
      "bytes": 37561,
      "filename": "10-2011_902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310.pdf",
      "key": "originals/902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310.pdf",
      "pages": 16,
      "sources": [
        "original-pdfs/verified-v11/10-2011_902212128a6e8473a3e7273decd6d0e7d270f059d8de2ba1a263121a55ada310.pdf"
      ]
    },
    "90cb485a32d2b7ea8ad9e0d0012fbfeb416a46220d28fedbd144e764e3ea572e": {
      "bytes": 90956,
      "filename": "31-2013_sri-lanka-electricity-amendment_g5884.pdf",
      "key": "originals/90cb485a32d2b7ea8ad9e0d0012fbfeb416a46220d28fedbd144e764e3ea572e.pdf",
      "pages": 24,
      "sources": [
        "original-pdfs/2009-20 sri-lanka-electricity-act-no-20-of-2009/31-2013_sri-lanka-electricity-amendment_g5884.pdf"
      ]
    },
    "917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131": {
      "bytes": 26521,
      "filename": "9-2012_917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131.pdf",
      "key": "originals/917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131.pdf",
      "pages": 8,
      "sources": [
        "original-pdfs/verified-v11/9-2012_917bc80bea10eadf439f39f8e58f8fde7c0f17f500378792d0a4f18dd91ab131.pdf"
      ]
    },
    "91a223273adfe4a89540e7627833a4d923ddf16bdccff2f4b23904ca29b2f8de": {
      "bytes": 409237,
      "filename": "36-2024_sri-lanka-electricity_g6347.pdf",
      "key": "originals/91a223273adfe4a89540e7627833a4d923ddf16bdccff2f4b23904ca29b2f8de.pdf",
      "pages": 152,
      "sources": [
        "original-pdfs/2024-36 sri-lanka-electricity-act-no-36-of-2024/36-2024_sri-lanka-electricity_g6347.pdf"
      ]
    },
    "954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21": {
      "bytes": 118380,
      "filename": "24-2023_954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21.pdf",
      "key": "originals/954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/24-2023_954bf58b4d319712ba537dcb3a189bbadaa2c8b96853c01a5402cf78e0fd8d21.pdf"
      ]
    },
    "97f11ff4103a25c2290748e60d2cb7cf2ef95512710ad3fb7faa662f0ea69f3b": {
      "bytes": 165134,
      "filename": "20-2009_sri-lanka-electricity_g19.pdf",
      "key": "originals/97f11ff4103a25c2290748e60d2cb7cf2ef95512710ad3fb7faa662f0ea69f3b.pdf",
      "pages": 88,
      "sources": [
        "original-pdfs/2009-20 sri-lanka-electricity-act-no-20-of-2009/20-2009_sri-lanka-electricity_g19.pdf"
      ]
    },
    "9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab": {
      "bytes": 70404,
      "filename": "5-2013_9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab.pdf",
      "key": "originals/9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/5-2013_9901f30c28f205adb8bf547c63b11d738ef23d158bca629132dc8644fc1d35ab.pdf"
      ]
    },
    "9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3": {
      "bytes": 93509,
      "filename": "20-2013_9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3.pdf",
      "key": "originals/9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3.pdf",
      "pages": 15,
      "sources": [
        "original-pdfs/verified-v11/20-2013_9a7ac0ebf6b06357344768a3c6a1994b374c6dcba29559d56cff35d22a36cfd3.pdf"
      ]
    },
    "9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26": {
      "bytes": 132666,
      "filename": "16-2021_9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26.pdf",
      "key": "originals/9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/16-2021_9ab7170c8eab20a2acf4a4fa0e77c92435d6c6792c7c5666a98c9725e2344a26.pdf"
      ]
    },
    "9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74": {
      "bytes": 18181,
      "filename": "12-2008_9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74.pdf",
      "key": "originals/9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/12-2008_9afda3b1ee76364d600ae725b37f9432ffed935dbb8db74e029d5ea02ed5ff74.pdf"
      ]
    },
    "9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3": {
      "bytes": 94662,
      "filename": "12-2012_9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3.pdf",
      "key": "originals/9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3.pdf",
      "pages": 19,
      "sources": [
        "original-pdfs/verified-v11/12-2012_9b5df559fd4f729f94a00a801fe8dd8659c45f9608a3ea2e582fe16dc01cb6a3.pdf"
      ]
    },
    "9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885": {
      "bytes": 128255,
      "filename": "20-2019_9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885.pdf",
      "key": "originals/9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885.pdf",
      "pages": 9,
      "sources": [
        "original-pdfs/verified-v11/20-2019_9c130d07bfa3050d3968c7e888029ec8ab79fc8ef7bda76bcfc3de189c86e885.pdf"
      ]
    },
    "9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef": {
      "bytes": 26015,
      "filename": "16-2009_9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef.pdf",
      "key": "originals/9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/16-2009_9c193a8aa321127f239ff3590e2e9e6ce39185a8f0abc506942dd71d1710b3ef.pdf"
      ]
    },
    "9c814051dba88d137f36e99821c84c1e0ff6514baaa36a5c1a80e4acfa20326f": {
      "bytes": 160262,
      "filename": "41-2014_appropriation_g5961.pdf",
      "key": "originals/9c814051dba88d137f36e99821c84c1e0ff6514baaa36a5c1a80e4acfa20326f.pdf",
      "pages": 56,
      "sources": [
        "original-pdfs/2014-41 appropriation-act-no-41-of-2014/41-2014_appropriation_g5961.pdf"
      ]
    },
    "a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99": {
      "bytes": 126020,
      "filename": "27-2022_a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99.pdf",
      "key": "originals/a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99.pdf",
      "pages": 6,
      "sources": [
        "original-pdfs/verified-v11/27-2022_a05af5a077184a5f840352fc161b7c05d0ee4547545d7d556d46e9b8c5d54c99.pdf"
      ]
    },
    "a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2": {
      "bytes": 19643,
      "filename": "6-2009_a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2.pdf",
      "key": "originals/a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/6-2009_a46c7fda815b7525c29d339a042f61a0d0aba6b279fb90dfd95f1fe4e2a587e2.pdf"
      ]
    },
    "a606efeb4fad6ef6d400f79401d231f5fea55b97a9d14ce654658b93e4b3d102": {
      "bytes": 241820,
      "filename": "43-2022_appropriation_g6281.pdf",
      "key": "originals/a606efeb4fad6ef6d400f79401d231f5fea55b97a9d14ce654658b93e4b3d102.pdf",
      "pages": 51,
      "sources": [
        "original-pdfs/2022-43 appropriation-act-no-43-of-2022/43-2022_appropriation_g6281.pdf"
      ]
    },
    "a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f": {
      "bytes": 25680,
      "filename": "9-2004_a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f.pdf",
      "key": "originals/a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f.pdf",
      "pages": 8,
      "sources": [
        "original-pdfs/verified-v11/9-2004_a74b43534cfef9daf3169f94c820a5a3350ccc544c53375c559b51591e320b9f.pdf"
      ]
    },
    "a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2": {
      "bytes": 118044,
      "filename": "14-2016_a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2.pdf",
      "key": "originals/a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2.pdf",
      "pages": 24,
      "sources": [
        "original-pdfs/verified-v11/14-2016_a7805df36ec051e9351ab4c0c5868150190e6390a45c1fc48256523ef144d8f2.pdf"
      ]
    },
    "aaf10552e64d1c6c82d5e269ec1881894bc20b7d2a16a0aac8b8f364c8804123": {
      "bytes": 51118,
      "filename": "49-2009_secured-transactions_g2650.pdf",
      "key": "originals/aaf10552e64d1c6c82d5e269ec1881894bc20b7d2a16a0aac8b8f364c8804123.pdf",
      "pages": 20,
      "sources": [
        "original-pdfs/2009-49 secured-transactions-act-no-49-of-2009/49-2009_secured-transactions_g2650.pdf"
      ]
    },
    "af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b": {
      "bytes": 62784,
      "filename": "12-2014_af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b.pdf",
      "key": "originals/af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/12-2014_af71306c9205522164829b7323b711526050d82f5c9bea7246ac7e8b63c6147b.pdf"
      ]
    },
    "afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa": {
      "bytes": 21301,
      "filename": "37-2007_afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa.pdf",
      "key": "originals/afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/37-2007_afc60811205dc51604d70f0f428d997f51b510a4870dd7d948502c422fad17aa.pdf"
      ]
    },
    "b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610": {
      "bytes": 75716,
      "filename": "8-2023_b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610.pdf",
      "key": "originals/b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/8-2023_b85b87f48cd5826a329cfa36a07c623643e0a92f3bb6234c75323edfac4d9610.pdf"
      ]
    },
    "baaa7b0b69f4666447379e19218c8c8146dd20cf1cfa2254b2b921986a0e958f": {
      "bytes": 237334,
      "filename": "19-2018_national-audit_g6086.pdf",
      "key": "originals/baaa7b0b69f4666447379e19218c8c8146dd20cf1cfa2254b2b921986a0e958f.pdf",
      "pages": 47,
      "sources": [
        "original-pdfs/2018-19 national-audit-act-no-19-of-2018/19-2018_national-audit_g6086.pdf"
      ]
    },
    "bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4": {
      "bytes": 17270,
      "filename": "51-2006_bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4.pdf",
      "key": "originals/bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/51-2006_bbcc48aefa8b78213d4fb0821b3d91086509f9863dfcc2aa0b748a2344ead5a4.pdf"
      ]
    },
    "bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e": {
      "bytes": 94613,
      "filename": "12-2013_bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e.pdf",
      "key": "originals/bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e.pdf",
      "pages": 15,
      "sources": [
        "original-pdfs/verified-v11/12-2013_bf58648b0725d7a6ba896dedbe845a69f7d9515a3875f5771995267ec5c3b47e.pdf"
      ]
    },
    "c1d9303b2bbf9cb59399d427587c4feac6e59960a0af4f49724dc10d2d8bc5c5": {
      "bytes": 278766,
      "filename": "21-2022_appropriation-amendment_g6263.pdf",
      "key": "originals/c1d9303b2bbf9cb59399d427587c4feac6e59960a0af4f49724dc10d2d8bc5c5.pdf",
      "pages": 47,
      "sources": [
        "original-pdfs/2021-30 appropriation-act-no-30-of-2021/21-2022_appropriation-amendment_g6263.pdf"
      ]
    },
    "c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285": {
      "bytes": 26203,
      "filename": "18-2011_c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285.pdf",
      "key": "originals/c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285.pdf",
      "pages": 8,
      "sources": [
        "original-pdfs/verified-v11/18-2011_c2d5a84634d08011d5200cd23ca0e31d399f7bb1d3c9d8bc84bd7b483fe01285.pdf"
      ]
    },
    "c40546e9c80b55644fbc6f9c396726938744099074ded90ca0d3d44dbd70020d": {
      "bytes": 345938,
      "filename": "21-2025_convention-against-doping-in-sport-amendment_g6400.pdf",
      "key": "originals/c40546e9c80b55644fbc6f9c396726938744099074ded90ca0d3d44dbd70020d.pdf",
      "pages": 20,
      "sources": [
        "original-pdfs/2013-33 convention-against-doping-in-sport-act-no-33-of-2013/21-2025_convention-against-doping-in-sport-amendment_g6400.pdf"
      ]
    },
    "c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d": {
      "bytes": 41305,
      "filename": "13-2006_c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d.pdf",
      "key": "originals/c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d.pdf",
      "pages": 14,
      "sources": [
        "original-pdfs/verified-v11/13-2006_c65bfaf8558fda4a31966cbd1a6c11d206478c8d7f97799c885ee66c7e4e1a3d.pdf"
      ]
    },
    "c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42": {
      "bytes": 18612,
      "filename": "7-2009_c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42.pdf",
      "key": "originals/c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/7-2009_c76b30a6c00f7c888495c55b44ef67387fabef8b0be4046b96c9839cf86c0e42.pdf"
      ]
    },
    "c9bc9ec78180949cde56f05e9f3a3d3ad5d8b6be69b1d53a2772de6a0175be2d": {
      "bytes": 48802,
      "filename": "32-2017_appropriation-amendment_g6074.pdf",
      "key": "originals/c9bc9ec78180949cde56f05e9f3a3d3ad5d8b6be69b1d53a2772de6a0175be2d.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/2016-24 appropriation-act-no-24-of-2016/32-2017_appropriation-amendment_g6074.pdf"
      ]
    },
    "cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c": {
      "bytes": 21681,
      "filename": "30-2009_cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c.pdf",
      "key": "originals/cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/30-2009_cac167d4a6c448752685586d22c19ce115fb86e8c04bb7637c74d4cf1939a39c.pdf"
      ]
    },
    "cc964ec41b5f4fda097468e030a78f68e10982a6d20346861c5ba2d3137cbfd4": {
      "bytes": 153452,
      "filename": "15-2015_appropriation-amendment_g5998.pdf",
      "key": "originals/cc964ec41b5f4fda097468e030a78f68e10982a6d20346861c5ba2d3137cbfd4.pdf",
      "pages": 54,
      "sources": [
        "original-pdfs/2014-41 appropriation-act-no-41-of-2014/15-2015_appropriation-amendment_g5998.pdf"
      ]
    },
    "cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57": {
      "bytes": 97761,
      "filename": "38-2014_cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57.pdf",
      "key": "originals/cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57.pdf",
      "pages": 20,
      "sources": [
        "original-pdfs/verified-v11/38-2014_cdc3d36908929a0a89f2d8f477e1c1c85ef3ae5e8a50933b9f33b4c7a4940f57.pdf"
      ]
    },
    "cf2d04934e1ce24690238b7a024284458f12ee648f2b89650c05f3e1256008d8": {
      "bytes": 292152,
      "filename": "07-2020_appropriation_g6202.pdf",
      "key": "originals/cf2d04934e1ce24690238b7a024284458f12ee648f2b89650c05f3e1256008d8.pdf",
      "pages": 74,
      "sources": [
        "original-pdfs/2020-7 appropriation-act-no-7-of-2020/07-2020_appropriation_g6202.pdf"
      ]
    },
    "d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342": {
      "bytes": 77613,
      "filename": "11-2013_d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342.pdf",
      "key": "originals/d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/11-2013_d270a63a18acc594f5a11c29a20c7fe5e25361e06a5997c6dccb169e62738342.pdf"
      ]
    },
    "d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4": {
      "bytes": 15643,
      "filename": "7-2008_d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4.pdf",
      "key": "originals/d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/7-2008_d34778de42b67646bc43fe4ee535cd1f0659e4697848ff2be25c5489585dfaa4.pdf"
      ]
    },
    "d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac": {
      "bytes": 27029,
      "filename": "33-2002_d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac.pdf",
      "key": "originals/d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/33-2002_d55bbb7be0bd45560aa905795c927635afc57044577875416aec6c8f8565caac.pdf"
      ]
    },
    "d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242": {
      "bytes": 100888,
      "filename": "41-2011_d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242.pdf",
      "key": "originals/d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242.pdf",
      "pages": 19,
      "sources": [
        "original-pdfs/verified-v11/41-2011_d5655884e7890ad4da937bd9dc2aaa6dd3392cfd39d5d9884675321e97ac4242.pdf"
      ]
    },
    "d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e": {
      "bytes": 43809,
      "filename": "25-2005_d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e.pdf",
      "key": "originals/d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e.pdf",
      "pages": 13,
      "sources": [
        "original-pdfs/verified-v11/25-2005_d642e2c2ccc797a329262f4c7ffbfdfa462fd021a3b6cd6d7c01895c0544030e.pdf"
      ]
    },
    "d6912d813de4299052106328480f311aaf455e4d1ac5063ce7c197bb1b46fb38": {
      "bytes": 96689,
      "filename": "02-2017_divineguma-amendment_g6031.pdf",
      "key": "originals/d6912d813de4299052106328480f311aaf455e4d1ac5063ce7c197bb1b46fb38.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/2013-1 divineguma-act-no-1-of-2013/02-2017_divineguma-amendment_g6031.pdf"
      ]
    },
    "dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc": {
      "bytes": 100776,
      "filename": "12-2021_dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc.pdf",
      "key": "originals/dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/12-2021_dcda00b6755405a092cfc80af26e83eb9ce905d5b047e12c222eb4e99328f4cc.pdf"
      ]
    },
    "dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe": {
      "bytes": 25671,
      "filename": "4-2012_dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe.pdf",
      "key": "originals/dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe.pdf",
      "pages": 9,
      "sources": [
        "original-pdfs/verified-v11/4-2012_dd24a23e707fe8fbf753e782c61ead82145ccd81a81128208d5509b8eed54dfe.pdf"
      ]
    },
    "dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db": {
      "bytes": 40304,
      "filename": "9-2007_dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db.pdf",
      "key": "originals/dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db.pdf",
      "pages": 17,
      "sources": [
        "original-pdfs/verified-v11/9-2007_dd75ecf4f046bb2707f6f3d30a2d470e16d3edf17257d9cb01a96602e61937db.pdf"
      ]
    },
    "ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c": {
      "bytes": 95480,
      "filename": "2-2020_ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c.pdf",
      "key": "originals/ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/2-2020_ddbdc71e6df73ddfe02483e1345fd2497246440f564aa3e1d14d1865777fe57c.pdf"
      ]
    },
    "dfe257bf5318ebd05393758ccbc8ac2dfe4decc6182c60b35c6ca1ee6f45078d": {
      "bytes": 32718,
      "filename": "16-2010_default-taxes-special-provisions_g5816.pdf",
      "key": "originals/dfe257bf5318ebd05393758ccbc8ac2dfe4decc6182c60b35c6ca1ee6f45078d.pdf",
      "pages": 12,
      "sources": [
        "original-pdfs/2010-16 default-taxes-special-provisions-act-no-16-of-2010/16-2010_default-taxes-special-provisions_g5816.pdf"
      ]
    },
    "e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6": {
      "bytes": 191931,
      "filename": "10-2025_e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6.pdf",
      "key": "originals/e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/10-2025_e07930075fecb0c6b59d29a15185dcd52cb64a2a5289ac4a7763b07a92e9e2e6.pdf"
      ]
    },
    "e120cefa4050d07f1719d57ca48b517ea9c7c7b38c68c4ad9b347dbd12c5d4a2": {
      "bytes": 245256,
      "filename": "11-2021_colombo-port-city-economic-commission_g6218.pdf",
      "key": "originals/e120cefa4050d07f1719d57ca48b517ea9c7c7b38c68c4ad9b347dbd12c5d4a2.pdf",
      "pages": 76,
      "sources": [
        "original-pdfs/2021-11 colombo-port-city-economic-commission-act-no-11-of-2021/11-2021_colombo-port-city-economic-commission_g6218.pdf"
      ]
    },
    "e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb": {
      "bytes": 18781,
      "filename": "8-2008_e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb.pdf",
      "key": "originals/e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/8-2008_e1f6da4e727adb53168597b29208c7c9af642b6013c0646d97042b828c7137eb.pdf"
      ]
    },
    "e56ba3de0e6969db54a28fde1c8d8eab1311723130476d1bc1555e3b89602fed": {
      "bytes": 412031,
      "filename": "30-2021_appropriation_g6232.pdf",
      "key": "originals/e56ba3de0e6969db54a28fde1c8d8eab1311723130476d1bc1555e3b89602fed.pdf",
      "pages": 75,
      "sources": [
        "original-pdfs/2021-30 appropriation-act-no-30-of-2021/30-2021_appropriation_g6232.pdf"
      ]
    },
    "e6d40c137d383e88fee98fdf57b80c79b18e9563f9c0eeaff91a98bba8035530": {
      "bytes": 360761,
      "filename": "09-2023_anti-corruption_g6296.pdf",
      "key": "originals/e6d40c137d383e88fee98fdf57b80c79b18e9563f9c0eeaff91a98bba8035530.pdf",
      "pages": 154,
      "sources": [
        "original-pdfs/2023-9 anti-corruption-act-no-9-of-2023/09-2023_anti-corruption_g6296.pdf"
      ]
    },
    "e857f11ec026b424c4c8a5bc458f3fdd9cf1cca96e667b9a9bb80d8ccd972d77": {
      "bytes": 462104,
      "filename": "24-2017_inland-revenue_g6054.pdf",
      "key": "originals/e857f11ec026b424c4c8a5bc458f3fdd9cf1cca96e667b9a9bb80d8ccd972d77.pdf",
      "pages": 234,
      "sources": [
        "original-pdfs/2017-24 inland-revenue-act-no-24-of-2017/24-2017_inland-revenue_g6054.pdf"
      ]
    },
    "e9299c851e2f3cdc743576c298be43ca875782bdd96373c9c9a068a57888ecdb": {
      "bytes": 295571,
      "filename": "19-2025_national-audit-amendment_g6394.pdf",
      "key": "originals/e9299c851e2f3cdc743576c298be43ca875782bdd96373c9c9a068a57888ecdb.pdf",
      "pages": 18,
      "sources": [
        "original-pdfs/2018-19 national-audit-act-no-19-of-2018/19-2025_national-audit-amendment_g6394.pdf"
      ]
    },
    "e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a": {
      "bytes": 51062,
      "filename": "11-2014_e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a.pdf",
      "key": "originals/e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/11-2014_e9c25a8a1864ff0f0a5f9e42ae91f227187aa0e96835f592f5fb75cd562ea42a.pdf"
      ]
    },
    "ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5": {
      "bytes": 24115,
      "filename": "11-2008_ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5.pdf",
      "key": "originals/ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/11-2008_ea155b19391a469d72586027402b0d364accca519d83cc363e35326669f6e3f5.pdf"
      ]
    },
    "ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b": {
      "bytes": 280234,
      "filename": "9-2025_ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b.pdf",
      "key": "originals/ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/9-2025_ee4575005a7a4d00092f392653f7cf9d8b72a860eb147c9d78d2f18079bcbe1b.pdf"
      ]
    },
    "ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7": {
      "bytes": 98652,
      "filename": "3-2020_ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7.pdf",
      "key": "originals/ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/3-2020_ee4f18629cf67bb146043ab38b79148bfa50a143759f5091945f5cb0315820c7.pdf"
      ]
    },
    "f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb": {
      "bytes": 115518,
      "filename": "21-2018_f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb.pdf",
      "key": "originals/f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb.pdf",
      "pages": 4,
      "sources": [
        "original-pdfs/verified-v11/21-2018_f0bd7e658e6512460a540b6d058635b15e5e85a2767ec72db536fe86609dafeb.pdf"
      ]
    },
    "f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3": {
      "bytes": 42181,
      "filename": "25-2003_f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3.pdf",
      "key": "originals/f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3.pdf",
      "pages": 11,
      "sources": [
        "original-pdfs/verified-v11/25-2003_f0e2d86e0272fb15c6ddfcfe1b9c9dfde8cc49bf032888fd28763038d11fcab3.pdf"
      ]
    },
    "f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9": {
      "bytes": 333135,
      "filename": "11-2025_f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9.pdf",
      "key": "originals/f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/11-2025_f225c61e7844299f5afc60dfd704e5fa27f6046d9fc3453e2442a6885e5b0ca9.pdf"
      ]
    },
    "f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac": {
      "bytes": 51293,
      "filename": "15-2023_f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac.pdf",
      "key": "originals/f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac.pdf",
      "pages": 5,
      "sources": [
        "original-pdfs/verified-v11/15-2023_f31c95b3d8dbc0ce3f61bb43831fa002f8305c68e307f0a34ccfe7147d8db6ac.pdf"
      ]
    },
    "f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e": {
      "bytes": 14987,
      "filename": "47-2007_f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e.pdf",
      "key": "originals/f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/47-2007_f4f8e9bda1d04084b552dbaf8caafe6f238c90a86fb426e2a7ae384072466e6e.pdf"
      ]
    },
    "f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7": {
      "bytes": 162667,
      "filename": "35-2018_f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7.pdf",
      "key": "originals/f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7.pdf",
      "pages": 24,
      "sources": [
        "original-pdfs/verified-v11/35-2018_f573acbc4e997188543b1b670dee74f9fdba620130a203eb4ed7c11e213ed9d7.pdf"
      ]
    },
    "f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4": {
      "bytes": 63635,
      "filename": "18-2014_f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4.pdf",
      "key": "originals/f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/18-2014_f64704a9df6e8c405b38c88c11c71b36f96801acbb0ba1060370679d2e9741c4.pdf"
      ]
    },
    "fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098": {
      "bytes": 27838,
      "filename": "33-2008_fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098.pdf",
      "key": "originals/fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098.pdf",
      "pages": 8,
      "sources": [
        "original-pdfs/verified-v11/33-2008_fb74b60e8c0dbccd5e41858c25b7e36ca15dd16f5d8364ee5a282f455e897098.pdf"
      ]
    },
    "fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56": {
      "bytes": 70650,
      "filename": "10-2014_fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56.pdf",
      "key": "originals/fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56.pdf",
      "pages": 7,
      "sources": [
        "original-pdfs/verified-v11/10-2014_fcceb645ca0d258213170468ef8db62f51f588407e265a04d7fded513ea7cc56.pdf"
      ]
    },
    "fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef": {
      "bytes": 14190,
      "filename": "45-2007_fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef.pdf",
      "key": "originals/fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef.pdf",
      "pages": 3,
      "sources": [
        "original-pdfs/verified-v11/45-2007_fe1ea4997df06af665367d8215066fa1426afeec60aa9b2e339459065cecb3ef.pdf"
      ]
    },
    "ffcc1cece781b08303b5fdd690b5a94a1e0b0a1363c9452a5e9710cf9e8c0130": {
      "bytes": 42778,
      "filename": "19-2010_registration-of-deaths-temporary-provisions_g5811.pdf",
      "key": "originals/ffcc1cece781b08303b5fdd690b5a94a1e0b0a1363c9452a5e9710cf9e8c0130.pdf",
      "pages": 14,
      "sources": [
        "original-pdfs/2010-19 registration-of-deaths-temporary-provisions-act-no-19-of-2010/19-2010_registration-of-deaths-temporary-provisions_g5811.pdf"
      ]
    }
  },
  "schema": "slad-original-pdfs-v1",
  "source_commit": "31793f29a314a9d0b89e03cfbc1ada8b5b7b401c",
  "source_repository": "Sedlex-SL/manual-act-extraction",
  "versions": {
    "gold-v10-budgetary-relief-allowance-of-workers-2005-36-v0": "engine-v10-749a9d200f6b438d",
    "gold-v10-budgetary-relief-allowance-of-workers-2005-36-v1": "engine-v10-ee4575005a7a4d00",
    "gold-v10-budgetary-relief-allowance-of-workers-2016-4-v0": "engine-v10-10df115f0c104eef",
    "gold-v10-budgetary-relief-allowance-of-workers-2016-4-v1": "engine-v10-e07930075fecb0c6",
    "gold-v10-carriage-by-air-2018-29-v0": "engine-v10-7c5287361c3de3d1",
    "gold-v10-carriage-by-air-2018-29-v1": "engine-v10-b85b87f48cd5826a",
    "gold-v10-civil-aviation-2010-14-v0": "engine-v10-3c899d6dad3585c8",
    "gold-v10-civil-aviation-2010-14-v1": "engine-v10-08303ae9f5fa3082",
    "gold-v10-civil-aviation-2010-14-v2": "engine-v10-954bf58b4d319712",
    "gold-v10-convention-on-the-suppression-of-terrorist-financing-2005-25-v0": "engine-v10-d642e2c2ccc797a3",
    "gold-v10-convention-on-the-suppression-of-terrorist-financing-2005-25-v1": "engine-v10-d5655884e7890ad4",
    "gold-v10-convention-on-the-suppression-of-terrorist-financing-2005-25-v2": "engine-v10-1c611f654f4d2029",
    "gold-v10-defence-services-command-and-staff-college-2008-5-v0": "engine-v10-8710db26120aeab6",
    "gold-v10-defence-services-command-and-staff-college-2008-5-v1": "engine-v10-67a43366df903e38",
    "gold-v10-defence-services-command-and-staff-college-2008-5-v2": "engine-v10-7c65a1d9b54f8188",
    "gold-v10-finance-2012-12-v0": "engine-v10-9b5df559fd4f729f",
    "gold-v10-finance-2012-12-v1": "engine-v10-bf58648b0725d7a6",
    "gold-v10-finance-2012-12-v2": "engine-v10-038fce99adb29b52",
    "gold-v10-finance-2012-12-v3": "engine-v10-b2df76a65c2d47ba",
    "gold-v10-finance-2018-35-v0": "engine-v10-038fce99adb29b52",
    "gold-v10-finance-2018-35-v1": "engine-v10-af956197361b1759",
    "gold-v10-finance-2018-35-v2": "engine-v10-d48b9922872a1b5d",
    "gold-v10-finance-2018-35-v3": "engine-v10-b2df76a65c2d47ba",
    "gold-v10-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v0": "engine-v10-8788c9db433b33a7",
    "gold-v10-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v1": "engine-v10-a46c7fda815b7525",
    "gold-v10-information-and-communication-technology-2003-27-v0": "engine-v10-565a4f3edcbaec3d",
    "gold-v10-information-and-communication-technology-2003-27-v1": "engine-v10-fb74b60e8c0dbccd",
    "gold-v10-land-restrictions-on-alienation-2014-38-v0": "engine-v10-cdc3d36908929a0a",
    "gold-v10-land-restrictions-on-alienation-2014-38-v1": "engine-v10-2cec4c3f6fea90c0",
    "gold-v10-land-restrictions-on-alienation-2014-38-v2": "engine-v10-f0bd7e658e651246",
    "gold-v10-local-authorities-special-provisions-2007-55-v0": "engine-v10-3706ee7993257c74",
    "gold-v10-local-authorities-special-provisions-2007-55-v1": "engine-v10-cac167d4a6c44875",
    "gold-v10-nation-building-tax-2009-9-v0": "engine-v10-b8cdc6d11c2f4445",
    "gold-v10-nation-building-tax-2009-9-v1": "engine-v10-b6a34344daa596f1",
    "gold-v10-nation-building-tax-2009-9-v10": "engine-v10-0d908137412311ad",
    "gold-v10-nation-building-tax-2009-9-v11": "engine-v10-f6238c841da14718",
    "gold-v10-nation-building-tax-2009-9-v2": "engine-v10-540977e80ed06d0c",
    "gold-v10-nation-building-tax-2009-9-v3": "engine-v10-e5c66a5c29d64edb",
    "gold-v10-nation-building-tax-2009-9-v4": "engine-v10-e9df7c60d5594c5d",
    "gold-v10-nation-building-tax-2009-9-v5": "engine-v10-43e8c4dc7e4ca1a3",
    "gold-v10-nation-building-tax-2009-9-v6": "engine-v10-8dab62f83f4c88f4",
    "gold-v10-nation-building-tax-2009-9-v7": "engine-v10-e9c4c4a58ccd7a26",
    "gold-v10-nation-building-tax-2009-9-v8": "engine-v10-5604933fce046827",
    "gold-v10-nation-building-tax-2009-9-v9": "engine-v10-ea252d114e78e690",
    "gold-v10-national-enterprise-development-authority-2006-17-v0": "engine-v10-738cfe3bea7f3f93",
    "gold-v10-national-enterprise-development-authority-2006-17-v1": "engine-v10-f64704a9df6e8c40",
    "gold-v10-national-minimum-wage-of-workers-2016-3-v0": "engine-v10-4ff365ba7583281e",
    "gold-v10-national-minimum-wage-of-workers-2016-3-v1": "engine-v10-3ad87b14401803d4",
    "gold-v10-national-minimum-wage-of-workers-2016-3-v2": "engine-v10-3e6289785b5d2ace",
    "gold-v10-office-on-missing-persons-2016-14-v0": "engine-v10-a7805df36ec051e9",
    "gold-v10-office-on-missing-persons-2016-14-v1": "engine-v10-52d986f40394d4c4",
    "gold-v10-petroleum-products-special-provisions-2002-33-v0": "engine-v10-d55bbb7be0bd4556",
    "gold-v10-petroleum-products-special-provisions-2002-33-v1": "engine-v10-a05af5a077184a5f",
    "gold-v10-ports-and-airports-development-levy-2011-18-v0": "engine-v10-9f7a25495e980023",
    "gold-v10-ports-and-airports-development-levy-2011-18-v1": "engine-v10-a3b3e391565b11ad",
    "gold-v10-ports-and-airports-development-levy-2011-18-v2": "engine-v10-418781f54cdfd082",
    "gold-v10-ports-and-airports-development-levy-2011-18-v3": "engine-v10-3d8d0dc5d494c5ed",
    "gold-v10-ports-and-airports-development-levy-2011-18-v4": "engine-v10-616ac68a0a7889f1",
    "gold-v10-provincial-councils-transfer-of-stamp-duty-2011-13-v0": "engine-v10-4041a8ef167eb084",
    "gold-v10-provincial-councils-transfer-of-stamp-duty-2011-13-v1": "engine-v10-2c83dc5b0edbf1e8",
    "gold-v10-rana-viru-seva-authority-1999-54-v0": "engine-v10-48e79ad5c5ebdff5",
    "gold-v10-rana-viru-seva-authority-1999-54-v1": "engine-v10-c76b30a6c00f7c88",
    "gold-v10-rana-viru-seva-authority-1999-54-v2": "engine-v10-55de35382c0b1fd0",
    "gold-v10-regional-infrastructure-development-levy-2006-51-v0": "engine-v10-bbcc48aefa8b7821",
    "gold-v10-regional-infrastructure-development-levy-2006-51-v1": "engine-v10-f4f8e9bda1d04084",
    "gold-v10-regional-infrastructure-development-levy-2006-51-v2": "engine-v10-9afda3b1ee76364d",
    "gold-v10-resettlement-authority-2007-9-v0": "engine-v10-dd75ecf4f046bb27",
    "gold-v10-resettlement-authority-2007-9-v1": "engine-v10-627abbb7b65581a2",
    "gold-v10-social-security-contribution-levy-2022-25-v0": "engine-v10-7de4ec283f8bc6bf",
    "gold-v10-social-security-contribution-levy-2022-25-v1": "engine-v10-bcea2bdb1dab3d9a",
    "gold-v10-social-security-contribution-levy-2022-25-v2": "engine-v10-177df77d8625abca",
    "gold-v10-social-security-contribution-levy-2022-25-v3": "engine-v10-1bbd3c02b957c261",
    "gold-v10-social-security-contribution-levy-2022-25-v4": "engine-v10-d0919c7e899414c7",
    "gold-v10-special-commodity-levy-2007-48-v0": "engine-v10-82a9bf4bbcf40c3b",
    "gold-v10-special-commodity-levy-2007-48-v1": "engine-v10-af71306c92055221",
    "gold-v10-stamp-duty-special-provisions-2006-12-v0": "engine-v10-11defaa0f2254736",
    "gold-v10-stamp-duty-special-provisions-2006-12-v1": "engine-v10-283e1252ff238d03",
    "gold-v10-strategic-development-projects-2008-14-v0": "engine-v10-24045391b4ecbcd3",
    "gold-v10-strategic-development-projects-2008-14-v1": "engine-v10-24e8fa6345a290f4",
    "gold-v10-strategic-development-projects-2008-14-v2": "engine-v10-340852bc820f0054",
    "gold-v10-strategic-development-projects-2008-14-v3": "engine-v10-010eaa2e62ff4030",
    "gold-v10-sugathadasa-national-sports-complex-authority-1999-17-v0": "engine-v10-581d20f6abcc200b",
    "gold-v10-sugathadasa-national-sports-complex-authority-1999-17-v1": "engine-v10-0a2e020ab1a01498",
    "gold-v10-tax-appeals-commission-2011-23-v0": "engine-v10-a98839990788e066",
    "gold-v10-tax-appeals-commission-2011-23-v1": "engine-v10-9c6a86c5e7eeb01c",
    "gold-v10-tax-appeals-commission-2011-23-v2": "engine-v10-7603f6d11a7efe52",
    "gold-v10-telecommunication-levy-2011-21-v0": "engine-v10-6617b32ac9f373cc",
    "gold-v10-telecommunication-levy-2011-21-v1": "engine-v10-15a38c5892d864b3",
    "gold-v10-telecommunication-levy-2011-21-v2": "engine-v10-e9c25a8a1864ff0f",
    "gold-v11-budgetary-relief-allowance-of-workers-2005-36-v0": "engine-v11-749a9d200f6b438d",
    "gold-v11-budgetary-relief-allowance-of-workers-2005-36-v1": "engine-v11-ee4575005a7a4d00",
    "gold-v11-budgetary-relief-allowance-of-workers-2016-4-v0": "engine-v11-10df115f0c104eef",
    "gold-v11-budgetary-relief-allowance-of-workers-2016-4-v1": "engine-v11-e07930075fecb0c6",
    "gold-v11-carriage-by-air-2018-29-v0": "engine-v11-7c5287361c3de3d1",
    "gold-v11-carriage-by-air-2018-29-v1": "engine-v11-b85b87f48cd5826a",
    "gold-v11-civil-aviation-2010-14-v0": "engine-v11-3c899d6dad3585c8",
    "gold-v11-civil-aviation-2010-14-v1": "engine-v11-08303ae9f5fa3082",
    "gold-v11-civil-aviation-2010-14-v2": "engine-v11-954bf58b4d319712",
    "gold-v11-convention-on-the-suppression-of-terrorist-financing-2005-25-v0": "engine-v11-d642e2c2ccc797a3",
    "gold-v11-convention-on-the-suppression-of-terrorist-financing-2005-25-v1": "engine-v11-d5655884e7890ad4",
    "gold-v11-convention-on-the-suppression-of-terrorist-financing-2005-25-v2": "engine-v11-1c611f654f4d2029",
    "gold-v11-defence-services-command-and-staff-college-2008-5-v0": "engine-v11-8710db26120aeab6",
    "gold-v11-defence-services-command-and-staff-college-2008-5-v1": "engine-v11-67a43366df903e38",
    "gold-v11-defence-services-command-and-staff-college-2008-5-v2": "engine-v11-7c65a1d9b54f8188",
    "gold-v11-economic-service-charge-2006-13-v0": "engine-v11-c65bfaf8558fda4a",
    "gold-v11-economic-service-charge-2006-13-v1": "engine-v11-65ca8020951f93cd",
    "gold-v11-economic-service-charge-2006-13-v10": "engine-v11-4f2fcade80a8b194",
    "gold-v11-economic-service-charge-2006-13-v11": "engine-v11-52056495ca84b30f",
    "gold-v11-economic-service-charge-2006-13-v2": "engine-v11-ea155b19391a469d",
    "gold-v11-economic-service-charge-2006-13-v3": "engine-v11-9c193a8aa321127f",
    "gold-v11-economic-service-charge-2006-13-v4": "engine-v11-63dbc7faff9ae200",
    "gold-v11-economic-service-charge-2006-13-v5": "engine-v11-6b75e3d7ebe56d2c",
    "gold-v11-economic-service-charge-2006-13-v6": "engine-v11-815b132e5eab9c93",
    "gold-v11-economic-service-charge-2006-13-v7": "engine-v11-28acaf68eae337aa",
    "gold-v11-economic-service-charge-2006-13-v8": "engine-v11-2fab47e1fd8d4922",
    "gold-v11-economic-service-charge-2006-13-v9": "engine-v11-0484e30bd9beee74",
    "gold-v11-finance-2003-25-v0": "engine-v11-f0e2d86e0272fb15",
    "gold-v11-finance-2003-25-v1": "engine-v11-020691ed319c4e1b",
    "gold-v11-finance-2003-25-v2": "engine-v11-8316b2609f3b2de5",
    "gold-v11-finance-2003-25-v3": "engine-v11-47c9fe736e85ea10",
    "gold-v11-finance-2003-25-v4": "engine-v11-9b5df559fd4f729f",
    "gold-v11-finance-2003-25-v5": "engine-v11-bf58648b0725d7a6",
    "gold-v11-finance-2003-25-v6": "engine-v11-038fce99adb29b52",
    "gold-v11-finance-2004-11-v0": "engine-v11-020691ed319c4e1b",
    "gold-v11-finance-2004-11-v1": "engine-v11-386743ac371b1e75",
    "gold-v11-finance-2004-11-v2": "engine-v11-c65bfaf8558fda4a",
    "gold-v11-finance-2004-11-v3": "engine-v11-afc60811205dc516",
    "gold-v11-finance-2004-11-v4": "engine-v11-d34778de42b67646",
    "gold-v11-finance-2004-11-v5": "engine-v11-726b6e86023ab900",
    "gold-v11-finance-2004-11-v6": "engine-v11-9b5df559fd4f729f",
    "gold-v11-finance-2005-5-v0": "engine-v11-5470e4359f0e6f4b",
    "gold-v11-finance-2005-5-v1": "engine-v11-8316b2609f3b2de5",
    "gold-v11-finance-2005-5-v2": "engine-v11-17d2d1d251a59b67",
    "gold-v11-finance-2005-5-v3": "engine-v11-fe1ea4997df06af6",
    "gold-v11-finance-2005-5-v4": "engine-v11-e1f6da4e727adb53",
    "gold-v11-finance-2005-5-v5": "engine-v11-505c9b943b0a883a",
    "gold-v11-finance-2005-5-v6": "engine-v11-47c9fe736e85ea10",
    "gold-v11-finance-2005-5-v7": "engine-v11-038fce99adb29b52",
    "gold-v11-finance-2006-11-v0": "engine-v11-8316b2609f3b2de5",
    "gold-v11-finance-2006-11-v1": "engine-v11-17d2d1d251a59b67",
    "gold-v11-finance-2006-11-v2": "engine-v11-47c9fe736e85ea10",
    "gold-v11-finance-2012-12-v0": "engine-v11-9b5df559fd4f729f",
    "gold-v11-finance-2012-12-v1": "engine-v11-bf58648b0725d7a6",
    "gold-v11-finance-2012-12-v2": "engine-v11-038fce99adb29b52",
    "gold-v11-finance-2012-12-v3": "engine-v11-b2df76a65c2d47ba",
    "gold-v11-finance-2018-35-v0": "engine-v11-038fce99adb29b52",
    "gold-v11-finance-2018-35-v1": "engine-v11-af956197361b1759",
    "gold-v11-finance-2018-35-v2": "engine-v11-d48b9922872a1b5d",
    "gold-v11-finance-2018-35-v3": "engine-v11-b2df76a65c2d47ba",
    "gold-v11-fiscal-management-responsibility-2003-3-v0": "engine-v11-6aecc8d3e0a62312",
    "gold-v11-fiscal-management-responsibility-2003-3-v1": "engine-v11-54d614a9a98dcdde",
    "gold-v11-fiscal-management-responsibility-2003-3-v2": "engine-v11-2b840f450fcd0d65",
    "gold-v11-fiscal-management-responsibility-2003-3-v3": "engine-v11-dcda00b6755405a0",
    "gold-v11-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v0": "engine-v11-8788c9db433b33a7",
    "gold-v11-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v1": "engine-v11-a46c7fda815b7525",
    "gold-v11-information-and-communication-technology-2003-27-v0": "engine-v11-565a4f3edcbaec3d",
    "gold-v11-information-and-communication-technology-2003-27-v1": "engine-v11-fb74b60e8c0dbccd",
    "gold-v11-land-restrictions-on-alienation-2014-38-v0": "engine-v11-cdc3d36908929a0a",
    "gold-v11-land-restrictions-on-alienation-2014-38-v1": "engine-v11-2cec4c3f6fea90c0",
    "gold-v11-land-restrictions-on-alienation-2014-38-v2": "engine-v11-f0bd7e658e651246",
    "gold-v11-local-authorities-special-provisions-2007-55-v0": "engine-v11-3706ee7993257c74",
    "gold-v11-local-authorities-special-provisions-2007-55-v1": "engine-v11-cac167d4a6c44875",
    "gold-v11-nation-building-tax-2009-9-v0": "engine-v11-b8cdc6d11c2f4445",
    "gold-v11-nation-building-tax-2009-9-v1": "engine-v11-b6a34344daa596f1",
    "gold-v11-nation-building-tax-2009-9-v10": "engine-v11-0d908137412311ad",
    "gold-v11-nation-building-tax-2009-9-v11": "engine-v11-f6238c841da14718",
    "gold-v11-nation-building-tax-2009-9-v2": "engine-v11-540977e80ed06d0c",
    "gold-v11-nation-building-tax-2009-9-v3": "engine-v11-e5c66a5c29d64edb",
    "gold-v11-nation-building-tax-2009-9-v4": "engine-v11-e9df7c60d5594c5d",
    "gold-v11-nation-building-tax-2009-9-v5": "engine-v11-43e8c4dc7e4ca1a3",
    "gold-v11-nation-building-tax-2009-9-v6": "engine-v11-8dab62f83f4c88f4",
    "gold-v11-nation-building-tax-2009-9-v7": "engine-v11-e9c4c4a58ccd7a26",
    "gold-v11-nation-building-tax-2009-9-v8": "engine-v11-5604933fce046827",
    "gold-v11-nation-building-tax-2009-9-v9": "engine-v11-ea252d114e78e690",
    "gold-v11-national-enterprise-development-authority-2006-17-v0": "engine-v11-738cfe3bea7f3f93",
    "gold-v11-national-enterprise-development-authority-2006-17-v1": "engine-v11-f64704a9df6e8c40",
    "gold-v11-national-minimum-wage-of-workers-2016-3-v0": "engine-v11-4ff365ba7583281e",
    "gold-v11-national-minimum-wage-of-workers-2016-3-v1": "engine-v11-3ad87b14401803d4",
    "gold-v11-national-minimum-wage-of-workers-2016-3-v2": "engine-v11-3e6289785b5d2ace",
    "gold-v11-office-on-missing-persons-2016-14-v0": "engine-v11-a7805df36ec051e9",
    "gold-v11-office-on-missing-persons-2016-14-v1": "engine-v11-52d986f40394d4c4",
    "gold-v11-petroleum-products-special-provisions-2002-33-v0": "engine-v11-d55bbb7be0bd4556",
    "gold-v11-petroleum-products-special-provisions-2002-33-v1": "engine-v11-a05af5a077184a5f",
    "gold-v11-ports-and-airports-development-levy-2011-18-v0": "engine-v11-9f7a25495e980023",
    "gold-v11-ports-and-airports-development-levy-2011-18-v1": "engine-v11-a3b3e391565b11ad",
    "gold-v11-ports-and-airports-development-levy-2011-18-v2": "engine-v11-418781f54cdfd082",
    "gold-v11-ports-and-airports-development-levy-2011-18-v3": "engine-v11-3d8d0dc5d494c5ed",
    "gold-v11-ports-and-airports-development-levy-2011-18-v4": "engine-v11-616ac68a0a7889f1",
    "gold-v11-provincial-councils-transfer-of-stamp-duty-2011-13-v0": "engine-v11-4041a8ef167eb084",
    "gold-v11-provincial-councils-transfer-of-stamp-duty-2011-13-v1": "engine-v11-2c83dc5b0edbf1e8",
    "gold-v11-rana-viru-seva-authority-1999-54-v0": "engine-v11-48e79ad5c5ebdff5",
    "gold-v11-rana-viru-seva-authority-1999-54-v1": "engine-v11-c76b30a6c00f7c88",
    "gold-v11-rana-viru-seva-authority-1999-54-v2": "engine-v11-55de35382c0b1fd0",
    "gold-v11-reconciled-4c016154ebbe-budgetary-relief-allowance-of-workers-2005-36-v0": "engine-v11-reconciled-4c016154ebbe-749a9d200f6b438d",
    "gold-v11-reconciled-4c016154ebbe-budgetary-relief-allowance-of-workers-2005-36-v1": "engine-v11-reconciled-4c016154ebbe-ee4575005a7a4d00",
    "gold-v11-reconciled-4c016154ebbe-budgetary-relief-allowance-of-workers-2016-4-v0": "engine-v11-reconciled-4c016154ebbe-10df115f0c104eef",
    "gold-v11-reconciled-4c016154ebbe-budgetary-relief-allowance-of-workers-2016-4-v1": "engine-v11-reconciled-4c016154ebbe-e07930075fecb0c6",
    "gold-v11-reconciled-4c016154ebbe-carriage-by-air-2018-29-v0": "engine-v11-reconciled-4c016154ebbe-7c5287361c3de3d1",
    "gold-v11-reconciled-4c016154ebbe-carriage-by-air-2018-29-v1": "engine-v11-reconciled-4c016154ebbe-b85b87f48cd5826a",
    "gold-v11-reconciled-4c016154ebbe-civil-aviation-2010-14-v0": "engine-v11-reconciled-4c016154ebbe-3c899d6dad3585c8",
    "gold-v11-reconciled-4c016154ebbe-civil-aviation-2010-14-v1": "engine-v11-reconciled-4c016154ebbe-08303ae9f5fa3082",
    "gold-v11-reconciled-4c016154ebbe-civil-aviation-2010-14-v2": "engine-v11-reconciled-4c016154ebbe-954bf58b4d319712",
    "gold-v11-reconciled-4c016154ebbe-convention-on-the-suppression-of-terrorist-financing-2005-25-v0": "engine-v11-reconciled-4c016154ebbe-d642e2c2ccc797a3",
    "gold-v11-reconciled-4c016154ebbe-convention-on-the-suppression-of-terrorist-financing-2005-25-v1": "engine-v11-reconciled-4c016154ebbe-d5655884e7890ad4",
    "gold-v11-reconciled-4c016154ebbe-convention-on-the-suppression-of-terrorist-financing-2005-25-v2": "engine-v11-reconciled-4c016154ebbe-1c611f654f4d2029",
    "gold-v11-reconciled-4c016154ebbe-defence-services-command-and-staff-college-2008-5-v0": "engine-v11-reconciled-4c016154ebbe-8710db26120aeab6",
    "gold-v11-reconciled-4c016154ebbe-defence-services-command-and-staff-college-2008-5-v1": "engine-v11-reconciled-4c016154ebbe-67a43366df903e38",
    "gold-v11-reconciled-4c016154ebbe-defence-services-command-and-staff-college-2008-5-v2": "engine-v11-reconciled-4c016154ebbe-7c65a1d9b54f8188",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v0": "engine-v11-reconciled-4c016154ebbe-c65bfaf8558fda4a",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v1": "engine-v11-reconciled-4c016154ebbe-65ca8020951f93cd",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v10": "engine-v11-reconciled-4c016154ebbe-4f2fcade80a8b194",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v11": "engine-v11-reconciled-4c016154ebbe-52056495ca84b30f",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v2": "engine-v11-reconciled-4c016154ebbe-ea155b19391a469d",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v3": "engine-v11-reconciled-4c016154ebbe-9c193a8aa321127f",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v4": "engine-v11-reconciled-4c016154ebbe-63dbc7faff9ae200",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v5": "engine-v11-reconciled-4c016154ebbe-6b75e3d7ebe56d2c",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v6": "engine-v11-reconciled-4c016154ebbe-815b132e5eab9c93",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v7": "engine-v11-reconciled-4c016154ebbe-28acaf68eae337aa",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v8": "engine-v11-reconciled-4c016154ebbe-2fab47e1fd8d4922",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13-v9": "engine-v11-reconciled-4c016154ebbe-0484e30bd9beee74",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25-v0": "engine-v11-reconciled-4c016154ebbe-f0e2d86e0272fb15",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25-v1": "engine-v11-reconciled-4c016154ebbe-020691ed319c4e1b",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25-v2": "engine-v11-reconciled-4c016154ebbe-8316b2609f3b2de5",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25-v3": "engine-v11-reconciled-4c016154ebbe-47c9fe736e85ea10",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25-v4": "engine-v11-reconciled-4c016154ebbe-9b5df559fd4f729f",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25-v5": "engine-v11-reconciled-4c016154ebbe-bf58648b0725d7a6",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25-v6": "engine-v11-reconciled-4c016154ebbe-038fce99adb29b52",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11-v0": "engine-v11-reconciled-4c016154ebbe-020691ed319c4e1b",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11-v1": "engine-v11-reconciled-4c016154ebbe-386743ac371b1e75",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11-v2": "engine-v11-reconciled-4c016154ebbe-c65bfaf8558fda4a",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11-v3": "engine-v11-reconciled-4c016154ebbe-afc60811205dc516",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11-v4": "engine-v11-reconciled-4c016154ebbe-d34778de42b67646",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11-v5": "engine-v11-reconciled-4c016154ebbe-726b6e86023ab900",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11-v6": "engine-v11-reconciled-4c016154ebbe-9b5df559fd4f729f",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v0": "engine-v11-reconciled-4c016154ebbe-5470e4359f0e6f4b",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v1": "engine-v11-reconciled-4c016154ebbe-8316b2609f3b2de5",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v2": "engine-v11-reconciled-4c016154ebbe-17d2d1d251a59b67",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v3": "engine-v11-reconciled-4c016154ebbe-fe1ea4997df06af6",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v4": "engine-v11-reconciled-4c016154ebbe-e1f6da4e727adb53",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v5": "engine-v11-reconciled-4c016154ebbe-505c9b943b0a883a",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v6": "engine-v11-reconciled-4c016154ebbe-47c9fe736e85ea10",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5-v7": "engine-v11-reconciled-4c016154ebbe-038fce99adb29b52",
    "gold-v11-reconciled-4c016154ebbe-finance-2006-11-v0": "engine-v11-reconciled-4c016154ebbe-8316b2609f3b2de5",
    "gold-v11-reconciled-4c016154ebbe-finance-2006-11-v1": "engine-v11-reconciled-4c016154ebbe-17d2d1d251a59b67",
    "gold-v11-reconciled-4c016154ebbe-finance-2006-11-v2": "engine-v11-reconciled-4c016154ebbe-47c9fe736e85ea10",
    "gold-v11-reconciled-4c016154ebbe-finance-2012-12-v0": "engine-v11-reconciled-4c016154ebbe-9b5df559fd4f729f",
    "gold-v11-reconciled-4c016154ebbe-finance-2012-12-v1": "engine-v11-reconciled-4c016154ebbe-bf58648b0725d7a6",
    "gold-v11-reconciled-4c016154ebbe-finance-2012-12-v2": "engine-v11-reconciled-4c016154ebbe-038fce99adb29b52",
    "gold-v11-reconciled-4c016154ebbe-finance-2012-12-v3": "engine-v11-reconciled-4c016154ebbe-b2df76a65c2d47ba",
    "gold-v11-reconciled-4c016154ebbe-finance-2018-35-v0": "engine-v11-reconciled-4c016154ebbe-038fce99adb29b52",
    "gold-v11-reconciled-4c016154ebbe-finance-2018-35-v1": "engine-v11-reconciled-4c016154ebbe-af956197361b1759",
    "gold-v11-reconciled-4c016154ebbe-finance-2018-35-v2": "engine-v11-reconciled-4c016154ebbe-d48b9922872a1b5d",
    "gold-v11-reconciled-4c016154ebbe-finance-2018-35-v3": "engine-v11-reconciled-4c016154ebbe-b2df76a65c2d47ba",
    "gold-v11-reconciled-4c016154ebbe-fiscal-management-responsibility-2003-3-v0": "engine-v11-reconciled-4c016154ebbe-6aecc8d3e0a62312",
    "gold-v11-reconciled-4c016154ebbe-fiscal-management-responsibility-2003-3-v1": "engine-v11-reconciled-4c016154ebbe-54d614a9a98dcdde",
    "gold-v11-reconciled-4c016154ebbe-fiscal-management-responsibility-2003-3-v2": "engine-v11-reconciled-4c016154ebbe-2b840f450fcd0d65",
    "gold-v11-reconciled-4c016154ebbe-fiscal-management-responsibility-2003-3-v3": "engine-v11-reconciled-4c016154ebbe-dcda00b6755405a0",
    "gold-v11-reconciled-4c016154ebbe-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v0": "engine-v11-reconciled-4c016154ebbe-8788c9db433b33a7",
    "gold-v11-reconciled-4c016154ebbe-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v1": "engine-v11-reconciled-4c016154ebbe-a46c7fda815b7525",
    "gold-v11-reconciled-4c016154ebbe-information-and-communication-technology-2003-27-v0": "engine-v11-reconciled-4c016154ebbe-565a4f3edcbaec3d",
    "gold-v11-reconciled-4c016154ebbe-information-and-communication-technology-2003-27-v1": "engine-v11-reconciled-4c016154ebbe-fb74b60e8c0dbccd",
    "gold-v11-reconciled-4c016154ebbe-land-restrictions-on-alienation-2014-38-v0": "engine-v11-reconciled-4c016154ebbe-cdc3d36908929a0a",
    "gold-v11-reconciled-4c016154ebbe-land-restrictions-on-alienation-2014-38-v1": "engine-v11-reconciled-4c016154ebbe-2cec4c3f6fea90c0",
    "gold-v11-reconciled-4c016154ebbe-land-restrictions-on-alienation-2014-38-v2": "engine-v11-reconciled-4c016154ebbe-f0bd7e658e651246",
    "gold-v11-reconciled-4c016154ebbe-local-authorities-special-provisions-2007-55-v0": "engine-v11-reconciled-4c016154ebbe-3706ee7993257c74",
    "gold-v11-reconciled-4c016154ebbe-local-authorities-special-provisions-2007-55-v1": "engine-v11-reconciled-4c016154ebbe-cac167d4a6c44875",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v0": "engine-v11-reconciled-4c016154ebbe-b8cdc6d11c2f4445",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v1": "engine-v11-reconciled-4c016154ebbe-b6a34344daa596f1",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v10": "engine-v11-reconciled-4c016154ebbe-0d908137412311ad",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v11": "engine-v11-reconciled-4c016154ebbe-f6238c841da14718",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v2": "engine-v11-reconciled-4c016154ebbe-540977e80ed06d0c",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v3": "engine-v11-reconciled-4c016154ebbe-e5c66a5c29d64edb",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v4": "engine-v11-reconciled-4c016154ebbe-e9df7c60d5594c5d",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v5": "engine-v11-reconciled-4c016154ebbe-43e8c4dc7e4ca1a3",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v6": "engine-v11-reconciled-4c016154ebbe-8dab62f83f4c88f4",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v7": "engine-v11-reconciled-4c016154ebbe-e9c4c4a58ccd7a26",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v8": "engine-v11-reconciled-4c016154ebbe-5604933fce046827",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9-v9": "engine-v11-reconciled-4c016154ebbe-ea252d114e78e690",
    "gold-v11-reconciled-4c016154ebbe-national-enterprise-development-authority-2006-17-v0": "engine-v11-reconciled-4c016154ebbe-738cfe3bea7f3f93",
    "gold-v11-reconciled-4c016154ebbe-national-enterprise-development-authority-2006-17-v1": "engine-v11-reconciled-4c016154ebbe-f64704a9df6e8c40",
    "gold-v11-reconciled-4c016154ebbe-national-minimum-wage-of-workers-2016-3-v0": "engine-v11-reconciled-4c016154ebbe-4ff365ba7583281e",
    "gold-v11-reconciled-4c016154ebbe-national-minimum-wage-of-workers-2016-3-v1": "engine-v11-reconciled-4c016154ebbe-3ad87b14401803d4",
    "gold-v11-reconciled-4c016154ebbe-national-minimum-wage-of-workers-2016-3-v2": "engine-v11-reconciled-4c016154ebbe-3e6289785b5d2ace",
    "gold-v11-reconciled-4c016154ebbe-office-on-missing-persons-2016-14-v0": "engine-v11-reconciled-4c016154ebbe-a7805df36ec051e9",
    "gold-v11-reconciled-4c016154ebbe-office-on-missing-persons-2016-14-v1": "engine-v11-reconciled-4c016154ebbe-52d986f40394d4c4",
    "gold-v11-reconciled-4c016154ebbe-petroleum-products-special-provisions-2002-33-v0": "engine-v11-reconciled-4c016154ebbe-d55bbb7be0bd4556",
    "gold-v11-reconciled-4c016154ebbe-petroleum-products-special-provisions-2002-33-v1": "engine-v11-reconciled-4c016154ebbe-a05af5a077184a5f",
    "gold-v11-reconciled-4c016154ebbe-ports-and-airports-development-levy-2011-18-v0": "engine-v11-reconciled-4c016154ebbe-9f7a25495e980023",
    "gold-v11-reconciled-4c016154ebbe-ports-and-airports-development-levy-2011-18-v1": "engine-v11-reconciled-4c016154ebbe-a3b3e391565b11ad",
    "gold-v11-reconciled-4c016154ebbe-ports-and-airports-development-levy-2011-18-v2": "engine-v11-reconciled-4c016154ebbe-418781f54cdfd082",
    "gold-v11-reconciled-4c016154ebbe-ports-and-airports-development-levy-2011-18-v3": "engine-v11-reconciled-4c016154ebbe-3d8d0dc5d494c5ed",
    "gold-v11-reconciled-4c016154ebbe-ports-and-airports-development-levy-2011-18-v4": "engine-v11-reconciled-4c016154ebbe-616ac68a0a7889f1",
    "gold-v11-reconciled-4c016154ebbe-provincial-councils-transfer-of-stamp-duty-2011-13-v0": "engine-v11-reconciled-4c016154ebbe-4041a8ef167eb084",
    "gold-v11-reconciled-4c016154ebbe-provincial-councils-transfer-of-stamp-duty-2011-13-v1": "engine-v11-reconciled-4c016154ebbe-2c83dc5b0edbf1e8",
    "gold-v11-reconciled-4c016154ebbe-rana-viru-seva-authority-1999-54-v0": "engine-v11-reconciled-4c016154ebbe-48e79ad5c5ebdff5",
    "gold-v11-reconciled-4c016154ebbe-rana-viru-seva-authority-1999-54-v1": "engine-v11-reconciled-4c016154ebbe-c76b30a6c00f7c88",
    "gold-v11-reconciled-4c016154ebbe-rana-viru-seva-authority-1999-54-v2": "engine-v11-reconciled-4c016154ebbe-55de35382c0b1fd0",
    "gold-v11-reconciled-4c016154ebbe-regional-infrastructure-development-levy-2006-51-v0": "engine-v11-reconciled-4c016154ebbe-bbcc48aefa8b7821",
    "gold-v11-reconciled-4c016154ebbe-regional-infrastructure-development-levy-2006-51-v1": "engine-v11-reconciled-4c016154ebbe-f4f8e9bda1d04084",
    "gold-v11-reconciled-4c016154ebbe-regional-infrastructure-development-levy-2006-51-v2": "engine-v11-reconciled-4c016154ebbe-9afda3b1ee76364d",
    "gold-v11-reconciled-4c016154ebbe-resettlement-authority-2007-9-v0": "engine-v11-reconciled-4c016154ebbe-dd75ecf4f046bb27",
    "gold-v11-reconciled-4c016154ebbe-resettlement-authority-2007-9-v1": "engine-v11-reconciled-4c016154ebbe-627abbb7b65581a2",
    "gold-v11-reconciled-4c016154ebbe-social-security-contribution-levy-2022-25-v0": "engine-v11-reconciled-4c016154ebbe-7de4ec283f8bc6bf",
    "gold-v11-reconciled-4c016154ebbe-social-security-contribution-levy-2022-25-v1": "engine-v11-reconciled-4c016154ebbe-bcea2bdb1dab3d9a",
    "gold-v11-reconciled-4c016154ebbe-social-security-contribution-levy-2022-25-v2": "engine-v11-reconciled-4c016154ebbe-177df77d8625abca",
    "gold-v11-reconciled-4c016154ebbe-social-security-contribution-levy-2022-25-v3": "engine-v11-reconciled-4c016154ebbe-1bbd3c02b957c261",
    "gold-v11-reconciled-4c016154ebbe-social-security-contribution-levy-2022-25-v4": "engine-v11-reconciled-4c016154ebbe-d0919c7e899414c7",
    "gold-v11-reconciled-4c016154ebbe-special-commodity-levy-2007-48-v0": "engine-v11-reconciled-4c016154ebbe-82a9bf4bbcf40c3b",
    "gold-v11-reconciled-4c016154ebbe-special-commodity-levy-2007-48-v1": "engine-v11-reconciled-4c016154ebbe-af71306c92055221",
    "gold-v11-reconciled-4c016154ebbe-stamp-duty-special-provisions-2006-12-v0": "engine-v11-reconciled-4c016154ebbe-11defaa0f2254736",
    "gold-v11-reconciled-4c016154ebbe-stamp-duty-special-provisions-2006-12-v1": "engine-v11-reconciled-4c016154ebbe-283e1252ff238d03",
    "gold-v11-reconciled-4c016154ebbe-strategic-development-projects-2008-14-v0": "engine-v11-reconciled-4c016154ebbe-24045391b4ecbcd3",
    "gold-v11-reconciled-4c016154ebbe-strategic-development-projects-2008-14-v1": "engine-v11-reconciled-4c016154ebbe-24e8fa6345a290f4",
    "gold-v11-reconciled-4c016154ebbe-strategic-development-projects-2008-14-v2": "engine-v11-reconciled-4c016154ebbe-340852bc820f0054",
    "gold-v11-reconciled-4c016154ebbe-strategic-development-projects-2008-14-v3": "engine-v11-reconciled-4c016154ebbe-010eaa2e62ff4030",
    "gold-v11-reconciled-4c016154ebbe-sugathadasa-national-sports-complex-authority-1999-17-v0": "engine-v11-reconciled-4c016154ebbe-581d20f6abcc200b",
    "gold-v11-reconciled-4c016154ebbe-sugathadasa-national-sports-complex-authority-1999-17-v1": "engine-v11-reconciled-4c016154ebbe-0a2e020ab1a01498",
    "gold-v11-reconciled-4c016154ebbe-tax-appeals-commission-2011-23-v0": "engine-v11-reconciled-4c016154ebbe-a98839990788e066",
    "gold-v11-reconciled-4c016154ebbe-tax-appeals-commission-2011-23-v1": "engine-v11-reconciled-4c016154ebbe-9c6a86c5e7eeb01c",
    "gold-v11-reconciled-4c016154ebbe-tax-appeals-commission-2011-23-v2": "engine-v11-reconciled-4c016154ebbe-7603f6d11a7efe52",
    "gold-v11-reconciled-4c016154ebbe-telecommunication-levy-2011-21-v0": "engine-v11-reconciled-4c016154ebbe-6617b32ac9f373cc",
    "gold-v11-reconciled-4c016154ebbe-telecommunication-levy-2011-21-v1": "engine-v11-reconciled-4c016154ebbe-15a38c5892d864b3",
    "gold-v11-reconciled-4c016154ebbe-telecommunication-levy-2011-21-v2": "engine-v11-reconciled-4c016154ebbe-e9c25a8a1864ff0f",
    "gold-v11-reconciled-4c016154ebbe-tobacco-tax-1999-8-v0": "engine-v11-reconciled-4c016154ebbe-06838282e43ff13b",
    "gold-v11-reconciled-4c016154ebbe-tobacco-tax-1999-8-v1": "engine-v11-reconciled-4c016154ebbe-a74b43534cfef9da",
    "gold-v11-regional-infrastructure-development-levy-2006-51-v0": "engine-v11-bbcc48aefa8b7821",
    "gold-v11-regional-infrastructure-development-levy-2006-51-v1": "engine-v11-f4f8e9bda1d04084",
    "gold-v11-regional-infrastructure-development-levy-2006-51-v2": "engine-v11-9afda3b1ee76364d",
    "gold-v11-resettlement-authority-2007-9-v0": "engine-v11-dd75ecf4f046bb27",
    "gold-v11-resettlement-authority-2007-9-v1": "engine-v11-627abbb7b65581a2",
    "gold-v11-social-security-contribution-levy-2022-25-v0": "engine-v11-7de4ec283f8bc6bf",
    "gold-v11-social-security-contribution-levy-2022-25-v1": "engine-v11-bcea2bdb1dab3d9a",
    "gold-v11-social-security-contribution-levy-2022-25-v2": "engine-v11-177df77d8625abca",
    "gold-v11-social-security-contribution-levy-2022-25-v3": "engine-v11-1bbd3c02b957c261",
    "gold-v11-social-security-contribution-levy-2022-25-v4": "engine-v11-d0919c7e899414c7",
    "gold-v11-special-commodity-levy-2007-48-v0": "engine-v11-82a9bf4bbcf40c3b",
    "gold-v11-special-commodity-levy-2007-48-v1": "engine-v11-af71306c92055221",
    "gold-v11-stamp-duty-special-provisions-2006-12-v0": "engine-v11-11defaa0f2254736",
    "gold-v11-stamp-duty-special-provisions-2006-12-v1": "engine-v11-283e1252ff238d03",
    "gold-v11-strategic-development-projects-2008-14-v0": "engine-v11-24045391b4ecbcd3",
    "gold-v11-strategic-development-projects-2008-14-v1": "engine-v11-24e8fa6345a290f4",
    "gold-v11-strategic-development-projects-2008-14-v2": "engine-v11-340852bc820f0054",
    "gold-v11-strategic-development-projects-2008-14-v3": "engine-v11-010eaa2e62ff4030",
    "gold-v11-sugathadasa-national-sports-complex-authority-1999-17-v0": "engine-v11-581d20f6abcc200b",
    "gold-v11-sugathadasa-national-sports-complex-authority-1999-17-v1": "engine-v11-0a2e020ab1a01498",
    "gold-v11-tax-appeals-commission-2011-23-v0": "engine-v11-a98839990788e066",
    "gold-v11-tax-appeals-commission-2011-23-v1": "engine-v11-9c6a86c5e7eeb01c",
    "gold-v11-tax-appeals-commission-2011-23-v2": "engine-v11-7603f6d11a7efe52",
    "gold-v11-telecommunication-levy-2011-21-v0": "engine-v11-6617b32ac9f373cc",
    "gold-v11-telecommunication-levy-2011-21-v1": "engine-v11-15a38c5892d864b3",
    "gold-v11-telecommunication-levy-2011-21-v2": "engine-v11-e9c25a8a1864ff0f",
    "gold-v11-tobacco-tax-1999-8-v0": "engine-v11-06838282e43ff13b",
    "gold-v11-tobacco-tax-1999-8-v1": "engine-v11-a74b43534cfef9da",
    "gold-v12-budgetary-relief-allowance-of-workers-2005-36-v0": "engine-v12-749a9d200f6b438d",
    "gold-v12-budgetary-relief-allowance-of-workers-2005-36-v1": "engine-v12-ee4575005a7a4d00",
    "gold-v12-budgetary-relief-allowance-of-workers-2016-4-v0": "engine-v12-10df115f0c104eef",
    "gold-v12-budgetary-relief-allowance-of-workers-2016-4-v1": "engine-v12-e07930075fecb0c6",
    "gold-v12-carriage-by-air-2018-29-v0": "engine-v12-7c5287361c3de3d1",
    "gold-v12-carriage-by-air-2018-29-v1": "engine-v12-b85b87f48cd5826a",
    "gold-v12-civil-aviation-2010-14-v0": "engine-v12-3c899d6dad3585c8",
    "gold-v12-civil-aviation-2010-14-v1": "engine-v12-08303ae9f5fa3082",
    "gold-v12-civil-aviation-2010-14-v2": "engine-v12-954bf58b4d319712",
    "gold-v12-convention-on-the-suppression-of-terrorist-financing-2005-25-v0": "engine-v12-d642e2c2ccc797a3",
    "gold-v12-convention-on-the-suppression-of-terrorist-financing-2005-25-v1": "engine-v12-d5655884e7890ad4",
    "gold-v12-convention-on-the-suppression-of-terrorist-financing-2005-25-v2": "engine-v12-1c611f654f4d2029",
    "gold-v12-defence-services-command-and-staff-college-2008-5-v0": "engine-v12-8710db26120aeab6",
    "gold-v12-defence-services-command-and-staff-college-2008-5-v1": "engine-v12-67a43366df903e38",
    "gold-v12-defence-services-command-and-staff-college-2008-5-v2": "engine-v12-7c65a1d9b54f8188",
    "gold-v12-economic-service-charge-2006-13-v0": "engine-v12-c65bfaf8558fda4a",
    "gold-v12-economic-service-charge-2006-13-v1": "engine-v12-65ca8020951f93cd",
    "gold-v12-economic-service-charge-2006-13-v10": "engine-v12-4f2fcade80a8b194",
    "gold-v12-economic-service-charge-2006-13-v11": "engine-v12-52056495ca84b30f",
    "gold-v12-economic-service-charge-2006-13-v2": "engine-v12-ea155b19391a469d",
    "gold-v12-economic-service-charge-2006-13-v3": "engine-v12-9c193a8aa321127f",
    "gold-v12-economic-service-charge-2006-13-v4": "engine-v12-63dbc7faff9ae200",
    "gold-v12-economic-service-charge-2006-13-v5": "engine-v12-6b75e3d7ebe56d2c",
    "gold-v12-economic-service-charge-2006-13-v6": "engine-v12-815b132e5eab9c93",
    "gold-v12-economic-service-charge-2006-13-v7": "engine-v12-28acaf68eae337aa",
    "gold-v12-economic-service-charge-2006-13-v8": "engine-v12-2fab47e1fd8d4922",
    "gold-v12-economic-service-charge-2006-13-v9": "engine-v12-0484e30bd9beee74",
    "gold-v12-finance-2003-25-v0": "engine-v12-f0e2d86e0272fb15",
    "gold-v12-finance-2003-25-v1": "engine-v12-020691ed319c4e1b",
    "gold-v12-finance-2003-25-v2": "engine-v12-8316b2609f3b2de5",
    "gold-v12-finance-2003-25-v3": "engine-v12-47c9fe736e85ea10",
    "gold-v12-finance-2003-25-v4": "engine-v12-9b5df559fd4f729f",
    "gold-v12-finance-2003-25-v5": "engine-v12-bf58648b0725d7a6",
    "gold-v12-finance-2003-25-v6": "engine-v12-038fce99adb29b52",
    "gold-v12-finance-2004-11-v0": "engine-v12-020691ed319c4e1b",
    "gold-v12-finance-2004-11-v1": "engine-v12-386743ac371b1e75",
    "gold-v12-finance-2004-11-v2": "engine-v12-c65bfaf8558fda4a",
    "gold-v12-finance-2004-11-v3": "engine-v12-afc60811205dc516",
    "gold-v12-finance-2004-11-v4": "engine-v12-d34778de42b67646",
    "gold-v12-finance-2004-11-v5": "engine-v12-726b6e86023ab900",
    "gold-v12-finance-2004-11-v6": "engine-v12-9b5df559fd4f729f",
    "gold-v12-finance-2005-5-v0": "engine-v12-5470e4359f0e6f4b",
    "gold-v12-finance-2005-5-v1": "engine-v12-8316b2609f3b2de5",
    "gold-v12-finance-2005-5-v2": "engine-v12-17d2d1d251a59b67",
    "gold-v12-finance-2005-5-v3": "engine-v12-fe1ea4997df06af6",
    "gold-v12-finance-2005-5-v4": "engine-v12-e1f6da4e727adb53",
    "gold-v12-finance-2005-5-v5": "engine-v12-505c9b943b0a883a",
    "gold-v12-finance-2005-5-v6": "engine-v12-47c9fe736e85ea10",
    "gold-v12-finance-2005-5-v7": "engine-v12-038fce99adb29b52",
    "gold-v12-finance-2006-11-v0": "engine-v12-8316b2609f3b2de5",
    "gold-v12-finance-2006-11-v1": "engine-v12-17d2d1d251a59b67",
    "gold-v12-finance-2006-11-v2": "engine-v12-47c9fe736e85ea10",
    "gold-v12-finance-2012-12-v0": "engine-v12-9b5df559fd4f729f",
    "gold-v12-finance-2012-12-v1": "engine-v12-bf58648b0725d7a6",
    "gold-v12-finance-2012-12-v2": "engine-v12-038fce99adb29b52",
    "gold-v12-finance-2012-12-v3": "engine-v12-b2df76a65c2d47ba",
    "gold-v12-finance-2018-35-v0": "engine-v12-038fce99adb29b52",
    "gold-v12-finance-2018-35-v1": "engine-v12-af956197361b1759",
    "gold-v12-finance-2018-35-v2": "engine-v12-d48b9922872a1b5d",
    "gold-v12-finance-2018-35-v3": "engine-v12-b2df76a65c2d47ba",
    "gold-v12-fiscal-management-responsibility-2003-3-v0": "engine-v12-6aecc8d3e0a62312",
    "gold-v12-fiscal-management-responsibility-2003-3-v1": "engine-v12-54d614a9a98dcdde",
    "gold-v12-fiscal-management-responsibility-2003-3-v2": "engine-v12-2b840f450fcd0d65",
    "gold-v12-fiscal-management-responsibility-2003-3-v3": "engine-v12-dcda00b6755405a0",
    "gold-v12-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v0": "engine-v12-8788c9db433b33a7",
    "gold-v12-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v1": "engine-v12-a46c7fda815b7525",
    "gold-v12-information-and-communication-technology-2003-27-v0": "engine-v12-565a4f3edcbaec3d",
    "gold-v12-information-and-communication-technology-2003-27-v1": "engine-v12-fb74b60e8c0dbccd",
    "gold-v12-inland-revenue-2017-24-v0": "engine-v12-e857f11ec026b424",
    "gold-v12-inland-revenue-2017-24-v1": "engine-v12-47d16ccba8e0c17d",
    "gold-v12-inland-revenue-2017-24-v2": "engine-v12-7da67ada42276e0a",
    "gold-v12-inland-revenue-2017-24-v3": "engine-v12-86f342be653bdd32",
    "gold-v12-inland-revenue-2017-24-v4": "engine-v12-239f61c451410588",
    "gold-v12-inland-revenue-2017-24-v5": "engine-v12-3767ee02072b2fee",
    "gold-v12-land-restrictions-on-alienation-2014-38-v0": "engine-v12-cdc3d36908929a0a",
    "gold-v12-land-restrictions-on-alienation-2014-38-v1": "engine-v12-2cec4c3f6fea90c0",
    "gold-v12-land-restrictions-on-alienation-2014-38-v2": "engine-v12-f0bd7e658e651246",
    "gold-v12-local-authorities-special-provisions-2007-55-v0": "engine-v12-3706ee7993257c74",
    "gold-v12-local-authorities-special-provisions-2007-55-v1": "engine-v12-cac167d4a6c44875",
    "gold-v12-nation-building-tax-2009-9-v0": "engine-v12-b8cdc6d11c2f4445",
    "gold-v12-nation-building-tax-2009-9-v1": "engine-v12-b6a34344daa596f1",
    "gold-v12-nation-building-tax-2009-9-v10": "engine-v12-0d908137412311ad",
    "gold-v12-nation-building-tax-2009-9-v11": "engine-v12-f6238c841da14718",
    "gold-v12-nation-building-tax-2009-9-v2": "engine-v12-540977e80ed06d0c",
    "gold-v12-nation-building-tax-2009-9-v3": "engine-v12-e5c66a5c29d64edb",
    "gold-v12-nation-building-tax-2009-9-v4": "engine-v12-e9df7c60d5594c5d",
    "gold-v12-nation-building-tax-2009-9-v5": "engine-v12-43e8c4dc7e4ca1a3",
    "gold-v12-nation-building-tax-2009-9-v6": "engine-v12-8dab62f83f4c88f4",
    "gold-v12-nation-building-tax-2009-9-v7": "engine-v12-e9c4c4a58ccd7a26",
    "gold-v12-nation-building-tax-2009-9-v8": "engine-v12-5604933fce046827",
    "gold-v12-nation-building-tax-2009-9-v9": "engine-v12-ea252d114e78e690",
    "gold-v12-national-enterprise-development-authority-2006-17-v0": "engine-v12-738cfe3bea7f3f93",
    "gold-v12-national-enterprise-development-authority-2006-17-v1": "engine-v12-f64704a9df6e8c40",
    "gold-v12-national-minimum-wage-of-workers-2016-3-v0": "engine-v12-4ff365ba7583281e",
    "gold-v12-national-minimum-wage-of-workers-2016-3-v1": "engine-v12-3ad87b14401803d4",
    "gold-v12-national-minimum-wage-of-workers-2016-3-v2": "engine-v12-3e6289785b5d2ace",
    "gold-v12-office-on-missing-persons-2016-14-v0": "engine-v12-a7805df36ec051e9",
    "gold-v12-office-on-missing-persons-2016-14-v1": "engine-v12-52d986f40394d4c4",
    "gold-v12-petroleum-products-special-provisions-2002-33-v0": "engine-v12-d55bbb7be0bd4556",
    "gold-v12-petroleum-products-special-provisions-2002-33-v1": "engine-v12-a05af5a077184a5f",
    "gold-v12-ports-and-airports-development-levy-2011-18-v0": "engine-v12-9f7a25495e980023",
    "gold-v12-ports-and-airports-development-levy-2011-18-v1": "engine-v12-a3b3e391565b11ad",
    "gold-v12-ports-and-airports-development-levy-2011-18-v2": "engine-v12-418781f54cdfd082",
    "gold-v12-ports-and-airports-development-levy-2011-18-v3": "engine-v12-3d8d0dc5d494c5ed",
    "gold-v12-ports-and-airports-development-levy-2011-18-v4": "engine-v12-616ac68a0a7889f1",
    "gold-v12-provincial-councils-transfer-of-stamp-duty-2011-13-v0": "engine-v12-4041a8ef167eb084",
    "gold-v12-provincial-councils-transfer-of-stamp-duty-2011-13-v1": "engine-v12-2c83dc5b0edbf1e8",
    "gold-v12-rana-viru-seva-authority-1999-54-v0": "engine-v12-48e79ad5c5ebdff5",
    "gold-v12-rana-viru-seva-authority-1999-54-v1": "engine-v12-c76b30a6c00f7c88",
    "gold-v12-rana-viru-seva-authority-1999-54-v2": "engine-v12-55de35382c0b1fd0",
    "gold-v12-regional-infrastructure-development-levy-2006-51-v0": "engine-v12-bbcc48aefa8b7821",
    "gold-v12-regional-infrastructure-development-levy-2006-51-v1": "engine-v12-f4f8e9bda1d04084",
    "gold-v12-regional-infrastructure-development-levy-2006-51-v2": "engine-v12-9afda3b1ee76364d",
    "gold-v12-resettlement-authority-2007-9-v0": "engine-v12-dd75ecf4f046bb27",
    "gold-v12-resettlement-authority-2007-9-v1": "engine-v12-627abbb7b65581a2",
    "gold-v12-social-security-contribution-levy-2022-25-v0": "engine-v12-7de4ec283f8bc6bf",
    "gold-v12-social-security-contribution-levy-2022-25-v1": "engine-v12-bcea2bdb1dab3d9a",
    "gold-v12-social-security-contribution-levy-2022-25-v2": "engine-v12-177df77d8625abca",
    "gold-v12-social-security-contribution-levy-2022-25-v3": "engine-v12-1bbd3c02b957c261",
    "gold-v12-social-security-contribution-levy-2022-25-v4": "engine-v12-d0919c7e899414c7",
    "gold-v12-special-commodity-levy-2007-48-v0": "engine-v12-82a9bf4bbcf40c3b",
    "gold-v12-special-commodity-levy-2007-48-v1": "engine-v12-af71306c92055221",
    "gold-v12-stamp-duty-special-provisions-2006-12-v0": "engine-v12-11defaa0f2254736",
    "gold-v12-stamp-duty-special-provisions-2006-12-v1": "engine-v12-283e1252ff238d03",
    "gold-v12-strategic-development-projects-2008-14-v0": "engine-v12-24045391b4ecbcd3",
    "gold-v12-strategic-development-projects-2008-14-v1": "engine-v12-24e8fa6345a290f4",
    "gold-v12-strategic-development-projects-2008-14-v2": "engine-v12-340852bc820f0054",
    "gold-v12-strategic-development-projects-2008-14-v3": "engine-v12-010eaa2e62ff4030",
    "gold-v12-sugathadasa-national-sports-complex-authority-1999-17-v0": "engine-v12-581d20f6abcc200b",
    "gold-v12-sugathadasa-national-sports-complex-authority-1999-17-v1": "engine-v12-0a2e020ab1a01498",
    "gold-v12-tax-appeals-commission-2011-23-v0": "engine-v12-a98839990788e066",
    "gold-v12-tax-appeals-commission-2011-23-v1": "engine-v12-9c6a86c5e7eeb01c",
    "gold-v12-tax-appeals-commission-2011-23-v2": "engine-v12-7603f6d11a7efe52",
    "gold-v12-telecommunication-levy-2011-21-v0": "engine-v12-6617b32ac9f373cc",
    "gold-v12-telecommunication-levy-2011-21-v1": "engine-v12-15a38c5892d864b3",
    "gold-v12-telecommunication-levy-2011-21-v2": "engine-v12-e9c25a8a1864ff0f",
    "gold-v12-tobacco-tax-1999-8-v0": "engine-v12-06838282e43ff13b",
    "gold-v12-tobacco-tax-1999-8-v1": "engine-v12-a74b43534cfef9da",
    "gold-v12-ui-final-ab345900-budgetary-relief-allowance-of-workers-2005-36-v0": "engine-v12-ui-final-ab345900-749a9d200f6b438d",
    "gold-v12-ui-final-ab345900-budgetary-relief-allowance-of-workers-2005-36-v1": "engine-v12-ui-final-ab345900-ee4575005a7a4d00",
    "gold-v12-ui-final-ab345900-budgetary-relief-allowance-of-workers-2016-4-v0": "engine-v12-ui-final-ab345900-10df115f0c104eef",
    "gold-v12-ui-final-ab345900-budgetary-relief-allowance-of-workers-2016-4-v1": "engine-v12-ui-final-ab345900-e07930075fecb0c6",
    "gold-v12-ui-final-ab345900-carriage-by-air-2018-29-v0": "engine-v12-ui-final-ab345900-7c5287361c3de3d1",
    "gold-v12-ui-final-ab345900-carriage-by-air-2018-29-v1": "engine-v12-ui-final-ab345900-b85b87f48cd5826a",
    "gold-v12-ui-final-ab345900-civil-aviation-2010-14-v0": "engine-v12-ui-final-ab345900-3c899d6dad3585c8",
    "gold-v12-ui-final-ab345900-civil-aviation-2010-14-v1": "engine-v12-ui-final-ab345900-08303ae9f5fa3082",
    "gold-v12-ui-final-ab345900-civil-aviation-2010-14-v2": "engine-v12-ui-final-ab345900-954bf58b4d319712",
    "gold-v12-ui-final-ab345900-convention-on-the-suppression-of-terrorist-financing-2005-25-v0": "engine-v12-ui-final-ab345900-d642e2c2ccc797a3",
    "gold-v12-ui-final-ab345900-convention-on-the-suppression-of-terrorist-financing-2005-25-v1": "engine-v12-ui-final-ab345900-d5655884e7890ad4",
    "gold-v12-ui-final-ab345900-convention-on-the-suppression-of-terrorist-financing-2005-25-v2": "engine-v12-ui-final-ab345900-1c611f654f4d2029",
    "gold-v12-ui-final-ab345900-defence-services-command-and-staff-college-2008-5-v0": "engine-v12-ui-final-ab345900-8710db26120aeab6",
    "gold-v12-ui-final-ab345900-defence-services-command-and-staff-college-2008-5-v1": "engine-v12-ui-final-ab345900-67a43366df903e38",
    "gold-v12-ui-final-ab345900-defence-services-command-and-staff-college-2008-5-v2": "engine-v12-ui-final-ab345900-7c65a1d9b54f8188",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v0": "engine-v12-ui-final-ab345900-c65bfaf8558fda4a",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v1": "engine-v12-ui-final-ab345900-65ca8020951f93cd",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v10": "engine-v12-ui-final-ab345900-4f2fcade80a8b194",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v11": "engine-v12-ui-final-ab345900-52056495ca84b30f",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v2": "engine-v12-ui-final-ab345900-ea155b19391a469d",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v3": "engine-v12-ui-final-ab345900-9c193a8aa321127f",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v4": "engine-v12-ui-final-ab345900-63dbc7faff9ae200",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v5": "engine-v12-ui-final-ab345900-6b75e3d7ebe56d2c",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v6": "engine-v12-ui-final-ab345900-815b132e5eab9c93",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v7": "engine-v12-ui-final-ab345900-28acaf68eae337aa",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v8": "engine-v12-ui-final-ab345900-2fab47e1fd8d4922",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13-v9": "engine-v12-ui-final-ab345900-0484e30bd9beee74",
    "gold-v12-ui-final-ab345900-finance-2003-25-v0": "engine-v12-ui-final-ab345900-f0e2d86e0272fb15",
    "gold-v12-ui-final-ab345900-finance-2003-25-v1": "engine-v12-ui-final-ab345900-020691ed319c4e1b",
    "gold-v12-ui-final-ab345900-finance-2003-25-v2": "engine-v12-ui-final-ab345900-8316b2609f3b2de5",
    "gold-v12-ui-final-ab345900-finance-2003-25-v3": "engine-v12-ui-final-ab345900-47c9fe736e85ea10",
    "gold-v12-ui-final-ab345900-finance-2003-25-v4": "engine-v12-ui-final-ab345900-9b5df559fd4f729f",
    "gold-v12-ui-final-ab345900-finance-2003-25-v5": "engine-v12-ui-final-ab345900-bf58648b0725d7a6",
    "gold-v12-ui-final-ab345900-finance-2003-25-v6": "engine-v12-ui-final-ab345900-038fce99adb29b52",
    "gold-v12-ui-final-ab345900-finance-2004-11-v0": "engine-v12-ui-final-ab345900-020691ed319c4e1b",
    "gold-v12-ui-final-ab345900-finance-2004-11-v1": "engine-v12-ui-final-ab345900-386743ac371b1e75",
    "gold-v12-ui-final-ab345900-finance-2004-11-v2": "engine-v12-ui-final-ab345900-c65bfaf8558fda4a",
    "gold-v12-ui-final-ab345900-finance-2004-11-v3": "engine-v12-ui-final-ab345900-afc60811205dc516",
    "gold-v12-ui-final-ab345900-finance-2004-11-v4": "engine-v12-ui-final-ab345900-d34778de42b67646",
    "gold-v12-ui-final-ab345900-finance-2004-11-v5": "engine-v12-ui-final-ab345900-726b6e86023ab900",
    "gold-v12-ui-final-ab345900-finance-2004-11-v6": "engine-v12-ui-final-ab345900-9b5df559fd4f729f",
    "gold-v12-ui-final-ab345900-finance-2005-5-v0": "engine-v12-ui-final-ab345900-5470e4359f0e6f4b",
    "gold-v12-ui-final-ab345900-finance-2005-5-v1": "engine-v12-ui-final-ab345900-8316b2609f3b2de5",
    "gold-v12-ui-final-ab345900-finance-2005-5-v2": "engine-v12-ui-final-ab345900-17d2d1d251a59b67",
    "gold-v12-ui-final-ab345900-finance-2005-5-v3": "engine-v12-ui-final-ab345900-fe1ea4997df06af6",
    "gold-v12-ui-final-ab345900-finance-2005-5-v4": "engine-v12-ui-final-ab345900-e1f6da4e727adb53",
    "gold-v12-ui-final-ab345900-finance-2005-5-v5": "engine-v12-ui-final-ab345900-505c9b943b0a883a",
    "gold-v12-ui-final-ab345900-finance-2005-5-v6": "engine-v12-ui-final-ab345900-47c9fe736e85ea10",
    "gold-v12-ui-final-ab345900-finance-2005-5-v7": "engine-v12-ui-final-ab345900-038fce99adb29b52",
    "gold-v12-ui-final-ab345900-finance-2006-11-v0": "engine-v12-ui-final-ab345900-8316b2609f3b2de5",
    "gold-v12-ui-final-ab345900-finance-2006-11-v1": "engine-v12-ui-final-ab345900-17d2d1d251a59b67",
    "gold-v12-ui-final-ab345900-finance-2006-11-v2": "engine-v12-ui-final-ab345900-47c9fe736e85ea10",
    "gold-v12-ui-final-ab345900-finance-2012-12-v0": "engine-v12-ui-final-ab345900-9b5df559fd4f729f",
    "gold-v12-ui-final-ab345900-finance-2012-12-v1": "engine-v12-ui-final-ab345900-bf58648b0725d7a6",
    "gold-v12-ui-final-ab345900-finance-2012-12-v2": "engine-v12-ui-final-ab345900-038fce99adb29b52",
    "gold-v12-ui-final-ab345900-finance-2012-12-v3": "engine-v12-ui-final-ab345900-b2df76a65c2d47ba",
    "gold-v12-ui-final-ab345900-finance-2018-35-v0": "engine-v12-ui-final-ab345900-038fce99adb29b52",
    "gold-v12-ui-final-ab345900-finance-2018-35-v1": "engine-v12-ui-final-ab345900-af956197361b1759",
    "gold-v12-ui-final-ab345900-finance-2018-35-v2": "engine-v12-ui-final-ab345900-d48b9922872a1b5d",
    "gold-v12-ui-final-ab345900-finance-2018-35-v3": "engine-v12-ui-final-ab345900-b2df76a65c2d47ba",
    "gold-v12-ui-final-ab345900-fiscal-management-responsibility-2003-3-v0": "engine-v12-ui-final-ab345900-6aecc8d3e0a62312",
    "gold-v12-ui-final-ab345900-fiscal-management-responsibility-2003-3-v1": "engine-v12-ui-final-ab345900-54d614a9a98dcdde",
    "gold-v12-ui-final-ab345900-fiscal-management-responsibility-2003-3-v2": "engine-v12-ui-final-ab345900-2b840f450fcd0d65",
    "gold-v12-ui-final-ab345900-fiscal-management-responsibility-2003-3-v3": "engine-v12-ui-final-ab345900-dcda00b6755405a0",
    "gold-v12-ui-final-ab345900-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v0": "engine-v12-ui-final-ab345900-8788c9db433b33a7",
    "gold-v12-ui-final-ab345900-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v1": "engine-v12-ui-final-ab345900-a46c7fda815b7525",
    "gold-v12-ui-final-ab345900-information-and-communication-technology-2003-27-v0": "engine-v12-ui-final-ab345900-565a4f3edcbaec3d",
    "gold-v12-ui-final-ab345900-information-and-communication-technology-2003-27-v1": "engine-v12-ui-final-ab345900-fb74b60e8c0dbccd",
    "gold-v12-ui-final-ab345900-inland-revenue-2017-24-v0": "engine-v12-ui-final-ab345900-e857f11ec026b424",
    "gold-v12-ui-final-ab345900-inland-revenue-2017-24-v1": "engine-v12-ui-final-ab345900-47d16ccba8e0c17d",
    "gold-v12-ui-final-ab345900-inland-revenue-2017-24-v2": "engine-v12-ui-final-ab345900-7da67ada42276e0a",
    "gold-v12-ui-final-ab345900-inland-revenue-2017-24-v3": "engine-v12-ui-final-ab345900-86f342be653bdd32",
    "gold-v12-ui-final-ab345900-inland-revenue-2017-24-v4": "engine-v12-ui-final-ab345900-239f61c451410588",
    "gold-v12-ui-final-ab345900-inland-revenue-2017-24-v5": "engine-v12-ui-final-ab345900-3767ee02072b2fee",
    "gold-v12-ui-final-ab345900-land-restrictions-on-alienation-2014-38-v0": "engine-v12-ui-final-ab345900-cdc3d36908929a0a",
    "gold-v12-ui-final-ab345900-land-restrictions-on-alienation-2014-38-v1": "engine-v12-ui-final-ab345900-2cec4c3f6fea90c0",
    "gold-v12-ui-final-ab345900-land-restrictions-on-alienation-2014-38-v2": "engine-v12-ui-final-ab345900-f0bd7e658e651246",
    "gold-v12-ui-final-ab345900-local-authorities-special-provisions-2007-55-v0": "engine-v12-ui-final-ab345900-3706ee7993257c74",
    "gold-v12-ui-final-ab345900-local-authorities-special-provisions-2007-55-v1": "engine-v12-ui-final-ab345900-cac167d4a6c44875",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v0": "engine-v12-ui-final-ab345900-b8cdc6d11c2f4445",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v1": "engine-v12-ui-final-ab345900-b6a34344daa596f1",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v10": "engine-v12-ui-final-ab345900-0d908137412311ad",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v11": "engine-v12-ui-final-ab345900-f6238c841da14718",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v2": "engine-v12-ui-final-ab345900-540977e80ed06d0c",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v3": "engine-v12-ui-final-ab345900-e5c66a5c29d64edb",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v4": "engine-v12-ui-final-ab345900-e9df7c60d5594c5d",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v5": "engine-v12-ui-final-ab345900-43e8c4dc7e4ca1a3",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v6": "engine-v12-ui-final-ab345900-8dab62f83f4c88f4",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v7": "engine-v12-ui-final-ab345900-e9c4c4a58ccd7a26",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v8": "engine-v12-ui-final-ab345900-5604933fce046827",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9-v9": "engine-v12-ui-final-ab345900-ea252d114e78e690",
    "gold-v12-ui-final-ab345900-national-enterprise-development-authority-2006-17-v0": "engine-v12-ui-final-ab345900-738cfe3bea7f3f93",
    "gold-v12-ui-final-ab345900-national-enterprise-development-authority-2006-17-v1": "engine-v12-ui-final-ab345900-f64704a9df6e8c40",
    "gold-v12-ui-final-ab345900-national-minimum-wage-of-workers-2016-3-v0": "engine-v12-ui-final-ab345900-4ff365ba7583281e",
    "gold-v12-ui-final-ab345900-national-minimum-wage-of-workers-2016-3-v1": "engine-v12-ui-final-ab345900-3ad87b14401803d4",
    "gold-v12-ui-final-ab345900-national-minimum-wage-of-workers-2016-3-v2": "engine-v12-ui-final-ab345900-3e6289785b5d2ace",
    "gold-v12-ui-final-ab345900-office-on-missing-persons-2016-14-v0": "engine-v12-ui-final-ab345900-a7805df36ec051e9",
    "gold-v12-ui-final-ab345900-office-on-missing-persons-2016-14-v1": "engine-v12-ui-final-ab345900-52d986f40394d4c4",
    "gold-v12-ui-final-ab345900-petroleum-products-special-provisions-2002-33-v0": "engine-v12-ui-final-ab345900-d55bbb7be0bd4556",
    "gold-v12-ui-final-ab345900-petroleum-products-special-provisions-2002-33-v1": "engine-v12-ui-final-ab345900-a05af5a077184a5f",
    "gold-v12-ui-final-ab345900-ports-and-airports-development-levy-2011-18-v0": "engine-v12-ui-final-ab345900-9f7a25495e980023",
    "gold-v12-ui-final-ab345900-ports-and-airports-development-levy-2011-18-v1": "engine-v12-ui-final-ab345900-a3b3e391565b11ad",
    "gold-v12-ui-final-ab345900-ports-and-airports-development-levy-2011-18-v2": "engine-v12-ui-final-ab345900-418781f54cdfd082",
    "gold-v12-ui-final-ab345900-ports-and-airports-development-levy-2011-18-v3": "engine-v12-ui-final-ab345900-3d8d0dc5d494c5ed",
    "gold-v12-ui-final-ab345900-ports-and-airports-development-levy-2011-18-v4": "engine-v12-ui-final-ab345900-616ac68a0a7889f1",
    "gold-v12-ui-final-ab345900-provincial-councils-transfer-of-stamp-duty-2011-13-v0": "engine-v12-ui-final-ab345900-4041a8ef167eb084",
    "gold-v12-ui-final-ab345900-provincial-councils-transfer-of-stamp-duty-2011-13-v1": "engine-v12-ui-final-ab345900-2c83dc5b0edbf1e8",
    "gold-v12-ui-final-ab345900-rana-viru-seva-authority-1999-54-v0": "engine-v12-ui-final-ab345900-48e79ad5c5ebdff5",
    "gold-v12-ui-final-ab345900-rana-viru-seva-authority-1999-54-v1": "engine-v12-ui-final-ab345900-c76b30a6c00f7c88",
    "gold-v12-ui-final-ab345900-rana-viru-seva-authority-1999-54-v2": "engine-v12-ui-final-ab345900-55de35382c0b1fd0",
    "gold-v12-ui-final-ab345900-regional-infrastructure-development-levy-2006-51-v0": "engine-v12-ui-final-ab345900-bbcc48aefa8b7821",
    "gold-v12-ui-final-ab345900-regional-infrastructure-development-levy-2006-51-v1": "engine-v12-ui-final-ab345900-f4f8e9bda1d04084",
    "gold-v12-ui-final-ab345900-regional-infrastructure-development-levy-2006-51-v2": "engine-v12-ui-final-ab345900-9afda3b1ee76364d",
    "gold-v12-ui-final-ab345900-resettlement-authority-2007-9-v0": "engine-v12-ui-final-ab345900-dd75ecf4f046bb27",
    "gold-v12-ui-final-ab345900-resettlement-authority-2007-9-v1": "engine-v12-ui-final-ab345900-627abbb7b65581a2",
    "gold-v12-ui-final-ab345900-social-security-contribution-levy-2022-25-v0": "engine-v12-ui-final-ab345900-7de4ec283f8bc6bf",
    "gold-v12-ui-final-ab345900-social-security-contribution-levy-2022-25-v1": "engine-v12-ui-final-ab345900-bcea2bdb1dab3d9a",
    "gold-v12-ui-final-ab345900-social-security-contribution-levy-2022-25-v2": "engine-v12-ui-final-ab345900-177df77d8625abca",
    "gold-v12-ui-final-ab345900-social-security-contribution-levy-2022-25-v3": "engine-v12-ui-final-ab345900-1bbd3c02b957c261",
    "gold-v12-ui-final-ab345900-social-security-contribution-levy-2022-25-v4": "engine-v12-ui-final-ab345900-d0919c7e899414c7",
    "gold-v12-ui-final-ab345900-special-commodity-levy-2007-48-v0": "engine-v12-ui-final-ab345900-82a9bf4bbcf40c3b",
    "gold-v12-ui-final-ab345900-special-commodity-levy-2007-48-v1": "engine-v12-ui-final-ab345900-af71306c92055221",
    "gold-v12-ui-final-ab345900-stamp-duty-special-provisions-2006-12-v0": "engine-v12-ui-final-ab345900-11defaa0f2254736",
    "gold-v12-ui-final-ab345900-stamp-duty-special-provisions-2006-12-v1": "engine-v12-ui-final-ab345900-283e1252ff238d03",
    "gold-v12-ui-final-ab345900-strategic-development-projects-2008-14-v0": "engine-v12-ui-final-ab345900-24045391b4ecbcd3",
    "gold-v12-ui-final-ab345900-strategic-development-projects-2008-14-v1": "engine-v12-ui-final-ab345900-24e8fa6345a290f4",
    "gold-v12-ui-final-ab345900-strategic-development-projects-2008-14-v2": "engine-v12-ui-final-ab345900-340852bc820f0054",
    "gold-v12-ui-final-ab345900-strategic-development-projects-2008-14-v3": "engine-v12-ui-final-ab345900-010eaa2e62ff4030",
    "gold-v12-ui-final-ab345900-sugathadasa-national-sports-complex-authority-1999-17-v0": "engine-v12-ui-final-ab345900-581d20f6abcc200b",
    "gold-v12-ui-final-ab345900-sugathadasa-national-sports-complex-authority-1999-17-v1": "engine-v12-ui-final-ab345900-0a2e020ab1a01498",
    "gold-v12-ui-final-ab345900-tax-appeals-commission-2011-23-v0": "engine-v12-ui-final-ab345900-a98839990788e066",
    "gold-v12-ui-final-ab345900-tax-appeals-commission-2011-23-v1": "engine-v12-ui-final-ab345900-9c6a86c5e7eeb01c",
    "gold-v12-ui-final-ab345900-tax-appeals-commission-2011-23-v2": "engine-v12-ui-final-ab345900-7603f6d11a7efe52",
    "gold-v12-ui-final-ab345900-telecommunication-levy-2011-21-v0": "engine-v12-ui-final-ab345900-6617b32ac9f373cc",
    "gold-v12-ui-final-ab345900-telecommunication-levy-2011-21-v1": "engine-v12-ui-final-ab345900-15a38c5892d864b3",
    "gold-v12-ui-final-ab345900-telecommunication-levy-2011-21-v2": "engine-v12-ui-final-ab345900-e9c25a8a1864ff0f",
    "gold-v12-ui-final-ab345900-tobacco-tax-1999-8-v0": "engine-v12-ui-final-ab345900-06838282e43ff13b",
    "gold-v12-ui-final-ab345900-tobacco-tax-1999-8-v1": "engine-v12-ui-final-ab345900-a74b43534cfef9da",
    "gold-v5-budgetary-relief-allowance-of-workers-2016-4-v0": "engine-v5-10df115f0c104eef",
    "gold-v5-budgetary-relief-allowance-of-workers-2016-4-v1": "engine-v5-e07930075fecb0c6",
    "gold-v5-carriage-by-air-2018-29-v0": "engine-v5-7c5287361c3de3d1",
    "gold-v5-carriage-by-air-2018-29-v1": "engine-v5-b85b87f48cd5826a",
    "gold-v5-civil-aviation-2010-14-v0": "engine-v5-3c899d6dad3585c8",
    "gold-v5-civil-aviation-2010-14-v1": "engine-v5-08303ae9f5fa3082",
    "gold-v5-civil-aviation-2010-14-v2": "engine-v5-954bf58b4d319712",
    "gold-v5-finance-2018-35-v0": "engine-v5-038fce99adb29b52",
    "gold-v5-finance-2018-35-v1": "engine-v5-af956197361b1759",
    "gold-v5-finance-2018-35-v2": "engine-v5-d48b9922872a1b5d",
    "gold-v5-finance-2018-35-v3": "engine-v5-b2df76a65c2d47ba",
    "gold-v5-land-restrictions-on-alienation-2014-38-v0": "engine-v5-cdc3d36908929a0a",
    "gold-v5-land-restrictions-on-alienation-2014-38-v1": "engine-v5-2cec4c3f6fea90c0",
    "gold-v5-land-restrictions-on-alienation-2014-38-v2": "engine-v5-f0bd7e658e651246",
    "gold-v5-nation-building-tax-2009-9-v0": "engine-v5-b8cdc6d11c2f4445",
    "gold-v5-nation-building-tax-2009-9-v1": "engine-v5-b6a34344daa596f1",
    "gold-v5-nation-building-tax-2009-9-v10": "engine-v5-0d908137412311ad",
    "gold-v5-nation-building-tax-2009-9-v11": "engine-v5-f6238c841da14718",
    "gold-v5-nation-building-tax-2009-9-v2": "engine-v5-540977e80ed06d0c",
    "gold-v5-nation-building-tax-2009-9-v3": "engine-v5-e5c66a5c29d64edb",
    "gold-v5-nation-building-tax-2009-9-v4": "engine-v5-e9df7c60d5594c5d",
    "gold-v5-nation-building-tax-2009-9-v5": "engine-v5-43e8c4dc7e4ca1a3",
    "gold-v5-nation-building-tax-2009-9-v6": "engine-v5-8dab62f83f4c88f4",
    "gold-v5-nation-building-tax-2009-9-v7": "engine-v5-e9c4c4a58ccd7a26",
    "gold-v5-nation-building-tax-2009-9-v8": "engine-v5-5604933fce046827",
    "gold-v5-nation-building-tax-2009-9-v9": "engine-v5-ea252d114e78e690",
    "gold-v5-office-on-missing-persons-2016-14-v0": "engine-v5-a7805df36ec051e9",
    "gold-v5-office-on-missing-persons-2016-14-v1": "engine-v5-52d986f40394d4c4",
    "gold-v5-ports-and-airports-development-levy-2011-18-v0": "engine-v5-9f7a25495e980023",
    "gold-v5-ports-and-airports-development-levy-2011-18-v1": "engine-v5-a3b3e391565b11ad",
    "gold-v5-ports-and-airports-development-levy-2011-18-v2": "engine-v5-418781f54cdfd082",
    "gold-v5-ports-and-airports-development-levy-2011-18-v3": "engine-v5-3d8d0dc5d494c5ed",
    "gold-v5-ports-and-airports-development-levy-2011-18-v4": "engine-v5-616ac68a0a7889f1",
    "gold-v5-provincial-councils-transfer-of-stamp-duty-2011-13-v0": "engine-v5-4041a8ef167eb084",
    "gold-v5-provincial-councils-transfer-of-stamp-duty-2011-13-v1": "engine-v5-2c83dc5b0edbf1e8",
    "gold-v5-tax-appeals-commission-2011-23-v0": "engine-v5-a98839990788e066",
    "gold-v5-tax-appeals-commission-2011-23-v1": "engine-v5-9c6a86c5e7eeb01c",
    "gold-v5-tax-appeals-commission-2011-23-v2": "engine-v5-7603f6d11a7efe52",
    "gold-v5-telecommunication-levy-2011-21-v0": "engine-v5-6617b32ac9f373cc",
    "gold-v5-telecommunication-levy-2011-21-v1": "engine-v5-15a38c5892d864b3",
    "gold-v5-telecommunication-levy-2011-21-v2": "engine-v5-e9c25a8a1864ff0f",
    "gold-v9-budgetary-relief-allowance-of-workers-2005-36-v0": "engine-v9-749a9d200f6b438d",
    "gold-v9-budgetary-relief-allowance-of-workers-2005-36-v1": "engine-v9-ee4575005a7a4d00",
    "gold-v9-carriage-by-air-2018-29-v0": "engine-v9-7c5287361c3de3d1",
    "gold-v9-carriage-by-air-2018-29-v1": "engine-v9-b85b87f48cd5826a",
    "gold-v9-civil-aviation-2010-14-v0": "engine-v9-3c899d6dad3585c8",
    "gold-v9-civil-aviation-2010-14-v1": "engine-v9-08303ae9f5fa3082",
    "gold-v9-civil-aviation-2010-14-v2": "engine-v9-954bf58b4d319712",
    "gold-v9-finance-2018-35-v0": "engine-v9-038fce99adb29b52",
    "gold-v9-finance-2018-35-v1": "engine-v9-af956197361b1759",
    "gold-v9-finance-2018-35-v2": "engine-v9-d48b9922872a1b5d",
    "gold-v9-finance-2018-35-v3": "engine-v9-b2df76a65c2d47ba",
    "gold-v9-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v0": "engine-v9-8788c9db433b33a7",
    "gold-v9-grant-of-citizenship-to-persons-of-indian-origin-2003-35-v1": "engine-v9-a46c7fda815b7525",
    "gold-v9-information-and-communication-technology-2003-27-v0": "engine-v9-565a4f3edcbaec3d",
    "gold-v9-information-and-communication-technology-2003-27-v1": "engine-v9-fb74b60e8c0dbccd",
    "gold-v9-land-restrictions-on-alienation-2014-38-v0": "engine-v9-cdc3d36908929a0a",
    "gold-v9-land-restrictions-on-alienation-2014-38-v1": "engine-v9-2cec4c3f6fea90c0",
    "gold-v9-land-restrictions-on-alienation-2014-38-v2": "engine-v9-f0bd7e658e651246",
    "gold-v9-local-authorities-special-provisions-2007-55-v0": "engine-v9-3706ee7993257c74",
    "gold-v9-local-authorities-special-provisions-2007-55-v1": "engine-v9-cac167d4a6c44875",
    "gold-v9-national-enterprise-development-authority-2006-17-v0": "engine-v9-738cfe3bea7f3f93",
    "gold-v9-national-enterprise-development-authority-2006-17-v1": "engine-v9-f64704a9df6e8c40",
    "gold-v9-national-minimum-wage-of-workers-2016-3-v0": "engine-v9-4ff365ba7583281e",
    "gold-v9-national-minimum-wage-of-workers-2016-3-v1": "engine-v9-3ad87b14401803d4",
    "gold-v9-national-minimum-wage-of-workers-2016-3-v2": "engine-v9-3e6289785b5d2ace",
    "gold-v9-office-on-missing-persons-2016-14-v0": "engine-v9-a7805df36ec051e9",
    "gold-v9-office-on-missing-persons-2016-14-v1": "engine-v9-52d986f40394d4c4",
    "gold-v9-petroleum-products-special-provisions-2002-33-v0": "engine-v9-d55bbb7be0bd4556",
    "gold-v9-petroleum-products-special-provisions-2002-33-v1": "engine-v9-a05af5a077184a5f",
    "gold-v9-ports-and-airports-development-levy-2011-18-v0": "engine-v9-9f7a25495e980023",
    "gold-v9-ports-and-airports-development-levy-2011-18-v1": "engine-v9-a3b3e391565b11ad",
    "gold-v9-ports-and-airports-development-levy-2011-18-v2": "engine-v9-418781f54cdfd082",
    "gold-v9-ports-and-airports-development-levy-2011-18-v3": "engine-v9-3d8d0dc5d494c5ed",
    "gold-v9-ports-and-airports-development-levy-2011-18-v4": "engine-v9-616ac68a0a7889f1",
    "gold-v9-provincial-councils-transfer-of-stamp-duty-2011-13-v0": "engine-v9-4041a8ef167eb084",
    "gold-v9-provincial-councils-transfer-of-stamp-duty-2011-13-v1": "engine-v9-2c83dc5b0edbf1e8",
    "gold-v9-rana-viru-seva-authority-1999-54-v0": "engine-v9-48e79ad5c5ebdff5",
    "gold-v9-rana-viru-seva-authority-1999-54-v1": "engine-v9-c76b30a6c00f7c88",
    "gold-v9-rana-viru-seva-authority-1999-54-v2": "engine-v9-55de35382c0b1fd0",
    "gold-v9-regional-infrastructure-development-levy-2006-51-v0": "engine-v9-bbcc48aefa8b7821",
    "gold-v9-regional-infrastructure-development-levy-2006-51-v1": "engine-v9-f4f8e9bda1d04084",
    "gold-v9-regional-infrastructure-development-levy-2006-51-v2": "engine-v9-9afda3b1ee76364d",
    "gold-v9-resettlement-authority-2007-9-v0": "engine-v9-dd75ecf4f046bb27",
    "gold-v9-resettlement-authority-2007-9-v1": "engine-v9-627abbb7b65581a2",
    "gold-v9-social-security-contribution-levy-2022-25-v0": "engine-v9-7de4ec283f8bc6bf",
    "gold-v9-social-security-contribution-levy-2022-25-v1": "engine-v9-bcea2bdb1dab3d9a",
    "gold-v9-social-security-contribution-levy-2022-25-v2": "engine-v9-177df77d8625abca",
    "gold-v9-social-security-contribution-levy-2022-25-v3": "engine-v9-1bbd3c02b957c261",
    "gold-v9-social-security-contribution-levy-2022-25-v4": "engine-v9-d0919c7e899414c7",
    "gold-v9-special-commodity-levy-2007-48-v0": "engine-v9-82a9bf4bbcf40c3b",
    "gold-v9-special-commodity-levy-2007-48-v1": "engine-v9-af71306c92055221",
    "gold-v9-stamp-duty-special-provisions-2006-12-v0": "engine-v9-11defaa0f2254736",
    "gold-v9-stamp-duty-special-provisions-2006-12-v1": "engine-v9-283e1252ff238d03",
    "gold-v9-strategic-development-projects-2008-14-v0": "engine-v9-24045391b4ecbcd3",
    "gold-v9-strategic-development-projects-2008-14-v1": "engine-v9-24e8fa6345a290f4",
    "gold-v9-strategic-development-projects-2008-14-v2": "engine-v9-340852bc820f0054",
    "gold-v9-strategic-development-projects-2008-14-v3": "engine-v9-010eaa2e62ff4030",
    "gold-v9-sugathadasa-national-sports-complex-authority-1999-17-v0": "engine-v9-581d20f6abcc200b",
    "gold-v9-sugathadasa-national-sports-complex-authority-1999-17-v1": "engine-v9-0a2e020ab1a01498",
    "gold-v9-tax-appeals-commission-2011-23-v0": "engine-v9-a98839990788e066",
    "gold-v9-tax-appeals-commission-2011-23-v1": "engine-v9-9c6a86c5e7eeb01c",
    "gold-v9-tax-appeals-commission-2011-23-v2": "engine-v9-7603f6d11a7efe52",
    "gold-v9-telecommunication-levy-2011-21-v0": "engine-v9-6617b32ac9f373cc",
    "gold-v9-telecommunication-levy-2011-21-v1": "engine-v9-15a38c5892d864b3",
    "gold-v9-telecommunication-levy-2011-21-v2": "engine-v9-e9c25a8a1864ff0f"
  },
  "works": {
    "gold-v10-budgetary-relief-allowance-of-workers-2005-36": "engine-v10-749a9d200f6b438d",
    "gold-v10-budgetary-relief-allowance-of-workers-2016-4": "engine-v10-10df115f0c104eef",
    "gold-v10-carriage-by-air-2018-29": "engine-v10-7c5287361c3de3d1",
    "gold-v10-civil-aviation-2010-14": "engine-v10-3c899d6dad3585c8",
    "gold-v10-convention-on-the-suppression-of-terrorist-financing-2005-25": "engine-v10-d642e2c2ccc797a3",
    "gold-v10-defence-services-command-and-staff-college-2008-5": "engine-v10-8710db26120aeab6",
    "gold-v10-finance-2012-12": "engine-v10-9b5df559fd4f729f",
    "gold-v10-finance-2018-35": "engine-v10-038fce99adb29b52",
    "gold-v10-grant-of-citizenship-to-persons-of-indian-origin-2003-35": "engine-v10-8788c9db433b33a7",
    "gold-v10-information-and-communication-technology-2003-27": "engine-v10-565a4f3edcbaec3d",
    "gold-v10-land-restrictions-on-alienation-2014-38": "engine-v10-cdc3d36908929a0a",
    "gold-v10-local-authorities-special-provisions-2007-55": "engine-v10-3706ee7993257c74",
    "gold-v10-nation-building-tax-2009-9": "engine-v10-b8cdc6d11c2f4445",
    "gold-v10-national-enterprise-development-authority-2006-17": "engine-v10-738cfe3bea7f3f93",
    "gold-v10-national-minimum-wage-of-workers-2016-3": "engine-v10-4ff365ba7583281e",
    "gold-v10-office-on-missing-persons-2016-14": "engine-v10-a7805df36ec051e9",
    "gold-v10-petroleum-products-special-provisions-2002-33": "engine-v10-d55bbb7be0bd4556",
    "gold-v10-ports-and-airports-development-levy-2011-18": "engine-v10-9f7a25495e980023",
    "gold-v10-provincial-councils-transfer-of-stamp-duty-2011-13": "engine-v10-4041a8ef167eb084",
    "gold-v10-rana-viru-seva-authority-1999-54": "engine-v10-48e79ad5c5ebdff5",
    "gold-v10-regional-infrastructure-development-levy-2006-51": "engine-v10-bbcc48aefa8b7821",
    "gold-v10-resettlement-authority-2007-9": "engine-v10-dd75ecf4f046bb27",
    "gold-v10-social-security-contribution-levy-2022-25": "engine-v10-7de4ec283f8bc6bf",
    "gold-v10-special-commodity-levy-2007-48": "engine-v10-82a9bf4bbcf40c3b",
    "gold-v10-stamp-duty-special-provisions-2006-12": "engine-v10-11defaa0f2254736",
    "gold-v10-strategic-development-projects-2008-14": "engine-v10-24045391b4ecbcd3",
    "gold-v10-sugathadasa-national-sports-complex-authority-1999-17": "engine-v10-581d20f6abcc200b",
    "gold-v10-tax-appeals-commission-2011-23": "engine-v10-a98839990788e066",
    "gold-v10-telecommunication-levy-2011-21": "engine-v10-6617b32ac9f373cc",
    "gold-v11-budgetary-relief-allowance-of-workers-2005-36": "engine-v11-749a9d200f6b438d",
    "gold-v11-budgetary-relief-allowance-of-workers-2016-4": "engine-v11-10df115f0c104eef",
    "gold-v11-carriage-by-air-2018-29": "engine-v11-7c5287361c3de3d1",
    "gold-v11-civil-aviation-2010-14": "engine-v11-3c899d6dad3585c8",
    "gold-v11-convention-on-the-suppression-of-terrorist-financing-2005-25": "engine-v11-d642e2c2ccc797a3",
    "gold-v11-defence-services-command-and-staff-college-2008-5": "engine-v11-8710db26120aeab6",
    "gold-v11-economic-service-charge-2006-13": "engine-v11-c65bfaf8558fda4a",
    "gold-v11-finance-2003-25": "engine-v11-f0e2d86e0272fb15",
    "gold-v11-finance-2004-11": "engine-v11-020691ed319c4e1b",
    "gold-v11-finance-2005-5": "engine-v11-5470e4359f0e6f4b",
    "gold-v11-finance-2006-11": "engine-v11-8316b2609f3b2de5",
    "gold-v11-finance-2012-12": "engine-v11-9b5df559fd4f729f",
    "gold-v11-finance-2018-35": "engine-v11-038fce99adb29b52",
    "gold-v11-fiscal-management-responsibility-2003-3": "engine-v11-6aecc8d3e0a62312",
    "gold-v11-grant-of-citizenship-to-persons-of-indian-origin-2003-35": "engine-v11-8788c9db433b33a7",
    "gold-v11-information-and-communication-technology-2003-27": "engine-v11-565a4f3edcbaec3d",
    "gold-v11-land-restrictions-on-alienation-2014-38": "engine-v11-cdc3d36908929a0a",
    "gold-v11-local-authorities-special-provisions-2007-55": "engine-v11-3706ee7993257c74",
    "gold-v11-nation-building-tax-2009-9": "engine-v11-b8cdc6d11c2f4445",
    "gold-v11-national-enterprise-development-authority-2006-17": "engine-v11-738cfe3bea7f3f93",
    "gold-v11-national-minimum-wage-of-workers-2016-3": "engine-v11-4ff365ba7583281e",
    "gold-v11-office-on-missing-persons-2016-14": "engine-v11-a7805df36ec051e9",
    "gold-v11-petroleum-products-special-provisions-2002-33": "engine-v11-d55bbb7be0bd4556",
    "gold-v11-ports-and-airports-development-levy-2011-18": "engine-v11-9f7a25495e980023",
    "gold-v11-provincial-councils-transfer-of-stamp-duty-2011-13": "engine-v11-4041a8ef167eb084",
    "gold-v11-rana-viru-seva-authority-1999-54": "engine-v11-48e79ad5c5ebdff5",
    "gold-v11-reconciled-4c016154ebbe-budgetary-relief-allowance-of-workers-2005-36": "engine-v11-reconciled-4c016154ebbe-749a9d200f6b438d",
    "gold-v11-reconciled-4c016154ebbe-budgetary-relief-allowance-of-workers-2016-4": "engine-v11-reconciled-4c016154ebbe-10df115f0c104eef",
    "gold-v11-reconciled-4c016154ebbe-carriage-by-air-2018-29": "engine-v11-reconciled-4c016154ebbe-7c5287361c3de3d1",
    "gold-v11-reconciled-4c016154ebbe-civil-aviation-2010-14": "engine-v11-reconciled-4c016154ebbe-3c899d6dad3585c8",
    "gold-v11-reconciled-4c016154ebbe-convention-on-the-suppression-of-terrorist-financing-2005-25": "engine-v11-reconciled-4c016154ebbe-d642e2c2ccc797a3",
    "gold-v11-reconciled-4c016154ebbe-defence-services-command-and-staff-college-2008-5": "engine-v11-reconciled-4c016154ebbe-8710db26120aeab6",
    "gold-v11-reconciled-4c016154ebbe-economic-service-charge-2006-13": "engine-v11-reconciled-4c016154ebbe-c65bfaf8558fda4a",
    "gold-v11-reconciled-4c016154ebbe-finance-2003-25": "engine-v11-reconciled-4c016154ebbe-f0e2d86e0272fb15",
    "gold-v11-reconciled-4c016154ebbe-finance-2004-11": "engine-v11-reconciled-4c016154ebbe-020691ed319c4e1b",
    "gold-v11-reconciled-4c016154ebbe-finance-2005-5": "engine-v11-reconciled-4c016154ebbe-5470e4359f0e6f4b",
    "gold-v11-reconciled-4c016154ebbe-finance-2006-11": "engine-v11-reconciled-4c016154ebbe-8316b2609f3b2de5",
    "gold-v11-reconciled-4c016154ebbe-finance-2012-12": "engine-v11-reconciled-4c016154ebbe-9b5df559fd4f729f",
    "gold-v11-reconciled-4c016154ebbe-finance-2018-35": "engine-v11-reconciled-4c016154ebbe-038fce99adb29b52",
    "gold-v11-reconciled-4c016154ebbe-fiscal-management-responsibility-2003-3": "engine-v11-reconciled-4c016154ebbe-6aecc8d3e0a62312",
    "gold-v11-reconciled-4c016154ebbe-grant-of-citizenship-to-persons-of-indian-origin-2003-35": "engine-v11-reconciled-4c016154ebbe-8788c9db433b33a7",
    "gold-v11-reconciled-4c016154ebbe-information-and-communication-technology-2003-27": "engine-v11-reconciled-4c016154ebbe-565a4f3edcbaec3d",
    "gold-v11-reconciled-4c016154ebbe-land-restrictions-on-alienation-2014-38": "engine-v11-reconciled-4c016154ebbe-cdc3d36908929a0a",
    "gold-v11-reconciled-4c016154ebbe-local-authorities-special-provisions-2007-55": "engine-v11-reconciled-4c016154ebbe-3706ee7993257c74",
    "gold-v11-reconciled-4c016154ebbe-nation-building-tax-2009-9": "engine-v11-reconciled-4c016154ebbe-b8cdc6d11c2f4445",
    "gold-v11-reconciled-4c016154ebbe-national-enterprise-development-authority-2006-17": "engine-v11-reconciled-4c016154ebbe-738cfe3bea7f3f93",
    "gold-v11-reconciled-4c016154ebbe-national-minimum-wage-of-workers-2016-3": "engine-v11-reconciled-4c016154ebbe-4ff365ba7583281e",
    "gold-v11-reconciled-4c016154ebbe-office-on-missing-persons-2016-14": "engine-v11-reconciled-4c016154ebbe-a7805df36ec051e9",
    "gold-v11-reconciled-4c016154ebbe-petroleum-products-special-provisions-2002-33": "engine-v11-reconciled-4c016154ebbe-d55bbb7be0bd4556",
    "gold-v11-reconciled-4c016154ebbe-ports-and-airports-development-levy-2011-18": "engine-v11-reconciled-4c016154ebbe-9f7a25495e980023",
    "gold-v11-reconciled-4c016154ebbe-provincial-councils-transfer-of-stamp-duty-2011-13": "engine-v11-reconciled-4c016154ebbe-4041a8ef167eb084",
    "gold-v11-reconciled-4c016154ebbe-rana-viru-seva-authority-1999-54": "engine-v11-reconciled-4c016154ebbe-48e79ad5c5ebdff5",
    "gold-v11-reconciled-4c016154ebbe-regional-infrastructure-development-levy-2006-51": "engine-v11-reconciled-4c016154ebbe-bbcc48aefa8b7821",
    "gold-v11-reconciled-4c016154ebbe-resettlement-authority-2007-9": "engine-v11-reconciled-4c016154ebbe-dd75ecf4f046bb27",
    "gold-v11-reconciled-4c016154ebbe-social-security-contribution-levy-2022-25": "engine-v11-reconciled-4c016154ebbe-7de4ec283f8bc6bf",
    "gold-v11-reconciled-4c016154ebbe-special-commodity-levy-2007-48": "engine-v11-reconciled-4c016154ebbe-82a9bf4bbcf40c3b",
    "gold-v11-reconciled-4c016154ebbe-stamp-duty-special-provisions-2006-12": "engine-v11-reconciled-4c016154ebbe-11defaa0f2254736",
    "gold-v11-reconciled-4c016154ebbe-strategic-development-projects-2008-14": "engine-v11-reconciled-4c016154ebbe-24045391b4ecbcd3",
    "gold-v11-reconciled-4c016154ebbe-sugathadasa-national-sports-complex-authority-1999-17": "engine-v11-reconciled-4c016154ebbe-581d20f6abcc200b",
    "gold-v11-reconciled-4c016154ebbe-tax-appeals-commission-2011-23": "engine-v11-reconciled-4c016154ebbe-a98839990788e066",
    "gold-v11-reconciled-4c016154ebbe-telecommunication-levy-2011-21": "engine-v11-reconciled-4c016154ebbe-6617b32ac9f373cc",
    "gold-v11-reconciled-4c016154ebbe-tobacco-tax-1999-8": "engine-v11-reconciled-4c016154ebbe-06838282e43ff13b",
    "gold-v11-regional-infrastructure-development-levy-2006-51": "engine-v11-bbcc48aefa8b7821",
    "gold-v11-resettlement-authority-2007-9": "engine-v11-dd75ecf4f046bb27",
    "gold-v11-social-security-contribution-levy-2022-25": "engine-v11-7de4ec283f8bc6bf",
    "gold-v11-special-commodity-levy-2007-48": "engine-v11-82a9bf4bbcf40c3b",
    "gold-v11-stamp-duty-special-provisions-2006-12": "engine-v11-11defaa0f2254736",
    "gold-v11-strategic-development-projects-2008-14": "engine-v11-24045391b4ecbcd3",
    "gold-v11-sugathadasa-national-sports-complex-authority-1999-17": "engine-v11-581d20f6abcc200b",
    "gold-v11-tax-appeals-commission-2011-23": "engine-v11-a98839990788e066",
    "gold-v11-telecommunication-levy-2011-21": "engine-v11-6617b32ac9f373cc",
    "gold-v11-tobacco-tax-1999-8": "engine-v11-06838282e43ff13b",
    "gold-v12-budgetary-relief-allowance-of-workers-2005-36": "engine-v12-749a9d200f6b438d",
    "gold-v12-budgetary-relief-allowance-of-workers-2016-4": "engine-v12-10df115f0c104eef",
    "gold-v12-carriage-by-air-2018-29": "engine-v12-7c5287361c3de3d1",
    "gold-v12-civil-aviation-2010-14": "engine-v12-3c899d6dad3585c8",
    "gold-v12-convention-on-the-suppression-of-terrorist-financing-2005-25": "engine-v12-d642e2c2ccc797a3",
    "gold-v12-defence-services-command-and-staff-college-2008-5": "engine-v12-8710db26120aeab6",
    "gold-v12-economic-service-charge-2006-13": "engine-v12-c65bfaf8558fda4a",
    "gold-v12-finance-2003-25": "engine-v12-f0e2d86e0272fb15",
    "gold-v12-finance-2004-11": "engine-v12-020691ed319c4e1b",
    "gold-v12-finance-2005-5": "engine-v12-5470e4359f0e6f4b",
    "gold-v12-finance-2006-11": "engine-v12-8316b2609f3b2de5",
    "gold-v12-finance-2012-12": "engine-v12-9b5df559fd4f729f",
    "gold-v12-finance-2018-35": "engine-v12-038fce99adb29b52",
    "gold-v12-fiscal-management-responsibility-2003-3": "engine-v12-6aecc8d3e0a62312",
    "gold-v12-grant-of-citizenship-to-persons-of-indian-origin-2003-35": "engine-v12-8788c9db433b33a7",
    "gold-v12-information-and-communication-technology-2003-27": "engine-v12-565a4f3edcbaec3d",
    "gold-v12-inland-revenue-2017-24": "engine-v12-e857f11ec026b424",
    "gold-v12-land-restrictions-on-alienation-2014-38": "engine-v12-cdc3d36908929a0a",
    "gold-v12-local-authorities-special-provisions-2007-55": "engine-v12-3706ee7993257c74",
    "gold-v12-nation-building-tax-2009-9": "engine-v12-b8cdc6d11c2f4445",
    "gold-v12-national-enterprise-development-authority-2006-17": "engine-v12-738cfe3bea7f3f93",
    "gold-v12-national-minimum-wage-of-workers-2016-3": "engine-v12-4ff365ba7583281e",
    "gold-v12-office-on-missing-persons-2016-14": "engine-v12-a7805df36ec051e9",
    "gold-v12-petroleum-products-special-provisions-2002-33": "engine-v12-d55bbb7be0bd4556",
    "gold-v12-ports-and-airports-development-levy-2011-18": "engine-v12-9f7a25495e980023",
    "gold-v12-provincial-councils-transfer-of-stamp-duty-2011-13": "engine-v12-4041a8ef167eb084",
    "gold-v12-rana-viru-seva-authority-1999-54": "engine-v12-48e79ad5c5ebdff5",
    "gold-v12-regional-infrastructure-development-levy-2006-51": "engine-v12-bbcc48aefa8b7821",
    "gold-v12-resettlement-authority-2007-9": "engine-v12-dd75ecf4f046bb27",
    "gold-v12-social-security-contribution-levy-2022-25": "engine-v12-7de4ec283f8bc6bf",
    "gold-v12-special-commodity-levy-2007-48": "engine-v12-82a9bf4bbcf40c3b",
    "gold-v12-stamp-duty-special-provisions-2006-12": "engine-v12-11defaa0f2254736",
    "gold-v12-strategic-development-projects-2008-14": "engine-v12-24045391b4ecbcd3",
    "gold-v12-sugathadasa-national-sports-complex-authority-1999-17": "engine-v12-581d20f6abcc200b",
    "gold-v12-tax-appeals-commission-2011-23": "engine-v12-a98839990788e066",
    "gold-v12-telecommunication-levy-2011-21": "engine-v12-6617b32ac9f373cc",
    "gold-v12-tobacco-tax-1999-8": "engine-v12-06838282e43ff13b",
    "gold-v12-ui-final-ab345900-budgetary-relief-allowance-of-workers-2005-36": "engine-v12-ui-final-ab345900-749a9d200f6b438d",
    "gold-v12-ui-final-ab345900-budgetary-relief-allowance-of-workers-2016-4": "engine-v12-ui-final-ab345900-10df115f0c104eef",
    "gold-v12-ui-final-ab345900-carriage-by-air-2018-29": "engine-v12-ui-final-ab345900-7c5287361c3de3d1",
    "gold-v12-ui-final-ab345900-civil-aviation-2010-14": "engine-v12-ui-final-ab345900-3c899d6dad3585c8",
    "gold-v12-ui-final-ab345900-convention-on-the-suppression-of-terrorist-financing-2005-25": "engine-v12-ui-final-ab345900-d642e2c2ccc797a3",
    "gold-v12-ui-final-ab345900-defence-services-command-and-staff-college-2008-5": "engine-v12-ui-final-ab345900-8710db26120aeab6",
    "gold-v12-ui-final-ab345900-economic-service-charge-2006-13": "engine-v12-ui-final-ab345900-c65bfaf8558fda4a",
    "gold-v12-ui-final-ab345900-finance-2003-25": "engine-v12-ui-final-ab345900-f0e2d86e0272fb15",
    "gold-v12-ui-final-ab345900-finance-2004-11": "engine-v12-ui-final-ab345900-020691ed319c4e1b",
    "gold-v12-ui-final-ab345900-finance-2005-5": "engine-v12-ui-final-ab345900-5470e4359f0e6f4b",
    "gold-v12-ui-final-ab345900-finance-2006-11": "engine-v12-ui-final-ab345900-8316b2609f3b2de5",
    "gold-v12-ui-final-ab345900-finance-2012-12": "engine-v12-ui-final-ab345900-9b5df559fd4f729f",
    "gold-v12-ui-final-ab345900-finance-2018-35": "engine-v12-ui-final-ab345900-038fce99adb29b52",
    "gold-v12-ui-final-ab345900-fiscal-management-responsibility-2003-3": "engine-v12-ui-final-ab345900-6aecc8d3e0a62312",
    "gold-v12-ui-final-ab345900-grant-of-citizenship-to-persons-of-indian-origin-2003-35": "engine-v12-ui-final-ab345900-8788c9db433b33a7",
    "gold-v12-ui-final-ab345900-information-and-communication-technology-2003-27": "engine-v12-ui-final-ab345900-565a4f3edcbaec3d",
    "gold-v12-ui-final-ab345900-inland-revenue-2017-24": "engine-v12-ui-final-ab345900-e857f11ec026b424",
    "gold-v12-ui-final-ab345900-land-restrictions-on-alienation-2014-38": "engine-v12-ui-final-ab345900-cdc3d36908929a0a",
    "gold-v12-ui-final-ab345900-local-authorities-special-provisions-2007-55": "engine-v12-ui-final-ab345900-3706ee7993257c74",
    "gold-v12-ui-final-ab345900-nation-building-tax-2009-9": "engine-v12-ui-final-ab345900-b8cdc6d11c2f4445",
    "gold-v12-ui-final-ab345900-national-enterprise-development-authority-2006-17": "engine-v12-ui-final-ab345900-738cfe3bea7f3f93",
    "gold-v12-ui-final-ab345900-national-minimum-wage-of-workers-2016-3": "engine-v12-ui-final-ab345900-4ff365ba7583281e",
    "gold-v12-ui-final-ab345900-office-on-missing-persons-2016-14": "engine-v12-ui-final-ab345900-a7805df36ec051e9",
    "gold-v12-ui-final-ab345900-petroleum-products-special-provisions-2002-33": "engine-v12-ui-final-ab345900-d55bbb7be0bd4556",
    "gold-v12-ui-final-ab345900-ports-and-airports-development-levy-2011-18": "engine-v12-ui-final-ab345900-9f7a25495e980023",
    "gold-v12-ui-final-ab345900-provincial-councils-transfer-of-stamp-duty-2011-13": "engine-v12-ui-final-ab345900-4041a8ef167eb084",
    "gold-v12-ui-final-ab345900-rana-viru-seva-authority-1999-54": "engine-v12-ui-final-ab345900-48e79ad5c5ebdff5",
    "gold-v12-ui-final-ab345900-regional-infrastructure-development-levy-2006-51": "engine-v12-ui-final-ab345900-bbcc48aefa8b7821",
    "gold-v12-ui-final-ab345900-resettlement-authority-2007-9": "engine-v12-ui-final-ab345900-dd75ecf4f046bb27",
    "gold-v12-ui-final-ab345900-social-security-contribution-levy-2022-25": "engine-v12-ui-final-ab345900-7de4ec283f8bc6bf",
    "gold-v12-ui-final-ab345900-special-commodity-levy-2007-48": "engine-v12-ui-final-ab345900-82a9bf4bbcf40c3b",
    "gold-v12-ui-final-ab345900-stamp-duty-special-provisions-2006-12": "engine-v12-ui-final-ab345900-11defaa0f2254736",
    "gold-v12-ui-final-ab345900-strategic-development-projects-2008-14": "engine-v12-ui-final-ab345900-24045391b4ecbcd3",
    "gold-v12-ui-final-ab345900-sugathadasa-national-sports-complex-authority-1999-17": "engine-v12-ui-final-ab345900-581d20f6abcc200b",
    "gold-v12-ui-final-ab345900-tax-appeals-commission-2011-23": "engine-v12-ui-final-ab345900-a98839990788e066",
    "gold-v12-ui-final-ab345900-telecommunication-levy-2011-21": "engine-v12-ui-final-ab345900-6617b32ac9f373cc",
    "gold-v12-ui-final-ab345900-tobacco-tax-1999-8": "engine-v12-ui-final-ab345900-06838282e43ff13b",
    "gold-v5-budgetary-relief-allowance-of-workers-2016-4": "engine-v5-10df115f0c104eef",
    "gold-v5-carriage-by-air-2018-29": "engine-v5-7c5287361c3de3d1",
    "gold-v5-civil-aviation-2010-14": "engine-v5-3c899d6dad3585c8",
    "gold-v5-finance-2018-35": "engine-v5-038fce99adb29b52",
    "gold-v5-land-restrictions-on-alienation-2014-38": "engine-v5-cdc3d36908929a0a",
    "gold-v5-nation-building-tax-2009-9": "engine-v5-b8cdc6d11c2f4445",
    "gold-v5-office-on-missing-persons-2016-14": "engine-v5-a7805df36ec051e9",
    "gold-v5-ports-and-airports-development-levy-2011-18": "engine-v5-9f7a25495e980023",
    "gold-v5-provincial-councils-transfer-of-stamp-duty-2011-13": "engine-v5-4041a8ef167eb084",
    "gold-v5-tax-appeals-commission-2011-23": "engine-v5-a98839990788e066",
    "gold-v5-telecommunication-levy-2011-21": "engine-v5-6617b32ac9f373cc",
    "gold-v9-budgetary-relief-allowance-of-workers-2005-36": "engine-v9-749a9d200f6b438d",
    "gold-v9-carriage-by-air-2018-29": "engine-v9-7c5287361c3de3d1",
    "gold-v9-civil-aviation-2010-14": "engine-v9-3c899d6dad3585c8",
    "gold-v9-finance-2018-35": "engine-v9-038fce99adb29b52",
    "gold-v9-grant-of-citizenship-to-persons-of-indian-origin-2003-35": "engine-v9-8788c9db433b33a7",
    "gold-v9-information-and-communication-technology-2003-27": "engine-v9-565a4f3edcbaec3d",
    "gold-v9-land-restrictions-on-alienation-2014-38": "engine-v9-cdc3d36908929a0a",
    "gold-v9-local-authorities-special-provisions-2007-55": "engine-v9-3706ee7993257c74",
    "gold-v9-national-enterprise-development-authority-2006-17": "engine-v9-738cfe3bea7f3f93",
    "gold-v9-national-minimum-wage-of-workers-2016-3": "engine-v9-4ff365ba7583281e",
    "gold-v9-office-on-missing-persons-2016-14": "engine-v9-a7805df36ec051e9",
    "gold-v9-petroleum-products-special-provisions-2002-33": "engine-v9-d55bbb7be0bd4556",
    "gold-v9-ports-and-airports-development-levy-2011-18": "engine-v9-9f7a25495e980023",
    "gold-v9-provincial-councils-transfer-of-stamp-duty-2011-13": "engine-v9-4041a8ef167eb084",
    "gold-v9-rana-viru-seva-authority-1999-54": "engine-v9-48e79ad5c5ebdff5",
    "gold-v9-regional-infrastructure-development-levy-2006-51": "engine-v9-bbcc48aefa8b7821",
    "gold-v9-resettlement-authority-2007-9": "engine-v9-dd75ecf4f046bb27",
    "gold-v9-social-security-contribution-levy-2022-25": "engine-v9-7de4ec283f8bc6bf",
    "gold-v9-special-commodity-levy-2007-48": "engine-v9-82a9bf4bbcf40c3b",
    "gold-v9-stamp-duty-special-provisions-2006-12": "engine-v9-11defaa0f2254736",
    "gold-v9-strategic-development-projects-2008-14": "engine-v9-24045391b4ecbcd3",
    "gold-v9-sugathadasa-national-sports-complex-authority-1999-17": "engine-v9-581d20f6abcc200b",
    "gold-v9-tax-appeals-commission-2011-23": "engine-v9-a98839990788e066",
    "gold-v9-telecommunication-levy-2011-21": "engine-v9-6617b32ac9f373cc"
  }
}
